/* English catalog.
 * Note on domain terms: the UI frame is translated, but Norwegian statutory names stay as proper nouns (Altinn, Skatteetaten, A-melding, SAF-T) because
 * they name a real form or authority the user has to recognise. Generic
 * accounting concepts (VAT return, income statement, trial balance) are
 * translated. When SE/DK reporting surfaces land, the same rule applies to
 * Skatteverket / TastSelv.
 * A key missing here falls back to the Norwegian catalog, so a partial
 * translation degrades to Norwegian rather than to a raw key.
 */
window.PlummeI18n.register('en', {
  // ----------------------------------------------------------------- common
  'common.save': 'Save changes',
  'common.saving': 'Saving...',
  'common.delete': 'Delete',
  'common.cancel': 'Cancel',
  'common.hoursMinutes': '{h}h {m}m',
  'account.view': 'Account view',
  'account.relevant': 'Relevant',
  'account.all': 'All',
  'account.favorites': 'Favourites',
  'account.addFavorite': 'Add to favourites',
  'account.removeFavorite': 'Remove from favourites',
  'account.searchHint': 'Search by name, number or e.g. 5x',
  'common.confirmTitle': 'Are you sure?',
  'common.continue': 'Continue',
  'common.working': 'Working...',
  'common.close': 'Close',
  'common.on': 'On',
  'common.off': 'Off',
  'common.active': 'Active',
  'common.yes': 'Yes',
  'common.no': 'No',
  'month.short.1': 'Jan',
  'month.short.2': 'Feb',
  'month.short.3': 'Mar',
  'month.short.4': 'Apr',
  'month.short.5': 'May',
  'month.short.6': 'Jun',
  'month.short.7': 'Jul',
  'month.short.8': 'Aug',
  'month.short.9': 'Sep',
  'month.short.10': 'Oct',
  'month.short.11': 'Nov',
  'month.short.12': 'Dec',
  // ------------------------------------------------ shared UI primitives (ui.jsx)
  'ui.summary.title': 'Summary',
  'ui.summary.exVat': 'Total excl. VAT',
  'ui.summary.vat': 'VAT',
  'ui.summary.total': 'Total',
  'ui.more': 'More',
  'ui.filter': 'Filter',
  'ui.filterReset': 'Clear filter',
  'ui.filterChoices': 'Filters',
  'ui.period': 'Period',
  'ui.from': 'From',
  'ui.to': 'To',
  'ui.fromMonth': 'From month',
  'ui.toMonth': 'To month',
  'ui.fromDate': 'From date',
  'ui.toDate': 'To date',
  'ui.today': 'Today',
  'ui.wholeYearTitle': 'All of {year}',
  'ui.quick.wholeYear': 'Whole year',
  'ui.quick.ytd': 'Year to date',
  'ui.quick.thisTerm': 'This term',
  'ui.quick.lastYear': 'Last year',
  'ui.term': 'Term {n}',
  'ui.amountSearch': 'Search by amount',
  'ui.amountFrom': 'Amount from',
  'ui.amountTo': 'Amount to',

  // ------------------------------- shared list building blocks (list-shared.jsx)
  'list.search': 'Search',
  'list.copy': 'Copy',
  'list.copied': 'Copied: {text}',
  'list.export': 'Export',
  'list.download': 'Download',
  'list.downloaded': '{label} downloaded',
  'list.nothingToExport': 'No rows to export',
  'list.downloading': 'Downloading {label} …',
  'list.upload': 'Upload',
  'list.add': 'Add',
  'list.archiveTitle': 'Move to archive?',
  'list.archiveConfirm': 'Move to archive',
  'list.deleteTitle': 'Delete?',
  'list.delete': 'Delete',
  'list.archiveBody': 'Move {name} to the archive? The customer is hidden from active customer lists, but invoices, payments and history are kept. This cannot be undone from here.',
  'list.deleteBody': 'Are you sure you want to delete {name}? This cannot be undone.',

  'crm.prospect': 'Prospect',
  'crm.active': 'Active',
  'crm.quoteSent': 'Quote sent',
  'crm.pause': 'On hold',

  'badge.paid': 'Settled',
  'badge.active': 'Active',
  'badge.sent': 'Sent',
  'badge.draft': 'Draft',
  'badge.created': 'Not sent',
  'badge.overdue': 'Overdue',
  'badge.credited': 'Credited',
  'badge.inactive': 'Inactive',
  'badge.ok': 'Filed',
  'badge.no': 'Not filed',
  'badge.soon': 'Due soon',

  'status.draft': 'Draft',
  'status.created': 'Not sent',
  'status.sent': 'Sent',
  'status.paid': 'Paid',
  'status.overdue': 'Overdue',
  'status.credited': 'Credited',

  // -------------------------------------------------------------- app frame
  'app.loading': 'Loading your accounts…',
  'app.loadingPersonalFinance': 'Loading your personal finances…',
  'app.loadingEmployeePortal': 'Loading your employee portal…',
  'project.cost.field': 'Project',
  'project.cost.none': 'Not on a project',
  'project.cost.billable': 'Rebilled to the customer',
  'project.cost.pickTitle': 'Choose project',
  'project.cost.search': 'Search for a project or customer',
  'project.cost.searchEmpty': 'No projects match the search.',
  'project.cost.toProject': 'To project',
  'app.employeePortalVerifyTitle': 'Confirm your email address',
  'app.employeePortalVerifyText': 'We sent a verification link to {{email}}. It may take a few minutes to arrive. Check your spam folder too. Open the link to continue.',
  'app.employeePortalVerifyResend': 'Resend the link',
  'app.employeePortalVerifySent': 'Verification link sent again.',
  'app.employeePortalVerifyAlready': 'The email address is already confirmed. Reload the page.',
  'app.employeePortalVerifyFailed': 'Could not send the verification link.',
  'app.emailVerifyCheck': 'I have confirmed',
  'app.emailVerifyConfirmed': 'The email address is confirmed.',
  'app.emailVerifyNotConfirmed': 'The email address has not been confirmed yet. Open the link in the email and try again.',
  'app.emailVerifyCheckFailed': 'Could not check the email address.',
  'app.emailVerifyInitialFailed': 'The account was created, but the verification link could not be sent. Try sending it again.',
  'app.placeholder.title': 'This page is on its way',
  'app.placeholder.text': 'We are putting the finishing touches on it. Check back soon!',
  'app.nobusiness.title': 'What would you like to start with?',
  'app.nobusiness.text': 'You are signed in, but you do not have a business in Plumme yet.',
  'app.nobusiness.create': 'Create business',
  'app.nobusiness.signOut': 'Sign out',
  'common.signOut': 'Sign out',
  // ------------------------------------------------------------------- auth
  'auth.sub.default': 'Simple bookkeeping for small businesses',
  'auth.sub.forgot': 'Reset your password',
  'auth.sub.sent': 'Check your email',
  'auth.sub.signup': 'Create an account and set up your business',
  'auth.language': 'Language',
  'auth.invite.household': 'You have received a household invitation. Sign in or create an account using the email address that received the invitation.',
  'auth.invite.business': 'You have received a client invitation. Enter the email address that received the invitation, and we will open it after you sign in.',
  'auth.email': 'Email',
  'auth.emailPlaceholder': 'you@example.com',
  'auth.password': 'Password',
  'auth.name': 'Name',
  'auth.namePlaceholder': 'Your name',
  'auth.passwordMin': 'At least 6 characters',
  'auth.showPassword': 'Show password',
  'auth.hidePassword': 'Hide password',
  'auth.remember': 'Remember me',
  'auth.forgot': 'Forgot password?',
  'auth.signIn': 'Sign in',
  'auth.signingIn': 'Signing in...',
  'auth.noAccount': 'No account yet?',
  'auth.createAccount': 'Create account',
  'auth.creating': 'Creating...',
  'auth.backToLogin': 'Back to sign in',
  'auth.forgotCopy': 'Enter the email you sign in with, and we will send you a link to set a new password.',
  'auth.sendResetLink': 'Send reset link',
  'auth.sending': 'Sending...',
  'auth.sentCopy': 'We have sent a link to {email}. Follow the link in the email to set a new password.',
  'auth.wrongEmail': 'Wrong email? Try again',
  'auth.error.signIn': 'Sign-in failed.',
  'auth.error.reset': 'Could not send the reset link.',
  'auth.error.signUp': 'Could not create the account.',

  // --------------------------------------------------------- receipt capture
  'capture.scan': 'Scan receipt',
  'capture.toInbox': 'To Inbox',
  'capture.toPurchase': 'To Paid purchase',
  'capture.analysisFailed': 'The receipt was uploaded, but the analysis failed.',
  'capture.readyInPurchase': 'The receipt is ready in Paid purchase.',
  'capture.uploadingToInbox': 'Uploading receipt to Inbox ...',
  'capture.uploadedToInbox': 'Receipt uploaded to Inbox.',
  'capture.uploadFailed': 'Could not upload the receipt.',
  'capture.analysisTimedOut': 'The receipt has been submitted. Analysis is taking a little longer and continues in the background.',
  'capture.paymentDialogLoadFailed': 'Could not load the payment choices. Try again.',
  // ------------------------------------------------------------- navigation
  'nav.home': 'Home',
  'nav.aiBookkeeper': 'AI Bookkeeper',
  'nav.aiAdvisor': 'AI Advisor',
  'nav.newSale': 'New sale',
  'nav.invoices': 'Invoices',
  'nav.otherSales': 'Other sales',
  'nav.customers': 'Customers',
  'nav.products': 'Products',
  'nav.projects': 'Projects',
  'nav.subscriptions': 'Agreements',
  'nav.newPurchase': 'New purchase',
  'nav.manualEntry': 'Manual entry',
  'nav.suppliers': 'Suppliers',
  'nav.assets': 'Fixed assets',
  'nav.inventory': 'Inventory',
  'nav.inbox': 'Inbox',
  'nav.incomeStatement': 'Income statement',
  'nav.trialBalance': 'Trial balance',
  'nav.budget': 'Budget',
  'nav.filings': 'VAT return',
  'nav.taxReturn': 'Tax return',
  'nav.yearEndClosing': 'Year-end closing',
  'nav.annualAccounts': 'Annual accounts',
  'nav.payroll': 'Payroll',
  'nav.mileageLog': 'Mileage log',
  'nav.vouchers': 'Transactions',
  'nav.bank': 'Bank',
  'nav.myPage': 'My page',
  'nav.activityLog': 'Activity log',
  'nav.altinn': 'Altinn',
  'nav.settings': 'Settings',

  'navgroup.sales': 'Sales',
  'navgroup.purchases': 'Purchases',
  'navgroup.reports': 'Reports',
  'navgroup.filings': 'Filings',
  'navgroup.employees': 'Employees',
  'navgroup.other': 'Other',
  'navgroup.miscellaneous': 'More',
  'navgroup.ai': 'AI',
  'navgroup.settings': 'Settings',

  'navhelp.home': 'Your home screen – key figures, charts and shortcuts for registering sales and purchases.',
  'navhelp.aiBookkeeper': 'SuperPlumma goes through bank, vouchers, VAT and deadlines and makes suggestions. You check and approve before anything is posted.',
  'navhelp.aiAdvisor': 'Financial advice from SuperPlumma – health score, recommendations, cash-flow forecast, risk and tax optimisation.',
  'navhelp.newSale': 'Create a new invoice or quote for a customer. The sale is posted automatically.',
  'navhelp.invoices': 'All invoices and quotes – status, due dates and payment.',
  'navhelp.customers': 'Your customer register. Add and edit the customers you invoice.',
  'navhelp.products': 'The goods and services you sell, with price and VAT rate – ready to use on invoices.',
  'navhelp.projects': 'Track hours on projects and activities, follow what has been done, and turn uninvoiced hours into invoice drafts.',
  'navhelp.subscriptions': 'Subscriptions, recurring invoices and customer lists with control over automatic delivery.',
  'navhelp.newPurchase': 'Record a purchase or a supplier invoice with voucher, supplier, amount and account.',
  'navhelp.manualEntry': 'Post manually straight to an account when you need full control of the entry.',
  'navhelp.suppliers': 'Your supplier register – name, company number and bank account for payments.',
  'navhelp.assets': 'Fixed assets and durable items that are depreciated over time.',
  'navhelp.inventory': 'Stock counts and the value of your inventory. Document the count and post the change in stock.',
  'navhelp.inbox': 'Receipts that have arrived but are not posted yet. Drag them onto the right entry.',
  'navhelp.incomeStatement': 'Income minus costs – shows whether the business is running at a profit.',
  'navhelp.trialBalance': 'The balance on every account – the basis for your financial reports.',
  'navhelp.budget': 'Set up a budget and follow how you are tracking against your targets.',
  'navhelp.filings': 'Check the VAT basis for each period. The return itself is filed with Skatteetaten.',
  'navhelp.taxReturn': 'Draft tax return based on your accounts – check the figures before filing with Skatteetaten.',
  'navhelp.yearEndClosing': 'Step by step through everything needed to close the financial year.',
  'navhelp.annualAccounts': 'Profit and loss, balance sheet, notes and signing. The annual accounts are filed with Regnskapsregisteret outside Plumme.',
  'navhelp.payroll': 'Run payroll, create payslips and post the payroll. The a-melding is filed outside Plumme.',
  'navhelp.mileageLog': 'Record work driving and see kilometres and deductions for the year.',
  'navhelp.vouchers': 'A complete overview of posted transactions and their vouchers – search and find them again.',
  'navhelp.bank': 'Upload bank statements and reconcile the bank accounts against your accounts.',
  'navhelp.myPage': 'Your own profile and user settings.',
  'navhelp.activityLog': 'Full history of what has been done in the accounts, and by whom.',
  'navhelp.altinn': 'Shortcut to filings and messages in Altinn.',
  'navhelp.settings': 'Settings for the company, the accounts and the app.',
  'navhelp.fallback': 'Open {label}.',

  // ------------------------------------------------------------ page titles
  'route.home': 'Home',
  'route.newSale': 'New sale',
  'route.newSaleliste': 'Invoices',
  'route.customers': 'Customers',
  'route.projects': 'Projects',
  'route.products': 'Products',
  'route.aiBookkeeper': 'AI Bookkeeper',
  'route.aiAdvisor': 'AI Advisor',
  'route.newPurchase': 'Paid purchase',
  'route.manualEntry': 'Manual entry',
  'route.vouchers': 'Transactions',
  'route.suppliers': 'Suppliers',
  'route.assets': 'Fixed assets',
  'route.filings': 'Filings',
  'route.inbox': 'Inbox',
  'route.documentation': 'Documentation',
  'route.mileageLog': 'Mileage log',
  'route.bank': 'Bank',
  'route.altinn': 'Altinn',
  'route.settings': 'Settings',
  'route.otherSales': 'Other sales',
  'route.subscriptions': 'Agreements',
  'route.incomeStatement': 'Income statement',
  'route.trialBalance': 'Trial balance',
  'route.budget': 'Budget',
  'route.payroll': 'Payroll',
  'route.taxReturn': 'Tax return',
  'route.yearEndClosing': 'Year-end closing',
  'route.annualAccounts': 'Annual accounts',
  'route.myPage': 'My page',
  'route.employeePortal': 'Employee portal',
  'route.activityLog': 'Activity log',
  'route.personalFinance': 'Personal finances',

  // ------------------------------------------------------------------ shell
  'shell.openMenu': 'Open menu',
  'shell.closeMenu': 'Close menu',
  'shell.collapseMenu': 'Collapse menu',
  'shell.showLabels': 'Show menu labels',
  'shell.hideLabels': 'Hide menu labels',
  'shell.designSystem': 'Design system ↗',
  'shell.customizeMenu': 'Customise menu',
  'shell.customizeHelpTitle': 'Customise menu',
  'shell.customizeHelp': 'Choose which pages appear in the side menu. Hide the ones you do not use to keep the menu tidy.',
  'shell.customizeTitle': 'Customise the side menu',
  'shell.customizeVisible': '{visible} of {total} visible',
  'shell.customizeLead': 'Turn off pages you do not use and they disappear from the side menu. You can turn them back on at any time.',
  'shell.customizeAllPages': 'All pages', 'shell.customizeAiMode': 'AI mode',
  'shell.customizeAlwaysOn': 'Always on',
  'shell.customizeDone': 'Done',
  'shell.camCapture': 'Take a photo of a document',
  'shell.camHelp': 'Take a photo of a document with the camera and load it straight into the Inbox or as a new purchase.',
  'shell.moreOptions': 'More options',
  'shell.search': 'Search',
  'shell.searchAll': 'Search everything',
  'shell.searchHelp': 'Search the active business — customers, invoices, products, vouchers, projects, pages and help. Tap to open search (shortcut: Ctrl/⌘+K).',
  'shell.searchPlaceholderLong': 'Search everything — invoices, customers, vouchers…',
  'shell.searchEnterHint': 'to see all matches',
  'shell.companyHelpTitle': 'Choose company or employer',
  'shell.companyHelp': 'Switch between the accounts you keep and the employers you work for. Everything in the app applies to the selected company.',
  'shell.yearHelpTitle': 'Financial year',
  'shell.yearHelp': 'Choose which financial year you are working on. All figures and filings apply to the selected year.',

  'shell.theme.helpTitle': 'Light / dark theme',
  'shell.theme.help': 'Switch between a light and dark look across the app. Your choice is remembered.',
  'shell.theme.toLight': 'Switch to light theme',
  'shell.theme.toDark': 'Switch to dark theme',
  'shell.theme.light': 'Light theme',
  'shell.theme.dark': 'Dark theme',

  'shell.bg.label': 'Background colour',
  'shell.bg.title': 'Background colour for this page',
  'shell.bg.help': 'Choose the background colour for this page only. The colour is saved per page.',
  'shell.bg.menuTitle': 'Background colour · this page',
  'shell.bg.default': 'Plum',
  'shell.bg.mint': 'Mint',
  'shell.bg.varm': 'Warm',
  'shell.bg.sky': 'Blue',
  'shell.bg.rose': 'Rose',
  'shell.bg.skog': 'Forest',

  'skin.title': 'Appearance',
  'skin.standard': 'Standard',
  'skin.standardSub': 'Plumme',
  'skin.klassisk': 'Classic',
  'skin.klassiskSub': 'Understated',

  'shell.client.employers': 'Your employers',
  'shell.client.employer': 'Employer',
  'shell.client.employee': 'Employee',
  'shell.client.private': 'Personal',
  'shell.client.firm': 'Accounting firm',
  'shell.client.firmSub': 'Client overview and reconciliation',

  // Accounting firm surface
  'rf.firm': 'Accounting firm',
  'rf.role.owner': 'Owner',
  'rf.role.admin': 'Administrator',
  'rf.role.employee': 'Team member',
  'rf.group.firm': 'Accountant',
  'rf.group.team': 'Team chat',
  'rf.group.other': 'Other',
  'rf.nav.clients': 'Client overview',
  'rf.nav.reconciliation': 'Reconciliation',
  'rf.nav.control': 'Control',
  'rf.nav.teamchat': 'Team chat',
  'rf.nav.members': 'Team',
  'rf.nav.clientList': 'Clients',
  'rf.client.pageBody': 'Connect the firm to its clients, and put colleagues on the engagements.',
  'rf.client.addTitle': 'Connect a client',
  'rf.client.addBody': 'The client needs a Plumme account for their business. The firm gets access only once the client accepts.',
  'rf.client.billedTo': 'Who pays',
  'rf.client.billedToClient': 'The client pays',
  'rf.client.billedToFirm': 'The firm pays',
  'rf.client.request': 'Send request',
  'rf.client.requesting': 'Sending …',
  'rf.client.requested': 'The request was sent to the client',
  'rf.avst.noClient': 'Pick a client first',
  'rf.avst.allClients': 'All clients',
  'rf.avst.thisClient': 'This client',
  'rf.avst.noClientBody': 'Reconciliation covers one client at a time. Open a client from the client overview and the reconciliation folder follows.',
  'rf.client.requestedMailFailed': 'The request was sent, but the email notification could not be delivered. The client will see it at their next sign-in.',
  'rf.client.requestedNoRecipient': 'The request was sent, but the business has no owner or administrator to notify. Contact the client yourself.',
  'rf.client.noneTitle': 'No clients yet',
  'rf.client.noneBody': 'Connect the firm to a client using their organisation number. The client must approve before you get access.',
  'rf.client.pendingBody': 'The client must accept the request in their own Plumme account. Nobody in the firm has access until then.',
  'rf.client.assignWho': 'Put on the engagement',
  'rf.client.assignPick': 'Choose a colleague',
  'rf.client.assignRole': 'Role on the engagement',
  'rf.client.assign': 'Assign',
  'rf.client.assigned': 'The colleague was put on the client',
  'rf.client.end': 'End the engagement',
  'rf.client.ended': 'The engagement was ended',
  'rf.client.endConfirm': 'End the engagement for {name}? The access the firm granted its colleagues is withdrawn at the same time.',
  'fe.title': 'An accounting firm is requesting access',
  'fe.theFirm': 'The firm',
  'fe.body': 'If you accept, the colleagues the firm puts on the engagement get access to your books. You can end the arrangement at any time.',
  'fe.billedToFirm': 'The firm pays the subscription',
  'fe.billedToClient': 'You pay the subscription yourself',
  'fe.accept': 'Grant access',
  'fe.accepting': 'Accepting …',
  'fe.accepted': '{firm} now has access to your books.',
  'fe.decline': 'Decline',
  'fe.declined': 'The request was declined.',
  'fi.title': 'You have been invited as a colleague',
  'fi.theFirm': 'the firm',
  'fi.body': 'The invitation gives you access to the firm itself. Access to an individual client follows only once the firm puts you on an engagement.',
  'fi.verifyFirst': 'Confirm your email address first. We have sent a new confirmation link.',
  'fi.accept': 'Join',
  'fi.accepting': 'Joining …',
  'fi.accepted': 'You are now a colleague at {firm}.',
  'fi.acceptFailed': 'Could not accept the invitation.',
  'fi.recheck': 'I have confirmed',
  'fi.stillUnverified': 'The address is still not confirmed. Check your inbox and spam folder.',
  'fi.decline': 'Decline',
  'fi.declined': 'The invitation was declined.',
  'set.firm.title': 'Accounting firm',
  'set.firm.sub': 'The firm gets access to your books only once you accept, and loses it the moment you end the arrangement.',
  'set.firm.none': 'No accounting firm has access to this business, and none has asked for it.',
  'set.firm.pending': 'Waiting for your answer',
  'set.firm.active': 'Has access',
  'set.firm.end': 'End the arrangement',
  'set.firm.endConfirm': 'End the arrangement with {firm}? Their colleagues lose access to your books immediately.',
  'set.firm.ended': 'The arrangement has ended, and the access is withdrawn.',
  'set.firm.onlyManagers': 'Only the owner and administrators can answer a request.',
  'rf.create.title': 'Create accounting firm',
  'rf.create.eyebrow': 'Accounting firm',
  'rf.create.readyBody': 'The firm is created and you are the owner. Next, invite your colleagues and connect your clients.',
  'rf.create.openSurface': 'Open the firm surface',
  'rf.create.body': 'The firm is looked up in the company register. You become the owner and can invite colleagues afterwards.',
  'rf.create.orgNumber': 'Organisation number',
  'rf.create.hintDigits': 'Nine digits. The firm must be registered in the company register.',
  'rf.create.hintReady': 'The number is looked up in the company register when you create the firm.',
  'rf.create.hintDemo': 'The demo account may use a made-up number. Give the firm a name below.',
  'rf.create.firmName': 'Name of the firm',
  'rf.create.nameRequired': 'The company was not found in the register. Enter the name of the firm to continue.',
  'rf.create.unverifiedNote': 'The firm is created without a register lookup and is marked unverified. It must be verified before real firms go live.',
  'rf.create.demoNote': 'The demo account sets the name itself. Ordinary accounts get it from the company register.',
  'rf.create.submit': 'Create firm',
  'rf.create.working': 'Creating …',
  'rf.create.done': 'The accounting firm was created',
  'rf.create.note': 'The lookup confirms the company exists. It does not check whether you may act on its behalf.',
  'rf.member.title': 'Position',
  'rf.member.email': 'Email',
  'rf.member.person': 'Person',
  'rf.member.rights': 'Rights',
  'rf.member.inviteTitle': 'Invite a colleague',
  'rf.member.invite': 'Send invitation',
  'rf.member.inviting': 'Sending …',
  'rf.member.invited': 'Invitation sent',
  'rf.member.inviteMailFailed': 'The invitation was created, but the email could not be sent.',
  'rf.member.listTitle': 'Team',
  'rf.member.none': 'No colleagues yet.',
  'rf.member.updated': 'The position was changed',
  'rf.member.remove': 'Remove access',
  'rf.member.removed': 'Access removed',
  'rf.member.removedWithClients': 'Access removed, including at {count} clients.',
  'rf.member.removeConfirm': 'Remove access for {name}? All client access the firm granted this person is withdrawn at the same time.',
  'rf.member.removeNote': 'Removing a colleague also withdraws every client access the firm granted them — across all clients, in one operation.',
  'rf.member.ownerRights': 'Firm owner',
  'rf.member.canControl': 'Can control',
  'rf.nav.backToApp': 'Back to my books',
  'rf.nav.back': 'Back',
  'app.nobusiness.openFirm': 'Open the accounting firm',
  'rf.tab.close': 'Close tab',
  'rf.tab.assignFirst': 'Nobody is on this engagement yet. Access to the books follows the assignment — put someone on the engagement under Clients.',
  'rf.tab.assignNeeded': 'You are not on this engagement. Ask an administrator in the firm to put you on it.',
  'rf.soon.clients': 'The client overview is being connected to the client status the backend computes for each client.',
  'rf.soon.reconciliation': 'The reconciliation surface is being built. The access model and the client status it builds on are in place.',
  'rf.soon.control': 'The control surface follows reconciliation. The four-eyes rule is enforced in the backend when it ships.',
  'rf.noFirm.title': 'You are not a member of an accounting firm',
  'rf.noFirm.body': 'You are not a member of a firm yet. Create your own below, or ask an administrator in the firm to invite you — the invitation arrives by email.',
  'tc.title': 'Team chat',
  'tc.rooms': 'Rooms',
  'tc.dms': 'Direct messages',
  'tc.newRoom': 'New room',
  'tc.roomName': 'Room name',
  'tc.roomNamePlaceholder': 'E.g. Control team',
  'tc.createRoom': 'Create room',
  'tc.noColleagues': 'No colleagues in the firm yet',
  'tc.commonRoom': 'Common room',
  'tc.room': 'Room',
  'tc.commonSubtitle': 'Shared room for the whole team',
  'tc.roomSubtitle': 'Room in the firm',
  'tc.dm': 'Direct message',
  'tc.dmSubtitle': 'Direct message',
  'tc.empty': 'No messages here yet — write the first one.',
  'tc.placeholder': 'Write a message…',
  'tc.send': 'Send',
  'tc.unknown': 'Unknown',
  'shell.client.clients': 'Your clients',
  'shell.client.signOutSub': 'End the session on this device',
  'shell.client.signOutFailed': 'Could not sign out. Please try again.',
  'shell.client.none': 'No business',
  'shell.client.noBusinesses': 'No businesses',
  'shell.client.connecting': 'Connecting to the Plumme backend',
  'shell.client.personalEconomy': 'Personal finances',
  'shell.client.accountingClient': 'Accounting client',
  'shell.client.org': 'Reg. {org}',

  'shell.suggest.invoices': 'Invoices',
  'shell.suggest.customers': 'Customers',
  'shell.suggest.vouchers': 'Vouchers',

  'trial.title': 'Trial is active',
  'trial.active': 'Your trial is active.',
  'trial.dayLeft': 'You have {days} day left.',
  'trial.daysLeft': 'You have {days} days left.',
  'trial.body': 'Everything works - enjoy getting to know Plumme.',
  'trial.upgrade': 'Upgrade',

  // --------------------------------------------------------- Home / dashboard
  'home.greeting': 'Welcome back 👋',
  'home.registerSale': 'Register sale',
  'home.registerSaleHelp': 'Register a new sale or create an invoice for a customer. The sale is posted to the right account automatically.',
  'home.registerPurchase': 'Register purchase',
  'home.registerPurchaseHelp': 'Register a purchase or upload a receipt. SuperPlumma suggests the account and VAT treatment for you.',
  'home.aiHelp': 'Everything SuperPlumma and the agents have done automatically – bookkeeping, VAT, payroll and more. You approve with one tap.',
  'home.autopilot.active': 'Active',
  'home.autopilot.followUp': 'Needs review',
  'home.autopilot.disabled': 'Disabled',

  'home.view.period': 'Period',
  'home.view.analysis': 'Analysis',
  'home.view.cashflow': 'Net result',
  'home.viewLabel.period': 'Income and costs per month',
  'home.viewLabel.analysis': 'Income vs. costs breakdown',
  'home.viewLabel.cashflow': 'Net result per month',
  'home.ana.ring': 'Breakdown',
  'home.ana.gauge1': 'Key figures',
  'home.ana.gauge2': 'Financial key figures',
  'home.sub.yoyArrow': 'The arrow shows the change from last year.',
  'home.sub.exVat': 'All totals are shown excl. VAT.',
  'home.legend.in': 'In',
  'home.legend.out': 'Out',
  'home.legend.income': 'Income',
  'home.legend.cost': 'Cost',
  'home.legend.result': 'Result',
  'home.legend.cashflow': 'Result',
  'home.selectedMonths': 'Selected months:',
  'home.reset': 'Clear',
  'home.sumOfMonth': 'Total for {n} month',
  'home.sumOfMonths': 'Total for {n} months',
  'home.noPrevPeriod': 'No previous period',
  'home.fromPrevMonth': 'from last month',
  'home.fromLastYear': 'from last year',
  'home.showDistribution': 'Show breakdown',
  'home.noData': 'No data',

  'home.donut.registeredIncome': 'Registered income',
  'home.donut.registeredCosts': 'Registered costs',
  'home.donut.income': 'Income',
  'home.donut.costs': 'Costs',
  'home.donut.result': 'Result',
  'home.donut.breakdown': '{title} — breakdown',
  'home.donut.back': 'Back',
  'home.donut.hint': 'Tap a part of the ring or a KPI card below to see the breakdown',

  'home.health.good': 'Good',
  'home.health.balanced': 'Balanced',
  'home.health.weak': 'Weak',
  'home.gauge.explain': 'Explain this key figure',
  'home.gauge.currentValue': 'Current value',
  'home.gauge.assessment': 'Assessment',
  'home.gauge.goodLevel': 'Good level: {good}',
  'home.gauge.income': 'Income',
  'home.gauge.income.info': 'Income is the total of everything the business has sold in the period, excluding VAT. Rising income over time gives you more room to manoeuvre.',
  'home.gauge.income.good': 'Rising over time',
  'home.gauge.costs': 'Costs',
  'home.gauge.costs.info': 'Costs are the expenses needed to run the business, excluding VAT. Lower costs relative to income give a better result.',
  'home.gauge.costs.good': 'Lower than income',
  'home.gauge.result': 'Result',
  'home.gauge.result.info': 'The result is what is left when costs are subtracted from income. A positive result means a profit for the period.',
  'home.gauge.result.good': 'Positive and stable',
  'home.gauge.liquidity': 'Liquidity',
  'home.gauge.liquidity.info': 'Liquidity shows the ability to pay bills and short-term debt as they fall due. A higher value gives a better buffer.',
  'home.gauge.liquidity.good': 'Above 1.0x, ideally above 2.0x',
  'home.gauge.profitability': 'Profitability',
  'home.gauge.profitability.info': 'Profitability shows how much of your income is left as result. The higher the percentage, the more the business earns per unit sold.',
  'home.gauge.profitability.good': 'Positive and rising',
  'home.gauge.solidity': 'Solidity',
  'home.gauge.solidity.info': 'Solidity shows how much of the business is financed by equity. Higher solidity makes the business more robust.',
  'home.gauge.solidity.good': 'A rising equity share over time',

  'home.assistant.sub': 'Bookkeeping assistant',
  'home.assistant.intro': 'Hi! I can handle simple actions for you, create invoices, register purchases, explain taxes and post receipts from your inbox. Ask away. If you want financial advice, the advisor is available on the AI Advisor page.',
  'home.assistant.thinking': 'SuperPlumma is thinking...',
  'home.assistant.placeholder': 'Ask SuperPlumma...',
  'home.assistant.noReply': 'SuperPlumma got no reply from the backend.',
  'home.assistant.errorReply': 'Could not get an answer from the assistant right now.',
  'home.assistant.errorToast': 'Could not get an assistant reply.',
  'home.assistant.cancel': 'Cancel',
  'home.assistant.opened': 'I opened the right page with the suggestion ready for you to check.',
  'home.assistant.openedToast': 'Opened the right flow',
  'home.assistant.noAdapter': 'This action does not have a Plumme adapter yet.',
  'home.assistant.paymentNotConnected': 'Payment registration is not connected to the backend.',
  'home.assistant.paymentRegistered': 'A payment of {sum} has been registered on invoice{number}.',
  'home.assistant.paymentToast': 'Payment registered',
  'home.assistant.paymentFailed': 'Could not register the payment.',
  'home.assistant.cancelled': 'Fine, I made no changes.',
  'home.assistant.sugg1': 'How much do I owe in taxes?',
  'home.assistant.sugg2': 'Create an invoice for a customer',
  'home.assistant.sugg3': 'What is VAT?',

  'home.action.register_payment': 'Approve payment',
  'home.action.create_invoice': 'Open invoice draft',
  'home.action.create_other_sale': 'Open other sale',
  'home.action.create_expense': 'Open new purchase',
  'home.action.register_purchase': 'Open new purchase',
  'home.action.create_customer': 'Save customer',
  'home.action.create_supplier': 'Save supplier',
  'home.action.create_product': 'Save product',
  'home.action.suggest_accounting_entry': 'Open manual entry',
  'home.action.create_mileage_entry': 'Open mileage log',
  'home.action.send_sales_document': 'Open invoices',
  'home.action.book_bank_lines': 'Open bank',
  'home.action.link_bank_receipts': 'Open bank',
  'home.action.annul_bank_posting': 'Open bank',
  'home.action.reporting_preparation': 'Open filings',
  'home.action.default': 'Open flow',

  'home.followup.title': 'Follow-up',
  'home.followup.allClear': 'Everything is under control',
  'home.followup.allClearSub': 'Nothing to follow up right now. Plumme will tell you when something needs attention.',
  'home.followup.next': 'Continue',
  'home.followup.showMore': 'Show more',
  'home.followup.modalTitle': 'Tasks that need attention',
  'home.followup.sales': 'Sales',
  'home.followup.purchases': 'Purchases',
  'home.followup.toInvoiceList': 'Go to invoices',
  'home.followup.toVoucherList': 'Go to vouchers',
  'home.followup.draftInvoices': 'You have {n} invoice drafts that are not finished.',
  'home.followup.unsentInvoices': 'You have {n} invoices that are ready but not sent.',
  'home.followup.overdueInvoices': 'You have {n} unsettled overdue invoices.',
  'home.followup.openPurchases': 'You have {n} unsettled supplier invoices.',
  'home.followup.missingAttachments': 'You have {n} purchases without a receipt.',
  'home.followup.bank': 'Bank reconciliation',
  'home.followup.toBank': 'Go to bank reconciliation',
  'home.followup.missingBankStatements': 'The operating account is missing bank statements for {months}',

  'home.overview.sales': 'Sales',
  'home.overview.purchases': 'Purchases',
  'home.overview.outstandingSales': 'Outstanding sales',
  'home.overview.outstandingPurchases': 'Outstanding purchases',
  'home.overview.salesHelp': 'Outstanding sales are invoices your customers have not paid yet. Green is within the due date, amber is overdue — follow those up with a reminder.',
  'home.overview.purchasesHelp': 'Outstanding purchases are supplier invoices you have not paid yet. Green is within the due date, amber is overdue and should be paid soon.',
  'home.overview.importedSubledger': 'Of which imported subledger: {amount}',
  'home.overview.inclVat': 'The amounts are incl. VAT.',
  'home.overview.helpTitle': 'Outstanding {what}',
  'home.overview.withinDue': 'Within due date',
  'home.overview.overdue': 'Overdue',
  'home.overview.statusTitle': '{within} % within due date · {over} % overdue',

  'home.deadlines.title': 'Upcoming deadlines',
  'home.deadlines.help': 'Upcoming filing deadlines - VAT return, tax return, annual accounts and shareholder register return, with the status of each.',
  'home.deadlines.none': 'No deadlines found in the backend data.',
  'home.deadlines.seeStatus': 'See status',
  'home.deadlines.helpTax': 'The tax return gathers your accounts and tax calculation for the year. Plumme helps you check the figures before filing.',
  'home.deadlines.helpAnnualAccounts': 'The annual accounts gather profit and loss, balance sheet and notes for the financial year, and are filed with Regnskapsregisteret when ready.',
  'home.deadlines.helpAnnualClosing': 'Year-end closing closes the financial year with checks, allocation and the necessary closing entries.',
  'home.deadlines.helpShareholderRegister': 'The shareholder register statement (RF-1086) is filed by limited companies by 31 January of the year after the income year. Plumme cannot submit it — this is a reminder.',
  'home.deadlines.helpVat': 'The VAT return reports output and input VAT for the period.',
  'home.deadlines.helpFallback': 'Deadline for {name}. Plumme notifies you and helps you on from the status view.',
  'home.deadlines.fallbackName': 'filing',
  'home.deadlines.name.shareholderRegister': 'Shareholder register statement',
  'home.fees.title': 'Public duties',
  'home.fees.help': 'An overview of what you owe the authorities right now - VAT, withholding tax and employer contributions. Calculated continuously from your bookkeeping.',
  'home.fees.none': 'No open public duties found.',

  'home.balances.title': 'Balances',
  'home.balances.help': 'Recorded balances on bank, cash and other accounts. The figures come from the trial balance, so they show what your books say - not what the bank has managed to update. Use the gear to pick which accounts to show, or search the chart of accounts for more. The operating and cash accounts can be hidden, but not removed.',
  'home.balances.choose': 'Choose accounts',
  'home.balances.total': 'Total',
  'home.balances.accountFallback': 'Account {code}',
  'home.balances.noneSelected': 'No accounts selected.',
  'home.balances.searchPlaceholder': 'Search the chart of accounts …',
  'home.balances.noHits': 'No matches',
  'home.balances.remove': 'Remove from the card',
  'home.balances.saveFailed': 'Could not save the account selection.',

  // --------------------------------------------------------- Settings
  'set.account': 'Account',
  'set.amount': 'Amount',
  'set.page': 'Page',
  'set.debit': 'Debit',
  'set.credit': 'Credit',
  'set.remove': 'Remove',
  'set.ib.title': 'Opening balance',
  'set.ib.startWizard': 'Start the wizard to create an opening balance',
  'set.ib.confirmDate': 'Confirm the start date',
  'set.ib.setUp': 'Set up the opening balance',
  'set.ib.confirmDateInPlumme': 'Confirm the start date in Plumme',
  'set.ib.startDate': 'Start date',
  'set.back': 'Back',
  'set.ib.dateOk': 'The date is correct, continue',
  'set.ib.draftEmpty': 'The draft is empty.',
  'set.text': 'Text',
  'set.toDebit': 'To (debit)',
  'set.fromCredit': 'From (credit)',
  'set.editLine': 'Edit line',
  'set.removeLine': 'Remove line',
  'set.quickPick': 'Quick picks',
  'set.addNewLine': 'Add a new line',
  'set.saved': 'Saved',
  'set.startOver': 'Start over',
  'set.ib.finish': 'Complete the opening balance',
  'set.ib.summary': 'Summary - amounts in and out of accounts',
  'set.ib.openNote': 'The entry is open and can be changed from this view.',
  'set.ib.intoAccount': 'Into account',
  'set.ib.outOfAccount': 'Out of account',
  'set.sum': 'Total',
  'set.ib.openEntry': 'Open entry',
  'set.accountNo': 'Account no.',
  'set.name': 'Name',
  'set.vatCode': 'VAT code',
  'set.description': 'Description',
  'set.relevantLinks': 'Relevant links',
  'set.deleteCancel': 'Delete / cancel',
  'set.ib.edit': 'Edit the opening balance',
  'set.ib.openingForAccount': 'Opening balance for account',
  'set.cancel': 'Cancel',
  'set.save': 'Save',
  'set.ib.postDescription': 'Description of the entry',
  'set.pickAccount': 'Choose account ...',
  'set.accountDebit': 'Account (debit)',
  'set.ib.cannotBeEmpty': 'An opening balance cannot be empty',
  'set.continueTitle': 'Continue?',
  'set.ib.post': 'Post the opening balance',
  'set.ib.draftTitle': 'Opening balance draft',
  'set.ib.draftHelp': 'Enter balance figures from your previous system so the trial balance starts correctly in Plumme.',
  'set.noteOptional': 'Note (optional)',
  'set.notePh': 'For example what was imported and from which date',
  'set.ib.lines': 'Balance lines',
  'set.ib.linesHelp': 'The balance figures at the transition date, split by account: assets, equity and liabilities from the old system. Enter one line per account so the balance starts with the right figures in Plumme.',
  'set.ib.addLine': 'Add balance line',
  'set.startup.title': 'Opening figures',
  'set.startup.introText': 'Use this if you move to Plumme part-way through {year}. You enter VAT and profit-and-loss figures from your previous system, so reports and the tax return continue correctly from the transition date.',
  'set.startup.startWizard': 'Start the wizard to enter opening figures',
  'set.startup.stepDate': 'Transition date and VAT',
  'set.startup.stepLines': 'Sales and costs',
  'set.startup.confirmTitle': 'Confirm the transition date and VAT so far',
  'set.startup.linesTitle': 'Split the figures before {date}',
  'set.startup.save': 'Save opening figures',
  'set.startup.receiptTitle': 'Opening figures as of {date}',
  'set.startup.receiptSub': 'Saved for the transition to Plumme',
  'set.startup.receiptLines': '{lines} lines registered - {sales} sales and {costs} cost.',
  'set.startup.edit': 'Edit opening figures',
  'set.transitionDate': 'Transition date',
  'set.transitionDateHelp': 'The date you moved to Plumme. The opening figures cover the period from the start of the year up to this date, kept in the old system.',
  'set.outputVatBefore': 'Output VAT before start',
  'set.outputVatBeforeHelp': 'VAT you have already collected on sales so far this year, before the transition. It is added to the year\'s VAT figures so the VAT return is correct.',
  'set.inputVatBefore': 'Input VAT before start',
  'set.inputVatBeforeHelp': 'VAT you have already paid on purchases so far this year (and can deduct), before the transition.',
  'set.salesByAccount': 'Sales by account',
  'set.salesByAccountHelp': 'Sales revenue so far this year, split by revenue account. Enter one line per sales account so the income statement starts with the right figures.',
  'set.salesByAccountBefore': 'Sales by account before start',
  'set.addSalesLine': 'Add sales line',
  'set.noSalesLines': 'No sales lines yet.',
  'set.costsByAccount': 'Costs by account',
  'set.costsByAccountHelp': 'Costs so far this year, split by cost account. Enter one line per cost account so the result is correct from the transition date.',
  'set.costsByAccountBefore': 'Costs by account before start',
  'set.addCostLine': 'Add cost line',
  'set.noCostLines': 'No cost lines yet.',
  'set.import.title': 'Import complete accounts',
  'set.import.pickPackage': 'Choose export files',
  'set.import.shouldContain': 'The package should contain',
  'set.import.saft': 'SAF-T Financial XML',
  'set.import.parties': 'Customer and supplier register, preferably Excel or CSV',
  'set.import.chart': 'Chart of accounts',
  'set.import.vouchers': 'Vouchers, receipts and invoices as PDF or images',
  'set.import.bankRecs': 'Bank reconciliations and invoice copies',
  'set.import.firstStep': 'First step in Plumme',
  'set.import.readsStructure': 'Reads the file structure',
  'set.import.findsFiles': 'Finds SAF-T, Excel and voucher files',
  'set.import.buildsAnalysis': 'Builds an import analysis',
  'set.import.letsApprove': 'Lets you approve a safe import of the chart of accounts, customers, suppliers and opening balance',
  'set.import.notAutomatic': 'Not automatic yet',
  'set.import.noPromise': 'Plumme does not promise that everything will be exactly identical to your previous system',
  'set.import.noHistoric': 'Historic entries are not posted without approval',
  'set.import.nothingToAltinn': 'Nothing is sent to Altinn',
  'set.import.noOverwrite': 'Existing vouchers are not deleted or overwritten without confirmation',
  'set.close': 'Close',
  'set.import.approveBase': 'Approve base data import',
  'set.import.working': 'Working...',
  'set.import.uploading': 'Uploading to Firebase Storage',
  'set.import.serverReading': 'The server is reading the import files now',
  'set.import.importingBase': 'Importing base data',
  'set.import.savedInAccounts': 'The import is saved in the accounts',
  'set.import.checkBefore': 'Check the chart of accounts, customers, suppliers and opening balance before reporting.',
  'set.import.dataOnlyTitle': 'Import accounting data only (recommended)',
  'set.import.dataOnlyHelp': 'Plumme creates a filtered copy in your browser containing SAF-T, CSV and Excel. PDFs, images and other documents are not uploaded.',
  'set.import.dataOnlyKeepOriginal': 'Keep the original ZIP file from Fiken.',
  'set.import.dataOnlyFiltering': 'Removing documents before upload',
  'set.import.dataOnlyFilteringHelp': 'The original file is unchanged. Only the new filtered data package is sent to Plumme.',
  'set.import.dataOnlyFiltered': '{count} document and voucher files were excluded from the upload.',
  'set.import.dataOnlyLibraryFailed': 'The ZIP filter could not be loaded. Try again or extract the SAF-T, CSV and Excel files manually.',
  'set.import.dataOnlyNoFiles': 'No SAF-T, CSV or Excel files were found in the ZIP package.',
  'set.import.packages.title': 'Stored import packages',
  'set.import.packages.help': 'See every ZIP file and which package is the active source for the import archive.',
  'set.import.packages.loading': 'Loading packages...',
  'set.import.packages.empty': 'No stored ZIP files.',
  'set.import.packages.statusImported': 'Active import',
  'set.import.packages.statusDuplicate': 'Identical duplicate',
  'set.import.packages.statusPrevious': 'Previous import',
  'set.import.packages.statusAnalyzed': 'Read',
  'set.import.packages.statusFailed': 'Reading failed',
  'set.import.packages.statusAnalyzing': 'Reading',
  'set.import.packages.statusUploaded': 'Uploaded',
  'set.import.packages.uploadedAt': 'Uploaded {date}',
  'set.import.packages.readAt': 'Last read {date}',
  'set.import.packages.importedAt': 'Imported into the accounts {date}',
  'set.import.packages.notAvailable': 'Unknown time',
  'set.import.packages.unknownSize': 'Unknown size',
  'set.import.packages.deleteConfirm': 'Delete {name}? The ZIP file and temporary analysis data will be permanently removed. No accounting data was imported from this package.',
  'set.import.packages.deletePreviousConfirm': 'Delete the previous import package {name}? Imported accounting data will remain. Documents found only in this older ZIP file cannot be opened after deletion.',
  'set.import.packages.deleteDialogTitle': 'Delete import package?',
  'set.import.packages.deleteDialogBody': 'You are about to delete {name}. The ZIP file and its analysis data will be permanently removed from the backend.',
  'set.import.packages.deletePreviousBody': 'You are about to delete the previous import package {name}. Accounting data will remain, but documents found only in this ZIP file cannot be opened afterwards.',
  'set.import.packages.deleteIrreversible': 'This action cannot be undone.',
  'set.import.packages.replaceTitle': 'Replace the existing import package?',
  'set.import.packages.replaceBody': 'You already have the import package {name}. Once the new package is analyzed and approved, it becomes active and every older ZIP package is deleted from the backend.',
  'set.import.packages.replaceSafety': 'The existing package is kept while the new one is uploaded and analyzed. If analysis fails or is cancelled, the current active package remains untouched.',
  'set.import.packages.replacePermanent': 'After approval, deletion of the old package cannot be undone.',
  'set.import.packages.chooseReplacement': 'Choose new ZIP',
  'set.import.packages.deleteProtected': 'This package is used by the accounts and cannot be deleted here.',
  'set.import.packages.protectedHelp': 'This is the active source for imported voucher documents and cannot be deleted.',
  'set.import.packages.duplicateHelp': 'The file contents are identical to the active import package and can be deleted.',
  'set.import.packages.deleting': 'Deleting...',
  'set.import.packages.delete': 'Delete',
  'set.import.packages.deleted': 'The import package was deleted.',
  'set.import.packages.deleteFailed': 'Could not delete the import package.',
  'set.import.packages.deleteMissing': 'The import package storage path is missing.',
  'set.import.packages.download': 'Download ZIP',
  'set.import.packages.downloading': 'Preparing...',
  'set.import.packages.downloadMissing': 'The import package storage path is missing.',
  'set.import.packages.downloadStarted': 'The original ZIP download has started.',
  'set.import.packages.downloadFailed': 'Could not download the import package.',
  'set.import.years.title': 'Choose data years',
  'set.import.years.help': 'Only figures and data for selected years are imported. Registers and the document archive are handled separately.',
  'set.import.years.recommended': 'Recommended period',
  'set.import.years.previousOnly': 'Previous years only',
  'set.import.years.all': 'All years',
  'set.import.years.current': 'current year',
  'set.import.years.retentionWarning': 'You excluded {years}, which may still be within the normal retention period. Ensure the material is retained elsewhere.',
  'set.import.years.documentsPreserved': 'The original ZIP and document archive remain complete regardless of year selection.',
  'set.import.years.importedTitle': 'Imported data years',
  'set.import.years.importedHelp': 'Remove imported figures for one year without deleting the ZIP, document archive, or manually created records.',
  'set.import.years.removeYear': 'Remove imported data for {year}',
  'set.import.years.removeTitle': 'Remove imported data for {year}?',
  'set.import.years.removeBody': 'Imported opening balance, report history, year-specific open items, and imported compliance statuses for {year} will be removed.',
  'set.import.years.removePreserves': 'Manual invoices, purchases, vouchers, registers, the original ZIP, and the document archive are preserved.',
  'set.import.years.removeConfirm': 'Remove data',
  'set.import.years.removing': 'Removing...',
  'set.import.years.removed': 'Removed {count} imported data points for {year}.',
  'set.import.years.removeFailed': 'Could not remove imported year data.',
  'set.import.years.invalid': 'Choose a valid import year.',
  'set.import.years.selectedLedgerRows': 'history rows in selected years',
  'set.showAll': 'Show all',
  'set.count.accounts': 'balance accounts',
  'set.count.customers': 'customers',
  'set.count.products': 'products',
  'set.count.openSalesInvoices': 'open customer invoices',
  'set.count.openPurchaseInvoices': 'open supplier invoices',
  'set.count.suppliers': 'suppliers',
  'set.count.openingBalances': 'opening balances',
  'set.import.after': 'After import',
  'set.noMatches': 'No matches.',
  'set.preview': 'Preview',
  'set.previewHeading': 'How the document looks',
  'set.preview.sender': 'Sender:',
  'set.preview.invoiceNo': 'Invoice no.:',
  'set.preview.invoiceDate': 'Invoice date:',
  'set.preview.dueDate': 'Due date:',
  'set.preview.accountNo': 'Account no.:',
  'set.preview.toPay': 'To pay:',
  'set.preview.docType': 'INVOICE',
  'set.preview.noCustomer': 'No customer selected yet',
  'set.preview.net': 'Net',
  'set.preview.vat': 'VAT',
  'set.preview.toPayShort': 'To pay',
  'set.menu.title': 'Side menu',
  'set.menu.help': 'Choose which pages appear in the menu on the left. Core pages are always visible.',
  'set.menu.showAll': 'Show all pages',
  'set.xlsx': 'XLSX',
  'set.csv': 'CSV',
  'set.import': 'Import',
  'set.data.accountingTitle': 'Import / export of accounts',
  'set.data.accountingSub': 'Import from another accounting system with ZIP, SAF-T, CSV or Excel files, and export backup and bookkeeping overviews.',
  'set.export': 'Export',
  'set.data.invoiceCsv': 'Invoice CSV',
  'set.data.invoiceTemplate': 'Invoice import template',
  'set.data.bookkeepingCsv': 'Bookkeeping CSV',
  'set.data.reusePackage': 'Reuses the uploaded export file without a new upload.',
  'set.data.resetAll': 'Reset all data',
  'set.data.deleteBusiness': 'Delete business',
  'set.data.onlyOwnerSchedule': 'Only the owner can schedule deletion.',
  'set.doc.tab': 'Documents',
  'svc.mcpMissingRedirect': 'The MCP service did not return a secure redirect.',
  'route.dailySettlements': 'Daily settlements',
  'nav.dailySettlements': 'Daily settlements',
  'navhelp.dailySettlements': 'Daily settlements from point-of-sale, booking, rental and online-shop systems. Check and approve before posting.',
  'dailySettlement.title': 'Daily settlements',
  'dailySettlement.sub': 'Settlements from point of sale, booking, rental and online shops. Nothing is posted until you approve it.',
  'dailySettlement.refresh': 'Refresh',
  'dailySettlement.loadError': 'Could not load the daily settlements.',
  'dailySettlement.openSettings': 'Open integrations',
  'dailySettlement.emptyTitle': 'No daily settlements here',
  'dailySettlement.emptyText': 'Once a source is connected and has delivered a settlement, it appears here for review and approval.',
  'dailySettlement.filter.open': 'To handle',
  'dailySettlement.filter.ready': 'Ready',
  'dailySettlement.filter.review': 'Needs review',
  'dailySettlement.filter.done': 'Done',
  'dailySettlement.status.ready': 'Ready for approval',
  'dailySettlement.status.review': 'Needs review',
  'dailySettlement.status.approved': 'Posted',
  'dailySettlement.status.dismissed': 'Closed without posting',
  'dailySettlement.attentionTitle': 'Sources needing attention',
  'dailySettlement.attentionStale': '{provider} has not delivered a settlement for {days} days. The last one was {date}.',
  'dailySettlement.attentionNever': '{provider} is connected but has never delivered a settlement.',
  'dailySettlement.homeWaiting': '{ready} ready for approval, {review} need review.',
  'dailySettlement.homeAction': 'Open daily settlements',
  'set.doc.title': 'Documents',
  'set.doc.sub': 'Upload and store your own documents, for example agreements, insurance or articles of association.',
  'set.doc.drop': 'Drag files here',
  'set.doc.dropHint': 'Or click to choose a file',
  'set.doc.empty': 'No documents uploaded yet.',
  'set.doc.added': 'Added',
  'set.doc.new': 'New document',
  'set.doc.edit': 'Edit document',
  'set.doc.remove': 'Remove document',
  'set.doc.open': 'Open document',
  'set.doc.add': 'Add document',
  'set.doc.name': 'Name',
  'set.doc.namePh': 'For example Liability insurance 2026',
  'set.doc.nameRequired': 'Give the document a name first',
  'set.doc.type': 'Type',
  'set.doc.attachTo': 'Attached by default to',
  'set.doc.attachToHint': 'The document is included automatically with these document types — it can be removed per send.',
  'set.doc.uploading': 'Uploading...',
  'set.doc.uploaded': 'Document uploaded',
  'set.doc.saved': 'Document updated',
  'set.doc.deleted': 'Document removed',
  'set.doc.deleteConfirm': 'Delete the document "{name}"?',
  'set.doc.fileHint': 'PDF, Word, Excel, JPG, PNG or WEBP. Max 10 MB.',
  'set.doc.unavailable': 'The documents page did not load. Reload the page — if it still looks empty, this is a bug we need to look at.',
  'set.doc.target.offer': 'Offers',
  'set.doc.target.orderConfirmation': 'Order confirmations',
  'set.doc.target.invoice': 'Invoices',
  'set.doc.target.creditNote': 'Credit notes',
  'set.doc.target.subscription': 'Subscriptions and lists',
  'set.doc.target.subscriptionHint': 'Included with email you send from a subscription or a customer list.',
  'set.doc.kind.agreement': 'Agreement',
  'set.doc.kind.insurance': 'Insurance',
  'set.doc.kind.articles': 'Articles of association',
  'set.doc.kind.authorization': 'Power of attorney',
  'set.doc.kind.certificate': 'Certificate',
  'set.doc.kind.standard_attachment': 'Standard attachment',
  'set.doc.kind.other': 'Other',
  'sale.att.standard': 'Standard',
  'sale.att.removeStandard': 'Do not include this time',
  'sale.att.remove': 'Remove attachment',
  'sub.standardDocs': 'Standard documents included: {names}',
  'set.data.saftXml': 'SAF-T XML (beta)',
  'set.acc.title': 'Accounting setup',
  'set.acc.sub': 'Basic settings for the accounts: first financial year, VAT registration, accounting method and similar.',
  'set.acc.startYear': 'Start year',
  'set.acc.startYearHelp': 'The first financial year you keep in Plumme. Vouchers and reports from before this year belong in an earlier system.',
  'set.acc.startInvoiceNo': 'Starting invoice number',
  'set.acc.startInvoiceNoHelp': 'The number your first invoice will get. If you are coming from another system, set this higher than the last number used so you get an unbroken sequence (a legal requirement).',
  'set.acc.vatStatus': 'VAT status',
  'set.acc.vatStatusHelp': 'Whether the business is registered in the VAT register. You become liable for VAT when taxable turnover passes NOK 50,000 over 12 months. VAT registered means you charge VAT on sales and deduct it on purchases.',
  'set.acc.vatRegistered': 'VAT registered',
  'set.acc.notVatRegistered': 'Not VAT registered',
  'set.acc.vatRegisteredFrom': 'VAT registered from',
  'set.acc.vatRegisteredWhen': 'Was the business already VAT registered on 1 January {year}?',
  'set.acc.vatRegisteredWhenHelp': 'The Plumme accounts start in {year}. From the VAT date, VAT is posted on sales and purchases — before it, none. Answering “yes” sets the date to 1 January {year}.',
  'set.acc.vatRegisteredPick': 'Choose an answer',
  'set.acc.vatRegisteredAtStart': 'Yes, registered before {year}',
  'set.acc.vatRegisteredLater': 'No, registered during {year} or later',
  'set.acc.vatRegisteredUnknown': 'Not sure',
  'set.acc.vatRegisteredFromHelp': 'The date the business was VAT registered. Before that date no VAT is calculated; from it, VAT is posted on sales and purchases.',
  'set.acc.standardVat': 'Suggestion for new sales lines',
  'set.acc.standardVatHelp': 'This is only the rate Plumme suggests for a new sales line. A business may use several VAT rates, and the product or invoice line can override the suggestion.',
  'set.acc.howFileVat': 'How do you file VAT',
  'set.acc.vatPeriod': 'VAT period',
  'set.acc.vatPeriodHelp': 'How often you file the VAT return. Most file every other month (6 periods a year). Small businesses under NOK 1 million can apply for annual filing. Quarterly and monthly are used in special cases.',
  'set.acc.midYearTitle': 'Starting mid-year (opening figures)',
  'set.acc.midYearHelp': 'Use this if you start using Plumme in the middle of a financial year. Then you enter opening figures — sales, costs and VAT so far this year — from the old system, so annual reports and the VAT return continue with the right figures.',
  'set.acc.midYear': 'Start mid-year',
  'set.acc.enterOpening': 'Enter opening figures',
  'set.acc.enterOpeningHelp': 'Opens the form where you enter the transition date, VAT so far, and sales/costs by account from the previous system.',
  'set.acc.ibHelp': 'The opening balance is the assets, equity and liabilities the company had at the start of the year — that is, the closing balance from last year. Enter it when you start a new financial year in Plumme, so the balance is right from day one.',
  'set.acc.viewIb': 'View / edit opening balance',
  'set.acc.viewIbHelp': 'Opens the opening balance you have posted, where you can see the lines, edit them or delete the balance.',
  'set.acc.addIb': 'Enter opening balance',
  'set.acc.addIbHelp': 'Opens a wizard that helps you set up the opening balance — you confirm the start date and enter the balance lines (debit/credit) from last year.',
  'set.acc.extraAccountsHelp': 'Only add extra accounts when the trial balance or the export needs them.',
  'set.acc.searchPlaceholder': 'Search the chart of accounts by number or name',
  'set.acc.searchNoHits': 'No accounts match “{query}”.',
  'set.acc.addAccount': 'Add account',
  'set.acc.addAccountHelp': 'Creates a custom account in the chart of accounts. Use it only when an account you need is missing — most standard accounts already exist.',
  'set.acc.accountNameHelp': 'A descriptive name for the account, as it appears in the chart of accounts and the reports — for example "Software/subscription".',
  'set.acc.accountNoHelp': 'A four-digit account number. The first digit sets the account class: 1 assets, 2 equity/liabilities, 3 income, 4-7 costs, 8 finance and tax.',
  'set.acc.accountClass': 'Account class',
  'set.acc.accountClassHelp': 'The main group the account belongs to, derived automatically from the first digit of the account number. It decides whether the account is an asset, liability, income or cost.',
  'set.acc.equivalent': 'Corresponds to account',
  'set.acc.equivalentHelp': 'Links the custom account to a standard account. That tells Plumme how the account should be treated in year-end closing and the tax return — so your own accounts end up correctly in the official forms.',
  'set.acc.createAccount': 'Create account',
  'set.acc.ownAccounts': 'Custom accounts',
  'set.acc.ownAccountsHelp': 'The accounts you have added yourself, beyond the standard chart. Only these can be changed or deleted.',
  'set.acc.noOwnAccounts': 'No custom accounts yet.',
  'set.acc.removeAccount': 'Remove account',
  'set.acc.deactivated': 'deactivated',
  'set.acc.standardAccounts': 'Standard accounts',
  'set.acc.standardAccountsHelp': 'The built-in standard chart of accounts (NS 4102). These are shared by everyone and used automatically when you post — you rarely need to add your own.',
  'set.bank.title': 'Bank reconciliation',
  'set.bank.help': 'Bank reconciliation helps you check that purchases, sales and payments are posted once and match the operating account.',
  'set.bank.activeFrom': 'Active from',
  'set.bank.accounts': 'Bank accounts',
  'set.bank.primaryHelp': 'The primary invoice account is the default account customers pay into.',
  'set.bank.disabled': 'Disabled',
  'set.bank.invoiceAccount': 'Invoice account',
  'set.bank.activate': 'Activate account',
  'set.bank.setAsInvoice': 'Set as invoice account',
  'set.bank.accountNumber': 'Account number',
  'set.bank.ledgerAccount': 'Account in the ledger',
  'set.bank.type': 'Type',
  'set.bank.typeOperating': 'Operating',
  'set.bank.typeTax': 'Tax withholding',
  'set.bank.typeSavings': 'Savings',
  'set.bank.typePrivate': 'Private',
  'set.bank.typeOther': 'Other',
  'set.bank.openingBalance': 'Opening balance for reconciliation',
  'set.bank.openingBalanceDate': 'Opening balance date',
  'set.bank.reconcileIn': 'Reconcile in Bank',
  'set.bank.mustReconcile': 'Must be reconciled',
  'set.bank.showInPayments': 'Show in Paid from/to',
  'set.bank.none': 'No bank accounts registered yet.',
  'set.bank.cards': 'Cards linked to this account',
  'set.bank.cardsHelp': 'Receipts usually show only the last four digits. Register the card and Plumme recognises the payment without waiting for the bank statement. The account type decides whether the purchase is company or a private expense.',
  'set.bank.cardsNone': 'This account has no card',
  'set.bank.cardsNoneHelp': 'Tick this, or register the cards, on every payment account. Once all accounts are settled, Plumme knows which cards the company has: a receipt paid with any other card is then suggested as a private outlay, with a note on the voucher.',
  'set.bank.cardPromptTitle': 'The cards decide company or private',
  'set.bank.cardPromptBody': 'Plumme reads the card number off the receipt. When we know which cards the company has, every card purchase is settled automatically: a card we know is a company purchase, any other card is a private outlay. These accounts have no answer yet:',
  'set.bank.cardPromptSkipHelp': 'If you skip, the account stays unsettled and card receipts need their payment source set by hand. You can fill it in at any time.',
  'set.bank.cardPromptFill': 'Fill in now',
  'set.bank.cardPromptSkip': 'Save without',
  'set.bank.accountFallback': 'Bank account',
  'set.bank.receiptDefault': 'Default payment source for vouchers',
  'set.bank.receiptDefaultSub': 'Used only when neither card, bank statement nor history says where the purchase was paid from.',
  'set.bank.receiptDefaultLabel': 'Payment source',
  'set.bank.receiptDefaultHint': 'The voucher becomes ready to post, but is marked in orange to show the source was preselected, not read from the document.',
  'set.bank.receiptDefaultNone': 'None - leave the voucher for review',
  'set.bank.cardLast4': 'Last four digits',
  'set.bank.cardLabel': 'Card name',
  'set.bank.cardLabelPh': 'E.g. Visa private',
  'set.bank.cardAdd': 'Add card',
  'set.bank.cardRemove': 'Remove card',
  'set.bank.cardLast4Invalid': 'Enter the last four digits of the card.',
  'set.bank.cardDuplicate': 'That card is already registered. Two cards with the same four digits cannot be told apart on a receipt.',
  'set.access.title': 'Access',
  'set.access.sub': 'Invite an accountant or partner with their own login. Access is controlled with roles.',
  'set.access.activeBusiness': 'Active business',
  'set.access.active': 'Active',
  'set.access.noBusinesses': 'No businesses are linked to the user yet.',
  'set.access.newBusiness': 'New business',
  'set.access.inviteTitle': 'Invite a partner',
  'set.access.inviteSub': 'Invite your accountant or other partners, and see pending invitations.',
  'set.access.noAdmin': 'You do not have the admin role on the selected business.',
  'set.access.noAdminSub': 'Only the owner and admin can invite new users.',
  'set.access.email': 'Email',
  'set.access.role': 'Role',
  'set.role.accountant': 'Accountant',
  'set.role.admin': 'Admin',
  'set.role.viewer': 'Read access',
  'set.access.sendInvite': 'Send invitation',
  'set.access.invites': 'Invitations',
  'set.access.invitesSub': 'Pending invitations for the active business.',
  'set.access.accept': 'Accept',
  'set.access.pending': 'Pending',
  'set.access.withdraw': 'Withdraw',
  'set.access.noInvites': 'No pending invitations.',
  'set.access.deleteNote': 'Deletes only the selected business, not your login or other businesses.',
  'set.access.deleteBusiness': 'Delete this business',
  'set.access.onlyOwnerDelete': 'Only the owner can delete a business.',
  'set.saveChanges': 'Save changes',
  'set.title': 'Settings',
  'set.subtitle': 'Business, user profile, access, accounting, bank, investments and data in one place.',
  'set.tabsTitle': 'Settings tabs',
  'set.tabsHelp': 'Each tab is one settings area: Business (company details), User profile (you), Access (who can do what), Preferences (notifications and display), Accounting (setup and chart of accounts), Bank, Investments, Data (import/export), Documents, Integrations and Subscription.',
  'set.company': 'Business',
  'set.country': 'Country',
  'set.companyName': 'Business name',
  'set.orgNumber': 'Organisation number',
  'set.phone': 'Phone',
  'set.address': 'Address',
  'set.zip': 'Postal code',
  'set.city': 'Postal place',
  'set.companyType': 'Company type',
  'set.logo': 'Company logo',
  'set.logoAlt': 'logo',
  'set.logoHelp': 'Logo for invoices. PNG, JPG or WebP, max 1 MB.',
  'set.uploadLogo': 'Upload logo',
  'set.previewInvoice': 'Preview invoice',
  'set.deleteLogo': 'Delete logo',
  'set.inboxEmail': 'Voucher inbox email',
  'set.inboxEmailHelp': 'Forward supplier invoices and receipts here to put vouchers straight into the Inbox.',
  'set.copyEmail': 'Copy email',
  'set.generateEmail': 'Generate a new address',
  'set.generateEmailHelp': 'Only rotate it if the address has leaked or is being spammed. Existing integrations must be updated.',
  'set.profile': 'User profile',
  'set.profileSub': 'Details belonging to your login.',
  'set.loggedInEmail': 'Signed-in email',
  'set.mobile': 'Mobile number',
  'set.saveProfile': 'Save user profile',
  'set.subscription': 'Subscription',
  'set.subscriptionSub': 'Billing is controlled by the backend and Stripe, not a local mock plan.',
  'set.openPortal': 'Open customer portal',
  'set.current': 'Current',

  // ------------------------------------------------------- AI Advisor (aiinsikt)
  'adv.eyebrow': 'Financial advisor',
  'adv.beta': 'Beta',
  'adv.updating': 'Updating',
  'adv.lead': 'SuperPlumma analyses your accounts and advises you like an experienced CFO — for {year}.',
  'adv.tab.overview': 'Overview',
  'adv.tab.liquidity': 'Liquidity & risk',
  'adv.tab.sales': 'Sales & profitability',
  'adv.tab.costs': 'Costs',
  // Sales profitability uses posted invoice cost snapshots when available.
  'adv.sales.title': 'Sales and profitability',
  'adv.sales.sub': 'Posted sales invoices for {year}',
  'adv.sales.help': 'Every figure here is calculated from posted sales invoices in the selected year, compared with the same figure the year before. Drafts, credit notes and offers are excluded.',
  'adv.sales.emptyTitle': 'No posted sales invoices yet',
  'adv.sales.emptyText': 'Once you have posted sales, I work out customer profitability, payment time, discount levels and which products are growing.',
  'adv.sales.periodYear': 'in {year}',
  'adv.sales.periodVsPrev': 'vs {year}',
  'adv.sales.invoiceCount': '{count} invoices',
  'adv.sales.customerCount': '{count} customers',
  'adv.sales.recurringCount': '{count} with recurring billing',
  'adv.sales.days': '{days} days',
  'adv.sales.noPayments': 'Nothing paid yet',
  'adv.sales.kpi.revenue': 'Revenue',
  'adv.sales.kpi.growth': 'Revenue growth',
  'adv.sales.kpi.growthHelp': 'Change in posted sales against the same period last year. Shown as "—" when there are no prior-year figures to compare with.',
  'adv.sales.kpi.avgInvoice': 'Average invoice',
  'adv.sales.kpi.discount': 'Average discount',
  'adv.sales.kpi.discountHelp': 'Total discount divided by what the invoices would have been worth without it. If this rises without volume rising, you are giving away margin for nothing.',
  'adv.sales.kpi.paymentDays': 'Payment time',
  'adv.sales.kpi.paymentDaysHelp': 'Average days from invoice date to a registered payment. Only paid invoices count — unpaid ones do not inflate the average.',
  'adv.sales.kpi.repeat': 'Repeat rate',
  'adv.sales.kpi.repeatHelp': 'Share of customers with more than one invoice this year. A high repeat rate gives more predictable revenue than the same sales spread across one-off customers.',
  'adv.sales.kpi.concentration': 'Customer concentration',
  'adv.sales.kpi.concentrationHelp': 'Share of revenue coming from your largest customer. Above 40 % means a single customer can sink the business on its own.',
  'adv.sales.kpi.recurring': 'Recurring revenue',
  'adv.sales.kpi.recurringHelp': 'Share of revenue from invoices with recurring billing or a subscription.',
  'adv.sales.customers': 'Customer profitability',
  'adv.sales.customersSub': 'Revenue, payment time and discount level per customer',
  'adv.sales.customersHelp': 'Customers are sorted by revenue in the selected year. The trend compares with last year — a new customer with no prior-year figures gets its own marker instead of an arrow.',
  'adv.sales.col.customer': 'Customer',
  'adv.sales.col.revenue': 'Revenue',
  'adv.sales.col.grossProfit': 'Gross profit',
  'adv.sales.col.paymentSpeed': 'Payment time',
  'adv.sales.col.discount': 'Discount',
  'adv.sales.col.jobs': 'Invoices',
  'adv.sales.col.trend': 'Trend',
  'adv.sales.partialProfit': 'Not calculated',
  'adv.sales.trendNew': 'New customer this year',
  'adv.sales.showAll': 'Show all {count} customers',
  'adv.sales.showFewer': 'Show fewer',
  'adv.sales.profitNote': 'Gross profit is shown when every invoice line for the customer has a recorded cost price. Older invoices and lines without a cost price show “Not calculated”.',
  'adv.sales.products': 'Products and services',
  'adv.sales.productsSub': 'Revenue per product, and what is growing or falling',
  'adv.sales.productsHelp': 'Products come from the invoice lines. Lines without a product name are grouped under "Uten produktnavn". Growth and decline are measured against the same product last year.',
  'adv.sales.topRevenue': 'Highest revenue',
  'adv.sales.growing': 'Fastest growing',
  'adv.sales.falling': 'Steepest decline',
  'adv.sales.noComparison': 'No prior-year figures to compare with',
  // Sales verdict
  'adv.sales.verdictTag': 'Sales and profitability right now',
  'adv.sales.verdict.concentration': '{name} accounts for {pct} % of invoiced sales of {revenue}. That is the biggest risk in your sales right now — if that customer leaves, most of the revenue goes with them.',
  'adv.sales.verdict.slowPayers': 'Sales themselves look fine, but {count} customer(s) pay slowly — the slowest takes {days} days. The money is earned; it is just sitting out longer than it needs to.',
  'adv.sales.verdict.discounts': 'You give {pct} % discount on average, {amount} in total this year. That is money you have already sold — worth checking that the discount actually brings in volume.',
  'adv.sales.verdict.growing': 'Sales are up {pct} % against last year and now stand at {revenue}. Nothing in the sales figures calls for action right now — the main thing is to keep it going.',
  'adv.sales.verdict.shrinking': 'Sales are down {pct} % against last year and stand at {revenue}. That is the clearest signal in your sales figures now.',
  'adv.sales.verdict.steady': 'Sales stand at {revenue} across {count} invoices. I see no red flags in the sales figures — the actions below are opportunities, not problems.',
  // What I would do first
  'adv.sales.moves.title': 'What I would do first',
  'adv.sales.moves.sub': 'Prioritised actions, sorted by effect',
  'adv.sales.moves.help': 'Every action has a figure from your own invoices behind it. The effect type says what kind of quantity the figure is — days, kroner or share — and they should never be added together.',
  'adv.sales.move.chaseSlowPayers.title': 'Chase the slowest payers',
  'adv.sales.move.chaseSlowPayers.text': '{count} customer(s) pay more slowly than the rest. {name} takes {days} days on average.',
  'adv.sales.move.chaseSlowPayers.effectLbl': 'Possible reduction in credit time',
  'adv.sales.move.chaseSlowPayers.effectNote': 'down towards your own average — the value in kroner depends on when the customer actually pays',
  'adv.sales.move.chaseSlowPayers.action': 'See invoice list',
  'adv.sales.move.reviewDiscounts.title': 'Review your discounts',
  'adv.sales.move.reviewDiscounts.text': 'You have given {amount} in discounts this year, {pct} % per invoice on average.',
  'adv.sales.move.reviewDiscounts.effectLbl': 'Estimated effect',
  'adv.sales.move.reviewDiscounts.effectNote': 'by halving the discount level',
  'adv.sales.move.reviewDiscounts.action': 'See invoice list',
  'adv.sales.move.spreadCustomers.title': 'Spread the customer base',
  'adv.sales.move.spreadCustomers.text': '{name} accounts for {pct} % of sales. One customer should not carry the revenue alone.',
  'adv.sales.move.spreadCustomers.effectLbl': 'Share from largest customer',
  'adv.sales.move.spreadCustomers.effectNote': 'this is the risk, not a gain',
  'adv.sales.move.spreadCustomers.action': 'See customers',
  'adv.sales.move.testPriceIncrease.title': 'Consider a price increase',
  'adv.sales.move.testPriceIncrease.text': 'Test what a {pct} % higher price does to revenue before you decide.',
  'adv.sales.move.testPriceIncrease.effectLbl': 'Estimated annual effect',
  'adv.sales.move.testPriceIncrease.effectNote': 'at current volume',
  'adv.sales.move.testPriceIncrease.action': 'See products',
  'adv.sales.move.growRecurring.title': 'Build more recurring sales',
  'adv.sales.move.growRecurring.text': '{pct} % of sales are recurring. Get up towards {target} % and revenue becomes far more predictable.',
  'adv.sales.move.growRecurring.effectLbl': 'Revenue that could become predictable',
  'adv.sales.move.growRecurring.effectNote': 'if the share reaches the target',
  'adv.sales.move.growRecurring.action': 'See subscriptions',
  // Sales scenarios
  'adv.sales.scn.title': 'Sales scenarios — What if …',
  'adv.sales.scn.sub': 'Effect on revenue, profit and liquidity',
  'adv.sales.scn.help': 'Pick a scenario to see before/after on revenue, profit, margin and liquidity, along with the assumptions I have used. The figures are calculations, not guarantees.',
  'adv.sales.scn.metric': 'Metric',
  'adv.sales.scn.base': 'Base',
  'adv.sales.scn.after': 'After scenario',
  'adv.sales.scn.change': 'Change',
  'adv.sales.scn.row.revenue': 'Revenue',
  'adv.sales.scn.row.result': 'Profit',
  'adv.sales.scn.row.margin': 'Profit margin',
  'adv.sales.scn.row.liquidity': 'Calculated planning balance',
  'adv.sales.scn.points': '{points} pp',
  'adv.sales.scn.assumptions': 'Assumptions',
  'adv.sales.scn.showAssumptions': 'View assumptions',
  'adv.sales.scn.confidence': 'Confidence',
  'adv.sales.scn.risk': 'Risk',
  'adv.sales.scn.scope': 'Scope',
  'adv.sales.scn.q.priceUp': 'I raise prices',
  'adv.sales.scn.q.volumeDown': 'Sales volume falls',
  'adv.sales.scn.q.halveDiscounts': 'I remove half of the discounts',
  'adv.sales.scn.q.loseTopCustomer': 'I lose {name}',
  'adv.sales.scn.q.growRecurring': 'Recurring sales grow {pct} %',
  'adv.sales.scn.summary.priceUp': 'At current volume a {pct} % price increase brings around {delta} more in annual revenue. A price increase adds no extra goods or hours cost, so the full amount flows through to profit.',
  'adv.sales.scn.summary.volumeDown': 'A {pct} % drop in volume takes around {delta} out of revenue. The calculation assumes costs stay flat, so this is the harshest outcome — if purchases fall with volume, the hit is smaller.',
  'adv.sales.scn.summary.halveDiscounts': 'You have given {amount} in discounts this year, {pct} % on average. Halving the level recovers around {delta} — provided the customers stay.',
  'adv.sales.scn.summary.loseTopCustomer': 'If {name} leaves you lose {delta} — {pct} % of sales. This is the figure that makes spreading the customer base worth doing before it happens.',
  'adv.sales.scn.summary.growRecurring': 'Growing recurring sales by {pct} % adds around {delta} a year. Recurring income is the most predictable revenue you have.',
  'adv.sales.scn.assumption.priceUp': 'Volume holds. Applies to all products and services.',
  'adv.sales.scn.assumption.volumeDown': 'Costs stay flat. Plumme has no cost price per product, so I cannot calculate how much of the cost falls with volume.',
  'adv.sales.scn.assumption.halveDiscounts': 'Customers buy the same at a lower discount. Calculated from discounts actually given this year.',
  'adv.sales.scn.assumption.loseTopCustomer': 'None of the revenue is replaced by other customers. Calculated from the customer’s actual posted sales.',
  'adv.sales.scn.assumption.growRecurring': 'The growth comes on top of current sales, not instead of it.',
  'adv.sales.scn.riskText.priceUp': 'If volume falls more than the price increase, the effect disappears. Watch sales volume for the first two months.',
  'adv.sales.scn.riskText.volumeDown': 'If volume falls on the most profitable customers first, the hit is larger than this.',
  'adv.sales.scn.riskText.halveDiscounts': 'Customers who buy because of the discount may leave. Test on a few first.',
  'adv.sales.scn.riskText.loseTopCustomer': 'Fixed costs do not leave with the customer, so profit is hit harder than revenue.',
  'adv.sales.scn.riskText.growRecurring': 'Recurring agreements tie you to price and delivery over time.',
  'adv.sales.scn.scopeText.all': 'All products and services',
  'adv.sales.scn.scopeText.discounted': 'Only invoices with a discount',
  'adv.sales.scn.scopeText.topCustomer': 'Only the largest customer',
  'adv.sales.scn.scopeText.recurring': 'Only recurring sales',
  'adv.sales.closerTag': 'This is what I would do',
  'adv.tab.tax': 'Tax',
  'adv.tab.budget': 'Budget',
  'adv.tab.insight': 'Insight',
  // Budget vs actual. Posted figures are year-to-date while the budget covers the whole
  // year, so the comparison is always against the budget through the current month.
  'adv.plan.title': 'Budget vs actual',
  'adv.plan.sub': '{year} — posted so far against the budget for the first {months} months',
  'adv.plan.help': 'Posted figures are year-to-date, while the budget covers the whole year. I therefore compare against the budget through the current month — otherwise everything would look far under budget in January.',
  'adv.plan.tableTitle': 'Variance by category',
  'adv.plan.tableSub': 'Budget for the first {months} months against posted',
  'adv.plan.tableHelp': 'Rows are sorted by the size of the variance. Accounts with postings but no budget are shown too — they are often the most interesting.',
  'adv.plan.col.category': 'Category',
  'adv.plan.col.budget': 'Budget so far',
  'adv.plan.col.actual': 'Posted',
  'adv.plan.col.variance': 'Variance',
  'adv.plan.unbudgeted': 'Not budgeted',
  'adv.plan.incomeVariance': 'Income variance',
  'adv.plan.costVariance': 'Cost variance',
  'adv.plan.abovePlan': 'above plan',
  'adv.plan.belowPlan': 'below plan',
  'adv.plan.overPlan': 'over plan',
  'adv.plan.underPlan': 'under plan',
  'adv.plan.separateNote': 'Income and cost variances are shown separately. Combined, a shortfall on income and a saving on cost can cancel out and look as if everything is on plan.',
  'adv.plan.noteWorse': '{name} is {amount} off in the wrong direction after {months} months. Worth a look before the gap grows over the rest of the year.',
  'adv.plan.noteBetter': '{name} is {amount} better than budgeted after {months} months.',
  'adv.plan.noteUnbudgeted': '{amount} has been posted to {name} without the account being budgeted.',
  'adv.plan.editBudget': 'Edit the budget',
  'adv.plan.noBudgetTitle': 'No budget for this year',
  'adv.plan.noBudgetText': 'Without a budget I have nothing to measure the posted figures against. Add one and I will show variances by category and flag anything drifting from plan.',
  'adv.plan.goToBudget': 'Create a budget',
  'adv.plan.notStartedTitle': 'The year has not started yet',
  'adv.plan.notStartedText': 'There are no posted months in {year} to compare the budget against.',
  // Goals. The user owns the goal; Plumme owns the measurement — the current value
  // always comes from posted figures.
  'adv.plan.goalsTitle': 'Goals',
  'adv.plan.goalsSub': 'Your own goals, measured against posted figures',
  'adv.plan.goalsHelp': 'A goal appears from its starting year until you mark it complete. A missed deadline stays visible for review. Income, profit and margin are measured separately each financial year, while the cash buffer follows the balance.',
  'adv.plan.goalsEmptyTitle': 'No goals set yet',
  'adv.plan.goalsEmptyText': 'Set a goal with a deadline — a cash buffer or a profit margin, for example — and I will track progress and tell you if you fall behind.',
  'adv.plan.goalNew': 'New goal',
  'adv.plan.goalEdit': 'Edit goal',
  'adv.plan.goalSave': 'Save goal',
  'adv.plan.goalSaved': 'Goal saved',
  'adv.plan.goalSaveFailed': 'Could not save the goal',
  'adv.plan.goalDeleted': 'Goal deleted',
  'adv.plan.goalTitleLabel': 'What is the goal?',
  'adv.plan.goalTitlePh': 'For example: build a cash buffer before year end',
  'adv.plan.goalMetricLabel': 'What should be measured?',
  'adv.plan.goalMetricHint': 'The current value comes from the accounts, not from anything you type in.',
  'adv.plan.goalTargetAmount': 'Target (kr)',
  'adv.plan.goalTargetPct': 'Target (%)',
  'adv.plan.goalNow': 'Now',
  'adv.plan.goalTarget': 'Target',
  'adv.plan.goalDeadline': 'Deadline',
  'adv.plan.goalDaysLeft': 'Days left',
  'adv.plan.goalMeasured': 'Measured against: {metric}', 'adv.plan.goalFromYear': 'From {year}',
  'adv.plan.goalReached': 'Reached',
  'adv.plan.goalCompleted': 'Completed', 'adv.plan.goalNeedsReview': 'Deadline passed – review goal',
  'adv.plan.goalComplete': 'Mark goal complete',
  'adv.plan.goalReopen': 'Reopen goal',
  'adv.plan.goalOverdue': 'Deadline passed',
  'adv.plan.goalOnTrack': 'On track',
  'adv.plan.goalBehind': 'Behind plan',
  'adv.plan.goalTracking': 'Tracking',
  'adv.plan.metric.buffer': 'Cash balance at year end',
  'adv.plan.metric.income': 'Posted revenue',
  'adv.plan.metric.result': 'Posted result',
  'adv.plan.metric.margin': 'Profit margin',
  'adv.plan.saving': 'Saving …',
  // Planned events. These are what turn the cashflow curve into an actual forecast.
  'adv.plan.eventsTitle': 'Planned events',
  'adv.plan.eventsSub': 'Known payments in and out that are not posted yet',
  'adv.plan.eventsHelp': 'Events appear in the year of their date. They do not move automatically to the next year; change the date if payment is postponed. Only upcoming, unbooked events are added to the cash flow forecast.',
  'adv.plan.eventsEmptyTitle': 'No planned events',
  'adv.plan.eventsEmptyText': 'With no events registered the cashflow curve stays flat after the current month, because it only knows posted figures.',
  'adv.plan.eventsNote': 'Events in earlier months are excluded from the curve. Remove an event once its payment is posted to avoid counting it twice.',
  'adv.plan.eventNew': 'New event',
  'adv.plan.eventEdit': 'Edit event',
  'adv.plan.eventSave': 'Save event',
  'adv.plan.eventSaved': 'Event saved',
  'adv.plan.eventSaveFailed': 'Could not save the event',
  'adv.plan.eventDeleted': 'Event deleted',
  'adv.plan.eventLabel': 'What is it?',
  'adv.plan.eventLabelPh': 'For example: holiday pay to employees',
  'adv.plan.eventKind': 'Type',
  'adv.plan.eventDate': 'Date',
  'adv.plan.eventDirection': 'Direction',
  'adv.plan.eventDirectionHint': 'Out lowers the cash balance, in raises it.',
  'adv.plan.directionOut': 'Out of the account',
  'adv.plan.directionIn': 'Into the account',
  'adv.plan.eventAmount': 'Amount',
  'adv.plan.kind.salary': 'Salary and bonus',
  'adv.plan.kind.tax': 'Tax and duties',
  'adv.plan.kind.supplier': 'Supplier payment',
  'adv.plan.kind.investment': 'Investment',
  'adv.plan.kind.loan': 'Loan and instalments',
  'adv.plan.kind.other': 'Other',
  'adv.tab.reports': 'Reports',
  // Comparison basis. Plumme holds no industry data: two of the rows are measured
  // against the company's own prior-year figures, two against a fixed threshold. The
  // card says so outright, so "0 %" is not read as an industry average.
  'adv.basisCmp.title': 'Comparison basis',
  'adv.basisCmp.sub': 'What the figures are actually measured against',
  'adv.basisCmp.help': 'The key figures below are not compared with other companies. Two are measured against the business’s own figures from the year before, and two against a fixed threshold. Each row is labelled with which of the two it is.',
  'adv.basisCmp.year': 'Financial year',
  'adv.basisCmp.against': 'Compared with',
  'adv.basisCmp.againstValue': 'Own figures from {year}',
  'adv.basisCmp.source': 'Data source',
  'adv.basisCmp.sourceValue': 'Figures posted in Plumme',
  'adv.basisCmp.industry': 'Industry data',
  'adv.basisCmp.industryValue': 'Not available',
  'adv.basisCmp.row.previousYear': 'vs {year}',
  'adv.basisCmp.row.threshold': 'vs fixed threshold',
  'adv.tab.benchmark': 'Comparison',

  'adv.hero.tag': "SuperPlumma's insight this month",
  'adv.hero.empty': 'AI Advisor needs posted income, costs and open items before it can give concrete advice.',
  'adv.hero.freeCapital': 'Available capital',
  'adv.hero.notCalculated': 'not calculated',
  'adv.hero.healthScore': 'Health score',
  'adv.hero.waiting': 'waiting',
  'adv.hero.ask': 'Ask SuperPlumma',
  'adv.hero.chatTitle': 'Chat with SuperPlumma',
  'adv.hero.chatHint': 'Chat with me',
  // Morning brief hero
  'adv.hero.briefTag': 'Monthly insight from SuperPlumma · {year}',
  'adv.hero.healthLead': 'Financial health:',
  'adv.hero.greeting.morning': 'Good morning.',
  'adv.hero.greeting.day': 'Hello.',
  'adv.hero.greeting.evening': 'Good evening.',
  'adv.hero.greetingNamed.morning': 'Good morning, {name}.',
  'adv.hero.greetingNamed.day': 'Hello, {name}.',
  'adv.hero.greetingNamed.evening': 'Good evening, {name}.',
  'adv.hero.tasksToday': '{count} things to do today',
  'adv.hero.seeAnalysis': 'See analysis',
  'adv.hero.effectNote.earlierIn': 'in sooner',
  'adv.hero.effectNote.overduePayables': 'overdue to suppliers',
  'adv.hero.effectNote.vatToCover': 'must be covered',
  'adv.hero.effectNote.vouchersAtRisk': 'purchases without receipts',
  'adv.overnight.title': 'SuperPlumma went through',
  'adv.overnight.transactions': '{count} transactions analysed',
  'adv.overnight.vouchers': '{count} receipts checked',
  'adv.overnight.risks': '{count} risks assessed',
  'adv.overnight.recommendations': '{count} recommendations found',
  'adv.overnight.updated': 'Last updated {time}',
  'adv.analysis.title': 'Open AI analysis of the accounts',
  'adv.analysis.empty': 'The analysis is not available right now.',
  // Activity feed
  'adv.feed.title': 'SuperPlumma has been watching',
  'adv.feed.sub': 'What I have noticed lately',
  'adv.feed.help': 'Changes I have spotted in your accounts — not recommendations. Red is urgent, amber should be followed up, green is just for information.',
  'adv.feed.seeDetails': 'See details',
  'adv.feed.marginDown.title': 'Profit margin is down {points} percentage points',
  'adv.feed.marginDown.body': 'Measured against last year. Worth a closer look before it becomes a trend.',
  'adv.feed.marginUp.title': 'Profit margin is up {points} percentage points',
  'adv.feed.marginUp.body': 'Measured against last year. No action needed — just good to know.',
  'adv.feed.costLineJump.title': '{name} is up {pct} %',
  'adv.feed.costLineJump.body': 'This cost line is growing faster than the rest compared with last year.',
  'adv.feed.overdueSales.title': '{amount} in receivables is overdue',
  'adv.feed.overdueSales.body': 'The money is already earned — it just has not come in yet.',
  'adv.feed.overduePurchases.title': '{amount} in supplier invoices is overdue',
  'adv.feed.overduePurchases.body': 'Overdue supplier invoices can trigger late interest and reminder fees.',
  'adv.feed.concentration.title': 'One customer accounts for {pct} % of sales',
  'adv.feed.concentration.body': 'High customer concentration leaves revenue exposed if that customer leaves.',
  'adv.feed.costsDown.title': 'Costs are down {pct} % against last year',
  'adv.feed.costsDown.body': 'No action needed — just good to know.',
  'adv.feed.incomeUp.title': 'Revenue is up {pct} % against last year',
  'adv.feed.incomeUp.body': 'Growth is calculated from posted income in the same period.',
  'adv.feed.vouchersComplete.title': 'All purchases have receipts',
  'adv.feed.vouchersComplete.body': 'Nothing here needs your attention right now.',
  // Conditional module: employees & payroll
  'adv.employees.title': 'Employees & payroll',
  'adv.employees.help': 'This module only appears because the business has employees or payroll runs. The figures come from posted payroll costs and your payroll runs.',
  'adv.employees.count': 'Employees',
  'adv.employees.share': 'Payroll cost / revenue',
  'adv.employees.cost': 'Posted payroll cost',
  'adv.employees.runs': 'Payroll runs this year',
  'adv.employees.note': 'The payroll share is calculated from posted 5000-series accounts against this year’s revenue.',
  'adv.employees.go': 'See payroll',
  // Task centre
  'adv.taskcenter.title': 'My tasks from SuperPlumma',
  'adv.taskcenter.all': 'All',
  'adv.taskcenter.empty': 'No tasks in this category.',
  'adv.status.bucket.now': 'Needs action now',
  // Advisor profile
  'adv.profile.title': 'Advisor profile',
  'adv.profile.help': 'Everything SuperPlumma knows about how you want advice — buffer, goal, risk level and frequency — in one place. You can change it all here.',
  'adv.profile.intro': 'I use this to make the advice more accurate. Changing something here changes how I prioritise — not how the accounts are kept.',
  'adv.profile.buffer': 'Desired buffer',
  'adv.profile.mainGoal': 'Main goal',
  'adv.profile.mainGoal.revenue': 'Grow revenue',
  'adv.profile.mainGoal.profitability': 'Improve profitability',
  'adv.profile.mainGoal.buffer': 'Build a cash buffer',
  'adv.profile.mainGoal.hiring': 'Hire',
  'adv.profile.mainGoal.investment': 'Invest',
  'adv.profile.mainGoal.workload': 'Reduce workload',
  'adv.profile.mainGoal.dividend': 'Get the business ready for dividends',
  'adv.profile.risk': 'Preferred risk level',
  'adv.profile.risk.cautious': 'Safe and cautious',
  'adv.profile.risk.balanced': 'Balanced',
  'adv.profile.risk.offensive': 'Open to risk',
  'adv.profile.cadence': 'How often you want advice',
  'adv.profile.cadence.daily': 'Daily',
  'adv.profile.cadence.weekly': 'Weekly',
  'adv.profile.cadence.monthly': 'Monthly',
  'adv.profile.accountantInvolved': 'Involve my accountant in proposals that need judgement',
  'adv.profile.investments': 'Planned events',
  'adv.profile.noInvestments': 'None registered',
  'adv.profile.season': 'Seasonal pattern',
  'adv.profile.seasonText': 'Strong months: {strong}. Weak months: {weak}.',
  'adv.profile.noSeason': 'Too little posted to see a pattern yet.',
  'adv.profile.learned': 'What I have learned from your choices',
  'adv.profile.nothingLearned': 'Nothing learned yet.',
  'adv.profile.saveFailed': 'Could not save the advisor profile',
  'adv.buffer.recommended': 'Recommended buffer',
  'adv.buffer.chosen': 'Chosen buffer',
  'adv.buffer.edit': 'Adjust liquidity buffer',
  'adv.buffer.editAria': 'Adjust liquidity buffer of {amount}',
  'adv.buffer.title': 'Liquidity buffer',
  'adv.buffer.auto': 'Automatic recommendation',
  'adv.buffer.autoHelp': 'SuperPlumma uses the highest calculated need. The current recommendation is {amount}.',
  'adv.buffer.custom': 'Custom amount',
  'adv.buffer.customHelp': 'Use this amount as the fixed threshold in advice, risks and cash flow.',
  'adv.buffer.amount': 'Desired buffer amount',
  'adv.buffer.basisTitle': 'Basis for the automatic recommendation',
  'adv.buffer.basisMinimum': 'Minimum level',
  'adv.buffer.basisMonthlyCosts': 'One month of costs',
  'adv.buffer.basisTax': 'Calculated tax reserve',
  'adv.buffer.basisVat': 'Upcoming VAT',
  'adv.buffer.basisHelp': 'The automatic buffer uses the highest of these amounts. It is a management threshold, not money held in a separate account.',
  'adv.buffer.saving': 'Saving …',
  'adv.buffer.saved': 'Liquidity buffer saved',
  'adv.buffer.invalid': 'Enter an amount greater than 0.',
  'adv.buffer.unavailable': 'The buffer setting is not available right now.',
  'adv.buffer.saveFailed': 'Could not save the liquidity buffer.',
  'adv.generated.kicker': 'Open AI analysis of your accounts',
  'adv.generated.daily': 'Daily advice',
  'adv.generated.monthly': 'This month',
  'adv.generated.previousMonthly': 'Previous month',
  'adv.generated.loading': 'SuperPlumma is reading the updated advisory evidence …',
  'adv.generated.updated': 'Updated {date}',
  'adv.generated.topOpportunity': 'Your biggest upside',
  'adv.generated.changes': 'What is happening right now?',
  'adv.generated.actions': 'What I would do now',
  'adv.generated.opportunities': 'Opportunities',
  'adv.generated.taxChecks': 'Tax and VAT control points',
  'adv.generated.more': 'See more opportunities and control points',
  'adv.generated.nextStep': 'Next step',
  'adv.generated.readOnly': 'The analysis is advisory only and performs no actions.',
  'adv.generated.importCoverage': 'Based on imported totals and open-item balances. Transaction-level and voucher-completeness checks are limited.',
  'adv.generated.refresh': 'Refresh advice',
  'adv.generated.failed': 'Could not refresh the AI advice now.',
  'adv.generated.unavailable': 'No AI advice is ready yet',
  'adv.generated.empty': 'There is no completed advice to show yet. Try refreshing the advice.',
  'adv.generated.limitReached': 'The monthly limit for new AI advice has been reached. Existing advice remains available, and the limit resets next month.',
  'adv.generated.todayCurrent': "Today's advice is ready",
  'adv.generated.monthCurrent': "This month's advice was updated today",
  'adv.generated.previousMonthCurrent': 'The retrospective was updated today',
  'adv.generated.noDataChanges': 'No new data',
  'adv.generated.monthCooldown': 'Updates weekly',
  'adv.generated.todayAlreadyCurrent': "Today's advice is already available. The next daily advice can be generated tomorrow.",
  'adv.generated.monthAlreadyCurrent': "This month's advice was updated today. It can be updated again tomorrow if the accounting evidence changes.",
  'adv.generated.previousMonthAlreadyCurrent': 'The retrospective was updated today. It can be updated again tomorrow if new data is posted in that period.',
  'adv.generated.noDataChangesInfo': 'There is no new accounting data since the previous advice. No AI call was used.',
  'adv.generated.monthCooldownInfo': 'The monthly advice can be updated once a week when the accounting evidence has changed.',
  'adv.generated.previousKept': 'The previous advice remains visible.',
  'adv.generated.type.booked': 'Posted fact',
  'adv.generated.type.calculated': 'Calculated',
  'adv.generated.type.scenario': 'Scenario',
  'adv.generated.type.opportunity': 'Opportunity',
  'adv.generated.type.control': 'Control point',
  'adv.generated.confidence.high': 'Strong evidence',
  'adv.generated.confidence.medium': 'Medium evidence',
  'adv.generated.confidence.low': 'Limited evidence',

  'adv.health.title': 'Financial health score',
  'adv.health.sub': "Overall assessment of the business's financial condition",
  'adv.health.help': 'A combined score is shown only when all four metrics can be calculated. Unknown values contribute no points. See the data basis for missing information.',
  'adv.health.badge.good': 'Healthy',
  'adv.health.badge.stable': 'Stable',
  'adv.health.badge.weak': 'Weak',
  'adv.health.badge.none': 'Not enough data',
  'adv.health.word.good': 'Good financial health',
  'adv.health.word.stable': 'Stable finances',
  'adv.health.word.weak': 'Needs attention',
  'adv.health.word.none': 'Preliminary assessment',
  'adv.health.emptyTitle': 'Not enough data for a health score',
  'adv.health.emptyText': 'Post sales, purchases and open items to activate the analysis.',
  'adv.health.summaryFallback': 'SuperPlumma assesses liquidity, growth, profitability and stability from your accounts.',
  'vat.wordMva': 'VAT', 'vat.wordMoms': 'VAT', 'vat.exemptMva': 'Exempt from VAT', 'vat.exemptMoms': 'Exempt from VAT', 'vat.rateLabel': '{{rate}}% {{word}}', 'vat.zeroRated': '0% {{suffix}}', 'vat.zeroRatedSuffixMva': 'exempt', 'vat.zeroRatedSuffixMoms': 'exempt', 'vat.salesReverseCharge51': '51 - Reverse charge on sales', 'vat.export52': '52 - Export',
  'adv.health.category.likviditet': 'Liquidity',
  'adv.health.category.vekst': 'Growth',
  'adv.health.category.lonnsomhet': 'Profitability',
  'adv.health.category.stabilitet': 'Stability',
  'adv.health.note.noOpenPayables': 'No open payables registered',
  'adv.health.note.noDebt': 'No debt',
  'adv.health.note.unknown': 'Unknown',
  'adv.health.note.receivablesVsPayables': 'Receivables measured against open payables',
  'adv.health.note.zeroPrevYearRevenue': "Last year's revenue is 0; percentage growth cannot be calculated",
  'adv.health.note.needsPrevYear': 'Needs prior-year figures for comparison',
  'adv.health.note.revenueChangeVsPrevYear': 'Revenue change against the same period last year',
  'adv.health.note.marginFromReport': 'Result margin from the income statement',
  'adv.health.note.noBookedRevenue': 'No booked revenue in the selected year',
  'adv.health.note.largestCustomerShare': 'Share of sales from the largest customer',
  'adv.health.note.needsInvoicesPerCustomer': 'Needs invoiced sales per customer',
  'adv.help.healthCard': 'The health score is a simple total from 0 to 100. It looks at several things at once, such as cash, income, costs and risk. It is a guide, not a verdict.',
  'adv.help.liquidity': 'This amount is open receivables minus open supplier claims. It does not show the money available in your bank account.',
  'adv.help.expectedBalance': 'Calculated planning balance at the end of the period. It is not based on a reconciled bank balance or confirmed payment dates.',
  'adv.help.expectedIn': 'Booked income in the visible window, not confirmed incoming payments.',
  'adv.help.expectedOut': 'Booked costs in the visible window, not confirmed outgoing payments.',
  'adv.help.cashBalance': 'Balance is the money available right now in this calculation.',
  'adv.help.bookedIn': 'Booked in means income or incoming payments already recorded for the period.',
  'adv.help.bookedOut': 'Booked out means costs or outgoing payments already recorded for the period.',
  'adv.help.endBalance': 'End balance is today’s balance plus money in, minus money out. It shows where cash ends in this calculation.',
  'adv.help.buffer': 'Liquidity buffer is a safety limit. It is not a separate bank account, but an amount Plumme uses to warn you when cash is getting low.',
  'adv.help.bufferMinimum': 'Minimum level is Plumme’s lowest recommended buffer. It keeps the recommendation from becoming too low when there is little history.',
  'adv.help.monthlyCosts': 'One month of costs means roughly what the business usually spends in a month. It helps you survive a slow month.',
  'adv.help.taxReserve': 'Tax reserve is money you should keep aside for tax, so the tax bill is not a surprise.',
  'adv.help.vatDue': 'Upcoming VAT is VAT that looks likely to be paid at the next VAT deadline.',
  'adv.help.buildsOn': 'These are numbers Plumme has actually found in your accounts and can use as a basis for advice.',
  'adv.help.missingData': 'These are details that are missing or thin. Adding them can make the advice more precise.',
  'adv.help.dataBasis': 'Data basis says how much Plumme knows right now. A good basis gives safer advice than a thin basis.',
  'adv.help.riskCard': 'Risk does not mean something is wrong. It means Plumme sees something worth watching before it becomes a problem.',
  'adv.help.statutoryDeadline': 'A statutory deadline is a date the authorities require you to file or pay by, such as VAT or a tax return.',
  'adv.help.effect.liquidity': 'This is about money available in the business, not necessarily higher profit.',
  'adv.help.effect.cost': 'This is money you may save by reducing or checking costs.',
  'adv.help.effect.tax': 'This is about tax, VAT or deductions. It often affects what you should set aside, but it is not binding tax advice.',
  'adv.help.effect.risk': 'This is a possible cost or loss you may avoid by following up early.',
  'adv.help.effect.income': 'This is possible increased sales or income. It is not money you already have.',
  'adv.help.effect.time': 'This is time saved in work or follow-up, not an accounting amount.',
  'adv.help.effect.other': 'The effect does not fit one standard group, so it is shown separately and is not added to other numbers.',
  'adv.help.income': 'Income is what the business has sold for before costs are deducted.',
  'adv.help.costs': 'Costs are what the business spends money on to operate, such as goods, software, rent or equipment.',
  'adv.help.result': 'Result is income minus costs. A positive result is profit; a negative result is a loss.',
  'adv.help.profitMargin': 'Profit margin shows how much of income remains as result. 20% means 20 kroner remains from every 100 kroner of income.',
  'adv.help.movement': 'Movement shows the change from the comparison period. Positive and negative must be read together with what the row is about.',
  'adv.help.revenue': 'Revenue is sales before costs are deducted. It says how much you sell for, not how much you keep.',
  'adv.help.grossProfit': 'Gross profit is income minus the direct cost of what you sold. If Plumme lacks cost price, it cannot calculate this safely.',
  'adv.help.paymentSpeed': 'Payment speed shows how quickly customers pay their invoices. Fewer days is usually better for cash flow.',
  'adv.help.discount': 'Discount is a price reduction given to the customer. High discounts can reduce profit even when sales look high.',
  'adv.help.avgInvoice': 'Average invoice is the average size of your invoices. It helps show whether sales are made of a few large or many small invoices.',
  'adv.help.topRevenue': 'Top revenue shows which products or services sold for the highest amount.',
  'adv.help.growingSales': 'Growing means sales of this have increased compared with an earlier period.',
  'adv.help.fallingSales': 'Falling means sales of this have decreased compared with an earlier period.',
  'adv.help.taxLine.tax': 'Tax is money the business or owner must pay from the result. For sole traders, this is connected to personal tax.',
  'adv.help.taxLine.liquidity': 'Liquidity in this tax choice means how the choice affects money available in the business.',
  'adv.help.taxLine.netCost': 'Net cost is what a purchase costs after the tax benefit is included in the calculation.',
  'adv.help.taxFig.taxBaseReduction': 'Tax base is the amount tax is calculated from. A lower tax base can mean lower tax, but only when the deduction is documented correctly.',
  'adv.help.taxFig.taxSaving': 'Tax saving is an estimate of how much lower the tax may become. It is not money paid out immediately.',
  'adv.help.taxFig.liquidityEffect': 'Liquidity effect shows how the choice affects cash. A purchase can save tax but still weaken cash.',
  'adv.help.taxFig.netCost': 'Net cost after tax effect shows roughly what the cost becomes after estimated tax benefit.',
  'adv.help.recommendWait': 'Wait means Plumme sees a benefit, but the timing may be poor because cash or risk is too tight.',
  'adv.help.goalNow': 'Now is the current measured value, based on booked numbers.',
  'adv.help.goalTarget': 'Target is the value you want to reach by the deadline.',
  'adv.help.incomeVariance': 'Income variance shows whether income is above or below the budget so far this year.',
  'adv.help.costVariance': 'Cost variance shows whether costs are above or below the budget so far this year.',
  'adv.help.budgetToDate': 'Budget to date is the plan for the period that has already passed, not the full annual budget.',
  'adv.help.actual': 'Actual is what has been recorded in the accounts.',
  'adv.help.variance': 'Variance is the difference between budget and actual numbers.',
  'adv.help.industry.basis.industry': 'Industry code says what type of business the company is registered as. It is used to find comparable businesses.',
  'adv.help.industry.basis.size': 'Business size groups companies by number of employees, so you are not compared with much larger companies.',
  'adv.help.industry.basis.region': 'Region says which geographic area the comparison uses.',
  'adv.help.industry.basis.year': 'Your financial year is the year of the metrics from Plumme. The industry year may be older.',
  'adv.help.industry.basis.source': 'Data source says where the comparison numbers come from.',
  'adv.help.industry.basis.peers': 'Compared with shows what kind of businesses are in the group, such as all businesses or only companies with filing obligations.',
  'adv.help.industry.basis.companies': 'Businesses in the main sample shows how many businesses the main source covers. The sample can vary by metric.',
  'adv.help.industry.metric.revenueGrowth': 'Revenue growth shows how much sales have increased or decreased compared with an earlier period.',
  'adv.help.industry.metric.liquidityRatio': 'Liquidity ratio measures whether short-term assets cover short-term debt. Higher often means better ability to pay.',
  'adv.help.industry.metric.costShare': 'Cost share shows how much of income goes to costs. Lower is often better, but not if necessary costs have been cut too hard.',
  'adv.help.industry.metric.resultMargin': 'Result margin shows how much of income remains as result.',
  'adv.help.industry.metric.payrollShare': 'Payroll share is booked costs in the 5000 account series as a share of operating income. The industry figure is a weighted average from Statistics Norway.',
  'adv.help.industry.metric.operatingMargin': 'Operating margin is operating income minus operating costs, divided by operating income. The comparison uses annual accounts from the Accounts Register.',

  'adv.prio.title': 'Tasks you can do today',
  'adv.prio.sub': 'Concrete work on invoices, documents and bank transactions',
  'adv.prio.help': 'This list contains follow-up you can perform in Plumme. Financial observations, such as budget variances and a low buffer, appear in the analysis and other tabs. Open a task for guidance and its workspace.',
  'adv.prio.why': 'Why?',
  // Effect types: what kind of financial effect the figure on a recommendation is.
  // Always shown separately, never summed — a liquidity effect is not income.
  'adv.effect.liquidity': 'Liquidity effect',
  'adv.effect.cost': 'Cost saving',
  'adv.effect.tax': 'Tax/VAT effect',
  'adv.effect.risk': 'Cost avoided',
  'adv.effect.income': 'Increased income',
  'adv.effect.time': 'Time saved',
  // Per-recommendation confidence — replaces a single overall percentage.
  'adv.confLevel.high': 'High confidence',
  'adv.confLevel.medium': 'Medium confidence',
  'adv.confLevel.low': 'Needs more data',
  'adv.confLevel.highHelp': 'Based on posted, confirmed figures for the period. The amount only changes if the accounts change.',
  'adv.confLevel.mediumHelp': 'Partly derived — for example calculated from the period so far, or compared with last year. It may adjust as more is posted.',
  'adv.confLevel.lowHelp': 'There are not enough posted figures to put a number on this yet.',
  'adv.basis.title': 'Data basis',
  'adv.basis.sub': 'This is how much I know when I advise you',
  'adv.basis.help': 'What the analysis actually builds on right now. I do not show a confidence percentage, because I only see what is posted in Plumme — never the whole picture. Filling in what is missing makes the advice more accurate.',
  'adv.basis.good': 'Good',
  'adv.basis.medium': 'Medium',
  'adv.basis.thin': 'Thin',
  'adv.prio.emptyTitle': 'No concrete tasks right now',
  'adv.prio.emptyText': 'No open tasks were found in the recorded figures. See the analysis and other tabs for financial trends and advice.',

  'adv.cal.title': 'Your financial calendar',
  'adv.cal.sub': "The most important things coming up",
  'adv.cal.help': 'Deadlines for VAT, the tax return and the annual accounts with the exact date, days remaining and the amount where it is known. Green means submitted, amber that the deadline is near, red that it has passed.',
  'adv.cal.statutory': 'Statutory deadline',
  'adv.cal.daysLeft': '{days} days left',
  'adv.cal.overdue': '{days} days overdue',
  'adv.cal.done': 'Submitted',
  'adv.cal.open': 'Open',
  // Opportunities, kept apart from what is urgent. The value is found, not banked.
  'adv.opp.title': 'Your biggest upside',
  'adv.opp.sub': 'Not problems — opportunities I think are worth a look',
  'adv.opp.help': 'Here I am not looking for mistakes but for opportunities. The amounts are marked "possible value": they have been found, not acted on, and should not be added to what you have already earned.',
  'adv.opp.possible': 'Possible value',
  // Per-recommendation status. These are the user's own notes — SuperPlumma executes
  // nothing, which is why there is no "in progress".
  'adv.status.new': 'New',
  'adv.status.snoozed': 'Snoozed',
  'adv.status.done': 'Marked done',
  'adv.status.dismissed': 'Not relevant',
  'adv.status.more': 'More options',
  'adv.status.snooze7': 'Remind me in a week',
  'adv.status.snooze30': 'Remind me in a month',
  'adv.status.markDone': 'Mark as done',
  'adv.status.notRelevant': 'Not relevant',
  'adv.status.reopen': 'Reopen',
  'adv.status.whyNotRelevant': 'Why is this not relevant?',
  'adv.status.reason.alreadyDone': 'Already done',
  'adv.status.reason.planChanged': 'The plan changed',
  'adv.status.reason.wrongAmount': 'The amount is wrong',
  'adv.status.reason.notNow': 'Not important right now',
  'adv.status.reason.notWanted': 'I do not want this kind of advice',
  'adv.status.stale': 'The figures have changed since you dealt with this, so I am raising it again.',
  'adv.status.saveFailed': 'Could not save the status',
  'adv.status.allHandledTitle': 'Nothing is waiting on you',
  'adv.status.allHandledText': 'Every recommendation is marked done, snoozed or not relevant. They are listed below if you want to reopen one.',
  'adv.status.bucket.planned': 'Snoozed',
  'adv.status.bucket.closed': 'Finished with',
  'adv.status.handoff': 'Sent for approval',
  'adv.status.bucket.waiting': 'Awaiting approval',
  // Handover to the platform router. The advisor executes nothing itself.
  'adv.handoff.start': 'Open',
  'adv.handoff.note': 'Sent to SuperPlumma for approval.',
  'adv.handoff.confirmLead': 'This is not carried out automatically. Continue below to check and finish.',
  'adv.handoff.noAdapter': 'This action has no page to finish on yet.',
  'adv.handoff.request.overdueSales': 'Draft reminders for my overdue customer invoices.',
  'adv.handoff.request.missingVouchers': 'Help me clear the purchases that are missing vouchers.',
  // Outcomes and learning. Measured against posted figures, never summed across effect
  // types, and explicit about what cannot be measured.
  'adv.outcome.title': 'What the advice led to',
  'adv.outcome.sub': 'Estimates against what actually happened',
  'adv.outcome.help': 'When you mark a recommendation as done, I lock the figure in the accounts that was supposed to change. Later I compare it with what that figure is now. Effects are kept apart — freed liquidity, cost saved and deductions secured are different quantities and are never added together.',
  'adv.outcome.marked': 'Marked done',
  'adv.outcome.wentRight': 'Went the right way',
  'adv.outcome.didNot': 'Did not land',
  'adv.outcome.notMeasurable': 'Cannot be measured',
  'adv.outcome.estimated': 'Estimated',
  'adv.outcome.actual': 'Actual',
  'adv.outcome.fromCount': 'from {count} recommendations',
  'adv.outcome.otherEffect': 'No effect type',
  'adv.outcome.reason.noMetric': 'This recommendation has no figure in the accounts to measure against.',
  'adv.outcome.reason.tooEarly': 'Too early to measure — the accounts need time to change first.',
  'adv.outcome.reason.noData': 'The measurement figure from when it was marked is missing.',
  'adv.outcome.note': 'A recommendation that did not land is the most useful feedback I get, so it is shown as plainly as the ones that worked. The measurement shows what the figure in the accounts did — it does not prove the advice caused it.',
  'adv.rec.overdueSales': 'Follow up overdue customer invoices',
  'adv.rec.vatDue': 'Set money aside for VAT',
  'adv.rec.missingVouchers': 'Upload missing vouchers',
  'adv.rec.costGrowth': 'Look at cost growth',
  'adv.rec.allClear': 'No action needed',

  'adv.docs.default': 'Show documentation',
  'adv.docs.hint': 'Charts and tables that support the analysis',
  'adv.docs.hide': 'Hide',
  'adv.docs.liquidity': 'Cash flow forecast',
  'adv.docs.costs': 'Show documentation — costs in detail',
  'adv.docs.tax': 'Show documentation — tax measures and rates',
  // Industry comparison
  'adv.industry.title': 'Comparison with similar companies',
  'adv.industry.sub': 'Your key figures against the industry',
  'adv.industry.help': 'The comparison measures the business against others with the same industry code and size band. The bands do not overlap, so every business belongs to exactly one.',
  'adv.industry.basisTitle': 'Comparison basis',
  'adv.industry.basisSub': 'What the figures are compared against',
  'adv.industry.basisHelp': 'The basis is always shown, even when the industry figures are missing — then you can see why the comparison cannot be made, instead of an empty card.',
  'adv.industry.basis.industry': 'Industry code',
  'adv.industry.basis.size': 'Company size',
  'adv.industry.basis.region': 'Region',
  'adv.industry.basis.year': 'Your financial year',
  'adv.industry.basis.source': 'Data source',
  'adv.industry.basis.companies': 'Businesses in the main sample',
  'adv.industry.source': 'Norwegian business and accounts registers',
  'adv.industry.unknown': 'Not registered',
  'adv.industry.unavailableShort': 'Not available',
  'adv.industry.wholeCountry': 'Whole country',
  'adv.industry.size.micro': '1–4 employees',
  'adv.industry.size.small': '5–19 employees',
  'adv.industry.size.medium': '20–49 employees',
  'adv.industry.size.large': '50+ employees',
  'adv.industry.median': 'Industry median',
  'adv.industry.above': 'Higher than the industry figure',
  'adv.industry.below': 'Lower than the industry figure',
  'adv.industry.equal': 'In line with the industry figure',
  'adv.industry.empty.noCompanyData.title': 'Your figures cannot be compared yet',
  'adv.industry.empty.noCompanyData.text': 'Industry figures are available, but your accounts lack valid metrics for the selected year. Check the posted accounts and try again.',
  'adv.industry.measure.median': 'Industry median',
  'adv.industry.measure.weightedAverage': 'Industry average',
  'adv.industry.sourceNote': 'The figures come from two sources. The accounts register gives a median of actual annual accounts but only covers businesses with a filing obligation. Statistics Norway’s structural business statistics covers all businesses, including sole traders, but gives a weighted average for the whole group. Each row shows which one it is based on.',
  'adv.industry.updated': 'The industry figures were last updated {date}.',
  'adv.industry.periodNote': 'Industry figures may cover an earlier financial year than your selected year. Treat the comparison as indicative, especially before the year is complete.',
  'adv.industry.metric.revenueGrowth': 'Revenue growth',
  'adv.industry.metric.liquidityRatio': 'Liquidity ratio',
  'adv.industry.metric.costShare': 'Cost share',
  'adv.industry.metric.resultMargin': 'Profit margin',
  'adv.industry.metric.payrollShare': 'Payroll share',
  'adv.industry.basis.peers': 'Compared against',
  'adv.industry.peers.limitedCompanies': 'Businesses with a filing obligation',
  'adv.industry.peers.allEnterprises': 'All businesses in the industry',
  'adv.industry.metric.operatingMargin': 'Operating margin',
  'adv.industry.measure.median.help': 'Median of the annual accounts of businesses with a filing obligation.',
  'adv.industry.measure.weightedAverage.help': 'Weighted average for the whole industry group, from Statistics Norway.',
  'adv.industry.crossFormNote': 'Most of the key figures below are measured against all businesses in the industry, from Statistics Norway’s structural business statistics. A few exist only in the annual accounts of businesses with a filing obligation — in practice limited companies. Those rows are marked, because they are not directly comparable with your business.',
  'adv.industry.skewed': 'not directly comparable',
  'adv.industry.skewedHelp': 'This key figure is affected by you taking private withdrawals instead of a salary.',
  'adv.industry.skewedNote': 'You take private withdrawals instead of a salary, so your own labour is not in the costs. A limited company books owner salary as a cost. That makes your figure look better than there is real ground for — watch the direction over time rather than the distance to the median.',
  'adv.industry.empty.noIndex.title': 'The industry figures have not been built yet',
  'adv.industry.empty.noIndex.text': 'Your industry code is registered, but Plumme has no industry index to measure you against yet. The index has to be built by fetching annual accounts for businesses in the same industry and calculating a median — that is not a lookup that can happen the moment you open this page.',
  'adv.industry.empty.noIndustryCode.title': 'We are missing your industry code',
  'adv.industry.empty.noIndustryCode.text': 'The industry code comes from the Norwegian business register when the business is verified with an organisation number. Without it I do not know which businesses to compare you with.',
  'adv.industry.empty.noIndustryCode.action': 'Go to settings',
  'adv.industry.empty.countryUnsupported.title': 'Industry figures are only available for Norway so far',
  'adv.industry.empty.countryUnsupported.text': 'The industry comparison is built on Norwegian registers. Equivalent sources for Swedish and Danish businesses are not connected yet.',
  'adv.report.monthly': 'Monthly',
  'adv.report.yearly': 'Yearly',
  'adv.report.tag.mnd': 'The month summarised',
  'adv.report.tag.aar': '{year} so far, summarised',
  'adv.docs.reports.mnd': 'Show documentation — monthly report',
  'adv.docs.reports.aar': 'Show documentation — annual report',
  'adv.recap.title': 'The period summarised',
  'adv.recap.sub': 'The essentials from the accounts, without reading the full report',
  'adv.recap.help': 'The same observations as the activity feed on Overview, laid out as a summary. Green went well, amber and red need following up. I do not derive new findings here — that would let two pages say different things about the same accounts.',
  'adv.recap.good': '{count} things went well',
  'adv.recap.watch': '{count} things to watch',
  'adv.recap.reco': 'One recommendation',
  'adv.recap.noGood': 'Nothing to celebrate in the figures yet.',
  'adv.recap.noWatch': 'Nothing needs following up right now.',
  'adv.recap.noReco': 'No recommendation is waiting for you.',
  'adv.docs.reports': 'Show documentation — monthly and annual report',
  'adv.docs.benchmark': 'Show documentation — all key figures against the comparison',


  'adv.cf.title': 'Liquidity plan',
  'adv.cf.sub': 'Calculated planning balance from open items, booked figures and planned events',
  'adv.cf.help': 'The planning balance is a calculation, not a bank balance. Net open items form the starting point, with booked income and costs and planned events changing the curve. Negative amounts show a planning shortfall.',
  'adv.cf.months': '{count} mo',
  'adv.cf.buffer': 'Net open items',
  'adv.cf.notCalculated': 'Not calculated',
  'adv.cf.expectedBalance': 'Planning balance (through {month})',
  'adv.cf.expectedIn': 'Booked income',
  'adv.cf.expectedOut': 'Booked costs',
  'adv.cf.emptyTitle': 'No cash flow forecast yet',
  'adv.cf.emptyText': 'The balance curve requires reconciled cash and bank movements. Open invoices are not cash.',
  'adv.cf.legendBalance': 'Calculated planning balance',
  'adv.cf.legendBuffer': 'Desired buffer',
  'adv.cf.tipBalance': 'Balance',
  'adv.cf.tipIn': 'In',
  'adv.cf.tipOut': 'Out',
  'adv.cf.tipBelowBuffer': 'Below desired buffer',
  // The curve is a running balance of posted figures, not a forecasting model. The copy
  // below says so outright, so a flat line after the current month is not read as a prediction.
  'adv.cf.certConfirmed': 'Posted months',
  'adv.cf.certExpected': 'Current month',
  'adv.cf.certPlanned': 'Planned events',
  'adv.cf.certUncertain': 'Nothing posted yet',
  'adv.cf.certNote': 'The last {count} months have nothing posted yet, so the line stays flat there. It shows what the balance becomes if nothing more happens — not what I think will happen.',
  'adv.cf.mathTitle': 'How I arrive at the closing balance',
  'adv.cf.mathStart': 'Planning starting point',
  'adv.cf.mathIn': 'Booked income',
  'adv.cf.mathOut': 'Booked costs',
  'adv.cf.mathAdjust': 'Rounding and adjustments',
  'adv.cf.mathEnd': 'Calculated planning balance',
  'adv.cf.simBase': 'Without action',
  'adv.cf.simAfter': 'After action',
  'adv.cf.simDiff': 'Difference',
  'adv.cf.simScenarios': '{count} scenarios',
  'adv.sim.note': 'Only actions that actually move money in or out can be simulated. Setting aside VAT moves money between your own accounts, and “build buffer” is a target — neither changes the cash balance.',
  'adv.scn.title': 'What if …',
  'adv.scn.sub': 'Try recommended actions or adjust costs and revenue. See the effect in the forecast below.',
  'adv.scn.help': 'Choose one recommended action or several scenarios. Scenarios can be combined with each other, while a recommended action is shown alone. The figures are compared with the base forecast, and the chart below updates. Nothing is carried out.',
  'adv.scn.note': 'These are calculations. The choices do not post, send or save anything.',
  'adv.scn.movesTitle': 'Recommended actions',
  'adv.scn.costTitle': 'Costs and investments',
  'adv.scn.revenueTitle': 'Revenue and customers',
  'adv.scn.noRevenueData': 'Revenue scenarios appear when revenue data is available.',
  'adv.scn.endBalance': 'Balance at period end',
  'adv.scn.lowBalance': 'Lowest balance in period',
  'adv.scn.monthsBelowBuffer': 'Months below buffer target',
  'adv.scn.turnOff': 'Turn the scenario off',
  'adv.scn.q.hire': 'I hire',
  'adv.scn.q.invest': 'I invest in …',
  'adv.scn.q.fixedCost': 'I take on a new fixed cost',
  'adv.scn.q.reduceFixedCosts': 'I reduce fixed costs',
  'adv.scn.q.priceUp': 'I raise prices',
  'adv.scn.q.revenueDown': 'Revenue falls',
  'adv.scn.q.loseTopCustomer': 'I lose my biggest customer',
  'adv.scn.row.hire': 'Employee {n}',
  'adv.scn.row.invest': 'Investment {n}',
  'adv.scn.row.fixedCost': 'Cost {n}',
  'adv.scn.addRow.hire': 'Add another employee',
  'adv.scn.addRow.invest': 'Add another investment',
  'adv.scn.addRow.fixedCost': 'Add another cost',
  'adv.scn.removeRow': 'Remove the line',
  'adv.scn.placeholder.costLabel': 'E.g. inventory or office rent',
  'adv.scn.slider.priceUp': 'Price increase',
  'adv.scn.slider.reduceFixedCosts': 'Reduction',
  'adv.scn.slider.revenueDown': 'Revenue drop',
  'adv.scn.fixedBasis': 'Selected basis: {amount} per month from up to {months} calendar months',
  'adv.scn.fixedBasisHelp': 'Accounts come from the income statement. Remove accounts that are not fixed for your business. The monthly average is an estimate; payment timing and VAT may differ.',
  'adv.scn.noFixedBasis': 'No posted amounts were found on selected accounts in this period. Check the income statement and account setup if you expected fixed costs here.',
  'adv.scn.field.startDate': 'Start date',
  'adv.scn.field.monthlySalary': 'Monthly salary',
  'adv.scn.field.socialPct': 'Employer costs (%)',
  'adv.scn.field.extraRevenue': 'Expected extra revenue/month',
  'adv.scn.field.amount': 'Amount',
  'adv.scn.field.payDate': 'Payment date',
  'adv.scn.field.financing': 'Financing',
  'adv.scn.field.equityPct': 'Equity share (%)',
  'adv.scn.field.termMonths': 'Repayment period (months)',
  'adv.scn.field.interestPct': 'Interest rate (% per year)',
  'adv.scn.field.loanType': 'Loan type',
  'adv.scn.field.costLabel': 'What is it for?',
  'adv.scn.field.monthlyAmount': 'Amount per month',
  'adv.scn.option.cash': 'Cash',
  'adv.scn.option.loan': 'Loan',
  'adv.scn.option.annuity': 'Annuity loan',
  'adv.scn.option.serial': 'Serial loan',
  'adv.scn.loan.open': 'Loan terms',
  'adv.scn.loan.summary': '{rate} % · {type} · {months} mo',
  'adv.scn.loan.title': 'Loan terms for investment {n}',
  'adv.scn.loan.done': 'Done',
  'adv.scn.loan.monthsUnit': 'mo',
  'adv.scn.loan.equityNow': 'Equity now',
  'adv.scn.loan.principal': 'Loan amount',
  'adv.scn.loan.firstPayment': 'First instalment',
  'adv.scn.loan.lastPayment': 'Last instalment',
  'adv.scn.loan.totalInterest': 'Total interest',
  'adv.scn.loan.totalPaid': 'Total paid',
  'adv.scn.loan.showPlan': 'See repayment plan',
  'adv.scn.loan.hidePlan': 'Hide repayment plan',
  'adv.scn.loan.typeHelp.annuity': 'An annuity loan has a fixed instalment. Most of the interest is paid early, and the monthly load stays the same.',
  'adv.scn.loan.typeHelp.serial': 'A serial loan has a fixed principal payment. The instalment is highest at the start and falls — heavier now, less interest in total.',
  'adv.scn.loan.note': 'The interest rate is your own estimate. The repayment plan is calculated from it, and is not a loan offer.',
  'adv.scn.plan.month': 'Term',
  'adv.scn.plan.payment': 'Instalment',
  'adv.scn.plan.interest': 'Interest',
  'adv.scn.plan.principal': 'Principal',
  'adv.scn.plan.remaining': 'Remaining debt',
  'adv.scn.summary.hire': 'A new employee from {date} costs around {cost} per month including employer costs. With expected extra revenue of {extra} per month, the cash balance changes by {net} per month from the start date. The curve below shows where the buffer ends up.',
  'adv.scn.summary.hireMany': '{count} new employees cost around {cost} per month in total including employer costs, with the first starting {date}. With expected extra revenue of {extra} per month, the cash balance changes by {net} per month once everyone is in place. The curve below shows where the buffer ends up.',
  'adv.scn.summary.investCash': 'Paying {amount} in cash drops the cash balance by the full amount that month. The curve below shows whether the buffer can take it.',
  'adv.scn.summary.investLoan': 'Of a total {amount} you pay {equity} from your own funds and borrow the rest over up to {termMonths} months. The first instalment is around {monthly}, and interest comes to {interest} across the whole repayment. The figures follow the rate you set yourself — they are not a loan offer.',
  'adv.scn.summary.fixedCost': 'A new fixed cost of {cost} per month from {date} takes {yearly} a year. The curve below shows whether the buffer can take it.',
  'adv.scn.summary.fixedCostMany': '{count} new fixed costs come to {cost} per month from {date}, or {yearly} a year. The curve below shows whether the buffer can take them.',
  'adv.scn.summary.reduceFixedCosts': '{pct}% of {base} on the selected cost accounts means an estimated {delta} less paid each month from now. The forecast shows the effect if the reduction continues.',
  'adv.scn.summary.priceUp': 'A {pct} % price increase brings in around {delta} more per month, measured against the average of the months that actually have posted income.',
  'adv.scn.summary.revenueDown': 'A {pct} % drop in revenue brings in around {delta} less per month, measured against the average of the months that actually have posted income.',
  'adv.scn.summary.loseTopCustomer': 'Your biggest customer accounts for {pct} % of sales. If they leave, you lose around {delta} per month. The curve below shows how low the buffer goes.',
  'adv.cf.commentaryFallback': 'Cash flow uses reconciled cash and bank movements.',

  'adv.cost.title': 'Cost analysis',
  'adv.cost.changeUp': 'up {pct} %',
  'adv.cost.changeDown': 'down {pct} %',
  'adv.cost.changeFlat': 'unchanged',
  'adv.cost.flagged': ' SuperPlumma has flagged this one because the increase is unusually large and should be checked.',
  'adv.cost.emptyTitle': 'No costs to analyse',
  'adv.cost.flagTitle': "SuperPlumma's cost alert",
  'adv.cost.flagHelp': 'When a cost clearly stands out — for example by growing much faster than the others — SuperPlumma highlights it here with a concrete recommendation, so you can react before it grows large.',
  'adv.cost.flagFallback': 'The largest costs',

  'adv.tax.title': 'Tax and VAT',
  'adv.tax.sub': 'Conservative checkpoints for the income year',
  'adv.tax.help': 'Checkpoints based on posted figures. This is not binding tax advice, but helps you see what should be set aside, checked or discussed with an adviser.',
  'adv.tax.rowHelp': '{desc} Effect: {effect}. Status: {saving}.',
  'adv.tax.effect': 'Tax effect',
  'adv.tax.saving': 'Expected saving',
  'adv.tax.emptyTitle': 'No tax checkpoints calculated',
  'adv.tax.emptyText': 'Tax and VAT appear once the accounts have a result, VAT or public dues to follow up.',
  'adv.tax.disclaimerTitle': 'Who is responsible?',
  'adv.tax.disclaimerHelp': 'The suggestions are automatically generated estimates and not binding tax advice. Final responsibility for what is posted and submitted always rests with the business and its accountant. Use the suggestions as a starting point for a conversation with your adviser.',
  'adv.tax.disclaimer': 'The suggestions are automatically generated estimates based on your accounting data and current rates. SuperPlumma never recommends a purchase just to save tax — liquidity and actual need always come first. Final responsibility for assessment and submission rests with the business and its accountant.',
  'adv.tax.checklist.button': 'Checklist',
  'adv.tax.checklist.title': 'Deduction Checklist',
  'adv.tax.checklist.note': 'This is a practical checklist of common deductions small businesses often miss. Deductions always require documentation, a business purpose and assessment against current rules.',
  'adv.tax.checklist.footer': 'Tip: Use the list together with your vouchers before VAT, tax return and year-end closing. Uncertain items should be checked with an accountant or official tax guidance.',
  'adv.tax.checklist.operations': 'Operations and administration',
  'adv.tax.checklist.operations.1': 'Office supplies, software, subscriptions and professional systems used in the business.',
  'adv.tax.checklist.operations.2': 'Accounting, legal assistance, bank fees, payment solutions and other professional services.',
  'adv.tax.checklist.operations.3': 'Phone, internet and home-office share when the cost can be documented and allocated fairly.',
  'adv.tax.checklist.sales': 'Sales, marketing and customers',
  'adv.tax.checklist.sales.1': 'Advertising, website, photo, design work, domains, printed material and other sales work.',
  'adv.tax.checklist.sales.2': 'Courses, conferences, memberships and professional development clearly connected to income.',
  'adv.tax.checklist.sales.3': 'Representation within the deduction rules, with attendees, purpose and voucher in place.',
  'adv.tax.checklist.travel': 'Travel and car',
  'adv.tax.checklist.travel.1': 'Business travel, parking, tolls, public transport, flights, hotels and subsistence at current rates.',
  'adv.tax.checklist.travel.2': 'Mileage log for business driving with date, purpose, from/to and kilometres.',
  'adv.tax.checklist.travel.3': 'Van, leasing, insurance, fuel and maintenance where the vehicle is actually used in the business.',
  'adv.tax.checklist.assets': 'Equipment and premises',
  'adv.tax.checklist.assets.1': 'PC, phone, tools, fixtures and other fixed assets. Large purchases may need to be capitalised and depreciated.',
  'adv.tax.checklist.assets.2': 'Rent for premises, workshop, storage, coworking or a share of premises used in the business.',
  'adv.tax.checklist.assets.3': 'Repairs, maintenance, cleaning, electricity and other premises costs that belong to operations.',
  'adv.tax.checklist.finance': 'Finance and losses',
  'adv.tax.checklist.finance.1': 'Interest, reminder fees and financing costs connected to the business.',
  'adv.tax.checklist.finance.2': 'Losses on receivables when the claim has genuinely been pursued and the loss is documented.',
  'adv.tax.checklist.finance.3': 'Currency losses, card fees and commissions related to business sales or purchases.',
  'adv.tax.checklist.people': 'Employees and helpers',
  'adv.tax.checklist.people.1': 'Salary, employer contributions, pension, insurance and staff measures within the rules.',
  'adv.tax.checklist.people.2': 'Fees to freelancers, subcontractors and hired help with proper documentation.',
  'adv.tax.checklist.people.3': 'Workwear and protective equipment when there is an occupational need, not ordinary private clothing.',
  // Tax — choice cards and proposals
  'adv.tax.insights.backToAdvisor': 'Back to AI Advisor',
  'buy.editPurchase': 'Edit purchase',
  'buy.editPurchaseHelp': 'Save changes to the posted purchase.',
  'adv.tax.choices.title': 'If this were my company',
  'adv.tax.myRecommendation': 'My recommendation:',
  'adv.tax.wait': 'Wait',
  'adv.tax.recommendWait': 'Recommendation: wait',
  'adv.tax.showCalculation': 'Show calculation',
  'adv.tax.line.tax': 'Tax',
  'adv.tax.line.liquidity': 'Liquidity',
  'adv.tax.line.netCost': 'Net cost',
  'adv.tax.fig.taxBaseReduction': 'Reduction in taxable base',
  'adv.tax.fig.taxSaving': 'Estimated tax saving',
  'adv.tax.fig.liquidityEffect': 'Liquidity effect',
  'adv.tax.fig.netCost': 'Net cost after tax effect',
  'adv.tax.rateNote.corporate': 'The tax saving is calculated at {pct} % corporate tax.',
  'adv.tax.rateNote.soleTrader': 'The tax saving is calculated at {pct} %, which is Plumme’s indicative rate for sole traders. Your actual marginal rate depends on bracket tax, national insurance and your personal circumstances.',
  'adv.tax.proposal.taxReserve.title': 'Set aside for tax',
  'adv.tax.proposal.taxReserve.desc': 'The result so far suggests reserving {amount} before private withdrawals or larger purchases. This does not lower the tax — it makes sure the money is there when the bill arrives.',
  'adv.tax.proposal.vatDue.title': 'VAT to be covered',
  'adv.tax.proposal.vatDue.desc': 'Calculated VAT from posted sales and purchases is {amount}. Check the period before submitting.',
  'adv.tax.proposal.buyAssets.title': 'Buying fixed assets before year end',
  'adv.tax.proposal.buyAssets.desc': 'You have {count} planned investment(s) totalling {amount}. The tax figures below are illustrative; check each asset’s type, use and lifetime.',
  'adv.tax.proposal.missingVouchers.title': 'Receipts you are missing',
  'adv.tax.proposal.missingVouchers.desc': '{count} booked purchases totalling {amount} are missing receipts. Check whether each purchase qualifies for a deduction or input VAT.',
  'adv.tax.calc.taxReserveBase': 'The tax buffer is {pct} % of the result so far, less prepaid tax: {amount}.',
  'adv.tax.calc.vatDueBase': 'Output VAT less input VAT for the period: {amount}.',
  'adv.tax.calc.assetCapitalize': 'The illustration treats {amount} as one qualifying asset above the direct-expensing limit ({limit}).',
  'adv.tax.calc.assetDirect': 'The illustration assumes the {amount} purchase qualifies for direct expensing below the limit ({limit}).',
  'adv.tax.calc.assetDepreciation': 'Illustration if the asset belongs to balance group d: {pct} % in the first year = {amount}.',
  'adv.tax.calc.assetSaving': '{reduction} lower taxable base × {pct} % = {saving} in tax saved.',
  'adv.tax.calc.voucherBase': '{count} booked purchases without receipts, totalling {amount} excluding VAT. This is not a calculated deduction.',
  'adv.tax.calc.voucherSaving': '{amount} in deductions × {pct} % = {saving} in tax saved, provided the receipts are obtained.',
  'adv.tax.calc.voucherVat': 'On top of that, {vat} in input VAT is at risk without documentation.',
  'adv.tax.choice.buyAssets.q': 'Buy the fixed assets before the new year?',
  'adv.tax.choice.buyAssets.reco.wait': 'Wait before buying. The forecast shows that the buffer cannot absorb the {amount} outflow now. Check the need and tax treatment for each asset before choosing the timing.',
  'adv.tax.choice.buyAssets.reco.do': 'The buffer can absorb the {amount} outflow. Buy only if the asset is needed, and check the tax treatment for each purchase. A possible tax benefit alone is not reason to buy.',
  'adv.tax.choice.buyAssets.reco.consider': 'Discuss it with your accountant. I do not have enough liquidity data to say whether the buffer can take the {amount} outflow this year.',
  'adv.tax.choice.taxReserve.q': 'Set money aside for tax now?',
  'adv.tax.choice.taxReserve.reco.do': 'Do it. {amount} is money you already owe — it just has not been set apart yet. Reserving it now means you will not have to find it when the deadline arrives.',
  'adv.tax.choice.taxReserve.reco.wait': 'Hold off briefly. The buffer is tight right now — but {amount} must be in place before the deadline.',
  'adv.tax.choice.taxReserve.reco.consider': 'Consider setting aside {amount} now, so the money is there when the deadline comes.',
  'adv.tax.choice.missingVouchers.q': 'Clear up the missing receipts?',
  'adv.tax.choice.missingVouchers.reco.do': 'Do this before the period closes. Find the {count} missing receipts and check which purchases actually qualify for a deduction or input VAT.',
  'adv.tax.choice.missingVouchers.reco.wait': 'Do this before the period closes. {count} receipts are missing; review eligibility for each purchase.',
  'adv.tax.choice.missingVouchers.reco.consider': 'Get the {count} missing receipts and assess whether the purchases qualify for a deduction.',

  'adv.report.emptyTitle': 'Reports appear here',
  'adv.report.emptyText': 'The report view is connected once the AI advisor gets backend data.',

  'adv.bench.title': 'Comparison with earlier figures',
  'adv.bench.sub': 'Your key figures against the chosen comparison basis',
  'adv.bench.help': 'Here you see your own key figures against last year or a recommended internal threshold. The label on the right tells you whether the development points the right way for each figure.',
  'adv.bench.rowHelp': 'Your business: {you} · comparison: {avg}. {verdict}{direction}',
  'adv.bench.rowBetter': 'The development is better on this measure.',
  'adv.bench.rowWorse': 'This is an area you could look into.',
  'adv.bench.higherBetter': ' Higher is better here.',
  'adv.bench.lowerBetter': ' Lower is better here.',
  'adv.bench.stronger': 'Stronger',
  'adv.bench.weaker': 'Weaker',
  'adv.bench.you': 'Your business',
  'adv.bench.comparison': 'Comparison',
  'adv.bench.emptyTitle': 'No comparison yet',
  'adv.bench.emptyText': 'Comparison requires key figures for the selected year and an earlier year or internal threshold.',
  // Narrative layer: the model sends { key, vars }, the text lives here.
  'adv.verdict.tag': 'What is happening right now?',
  'adv.verdict.liquidityBufferBreach': 'The balance calculated from posted figures is {shortfall} below the {buffer} buffer in {month}. Check upcoming payments before choosing an action.',
  'adv.verdict.liquidityOverdue': 'Customer invoices totalling {amount} are overdue and have not been recorded as paid. This may affect liquidity even if the calculated balance is above the buffer.',
  'adv.verdict.liquidityNoForwardData': 'This view has no upcoming months with a calculated balance. You can still review open items and the buffer.',
  'adv.verdict.liquidityOk': 'The calculated balance stays above the buffer in the months shown. Open items and payments not yet recorded can change the picture.',
  'adv.verdict.costSpike': '{name} is up {pct} % against the comparison period. That is the cost I would look at first.',
  'adv.verdict.costUp': 'Costs are up {pct} % against last year. No single item stands out, but the overall trend is worth a look.',
  'adv.verdict.costDown': 'Costs are down {pct} % against last year. That is good cost control.',
  'adv.verdict.costFlat': 'Costs are steady at {amount}. Nothing that needs action now.',
  'adv.verdict.costNoComparison': 'You have posted {amount} in costs. I am missing last year’s figures, so I cannot say yet whether the trend points the right way.',
  'adv.verdict.taxBoth': 'You have {vat} in VAT and {buffer} that should be set aside for tax. Make sure the money is there when the deadlines come.',
  'adv.verdict.taxVat': 'You have {vat} in VAT to cover. Set the amount aside before the due date.',
  'adv.verdict.taxBuffer': 'The result suggests setting aside {buffer} for tax before you take money out privately.',
  'adv.verdict.taxNothingDue': 'I find no VAT or tax provision falling due now. Use this tab as a checklist before filing.',
  'adv.verdict.reportProfit': 'The period gives a profit of {result} — {income} in and {costs} out.',
  'adv.verdict.reportLoss': 'The period gives a loss of {result} — {income} in and {costs} out.',
  'adv.verdict.benchAllStronger': 'You are stronger on all {total} key figures I compare. That is solid.',
  'adv.verdict.benchMixed': 'You are stronger on {better} of {total} key figures. The rest is where I would look for improvement.',
  'adv.verdict.benchAllWeaker': 'You are weaker on all {total} key figures I compare. Start with what matters most for cash flow.',
  'adv.verdict.benchNoData': 'I do not have a basis for comparing your key figures yet.',
  'adv.why.title': 'Why is it happening?',
  'adv.why.liquiditySub': 'Open items and provisions to consider alongside the calculated balance',
  'adv.liquidity.watchTitle': 'I also keep an eye on',
  'adv.liquidity.watchBelowBuffer': 'Gap to the buffer in {month}',
  'adv.liquidity.watchAboveBuffer': 'Room above the buffer in {month}',
  'adv.liquidity.watchNoBalance': 'No upcoming month with a calculated balance',
  'adv.liquidity.watchReceivables': 'Customer invoices not yet overdue',
  'adv.liquidity.watchPayables': 'Supplier invoices not yet overdue',
  'adv.liquidity.scope': 'This assessment uses posted income and costs, open items and the buffer threshold. Planned payments not recorded in Plumme are not included.',
  'adv.why.costTitle': 'This is what I noticed',
  'adv.why.whyOverdueSales': 'Overdue customer invoices',
  'adv.why.whyOverduePurchases': 'Overdue supplier invoices',
  'adv.why.whyPublicDues': 'VAT and tax provision falling due',
  'adv.why.whyCostUp': '{name} — up {pct} % against the comparison period',
  'adv.why.whyCostLargest': '{name} — your largest cost item',
  'adv.moves.title': 'If this were my company',
  'adv.moves.liquiditySub': 'Overdue items, upcoming VAT, the forecast buffer and sales documents needing follow-up.',
  'adv.moves.costTitle': 'Opportunities',
  'adv.moves.costSub': 'Money you can bring in or stop spending',
  'adv.moves.go': 'Open',
  'adv.moves.showAll': 'See all {count}',
  'adv.moves.count': '{count} items',
  'adv.moves.followup': 'Follow-up',
  'adv.moves.amount': 'Amount',
  'adv.moves.moveAcceptedOffer': 'Follow up accepted offers ({count})',
  'adv.moves.moveAcceptedOffer.note': 'No linked invoice or invoice draft',
  'adv.moves.moveFollowUpOffer': 'Follow up sent offers ({count})',
  'adv.moves.moveFollowUpOffer.note': 'Awaiting a reply or approaching expiry',
  'adv.moves.moveSendOffer': 'Send unsent offers ({count})',
  'adv.moves.moveSendOffer.note': 'Created but not sent to the customer',
  'adv.moves.moveOfferDrafts': 'Finish offer drafts ({count})',
  'adv.moves.moveOfferDrafts.note': 'Drafts that have not been issued and sent',
  'adv.moves.moveInvoiceDrafts': 'Review invoice drafts ({count})',
  'adv.moves.moveInvoiceDrafts.note': 'Drafts that are at least seven days old',
  'adv.moves.moveChaseOverdue': 'Chase the overdue customer invoices',
  'adv.moves.moveSetAsideVat': 'Set VAT aside before the due date',
  'adv.moves.moveBuildBuffer': 'Build the buffer before {month}',
  'adv.moves.movePayOverdue': 'Pay the overdue supplier invoices',
  'adv.moves.moveReviewCost': 'Review {name}',
  'adv.moves.moveFixVouchers': 'Upload {count} missing vouchers',
  'adv.moves.moveWatchCosts': 'No cost action needed now',
  'adv.gain.gainCashflow': 'better cash flow',
  'adv.gain.gainAvoidInterest': 'you avoid late-payment interest',
  'adv.gain.gainToBuffer': 'short of the buffer',
  'adv.gain.gainAvoidFees': 'you avoid fees and reminders',
  'adv.gain.gainCostIncrease': 'the increase against the comparison period',
  'adv.gain.gainDeductionRisk': 'deductions you risk losing without vouchers',
  'adv.gain.gainNoActionNeeded': 'costs are under control',
  'adv.monitor.title': 'SuperPlumma is monitoring',
  'adv.monitor.sub': 'This is what I check every time the figures change',
  'adv.monitor.help': 'The checks SuperPlumma runs automatically against the accounts. Green means the check is fine right now, amber that something should be looked at.',
  'adv.monitor.monitorLiquidity': 'Liquidity buffer',
  'adv.monitor.monitorOverdueSales': 'Overdue customer invoices',
  'adv.monitor.monitorOverduePurchases': 'Overdue supplier invoices',
  'adv.monitor.monitorVat': 'VAT falling due',
  'adv.monitor.monitorVouchers': 'Vouchers on purchases',
  'adv.monitor.monitorConcentration': 'Customer dependence',
  'adv.monitor.group.liquidity': 'Liquidity',
  'adv.monitor.group.receivables': 'Incoming payments',
  'adv.monitor.group.costs': 'Costs and suppliers',
  'adv.monitor.group.tax': 'Tax and deadlines',
  'adv.monitor.group.quality': 'Bookkeeping quality',
  'adv.monitor.group.sales': 'Sales and profitability',
  'adv.monitor.detail.liquidityBelow': 'The balance calculated from posted figures is below the {amount} buffer in month {month}.',
  'adv.monitor.detail.liquidityOk': 'The balance calculated from posted figures stays above the selected buffer in upcoming months.',
  'adv.monitor.detail.liquidityNoData': 'No upcoming months have a calculated balance in the selected period.',
  'adv.monitor.detail.receivablesOld': '{amount} is overdue; the oldest claim is {days} days old.',
  'adv.monitor.detail.receivablesOverdue': '{amount} in customer receivables is overdue.',
  'adv.monitor.detail.receivablesSlower': 'Customers take an average of {days} more days to pay.',
  'adv.monitor.detail.receivablesOk': 'No overdue customer receivables require follow-up.',
  'adv.monitor.detail.receivablesNoData': 'There is not enough sales data to assess incoming payments.',
  'adv.monitor.detail.costsSupplierOverdue': '{amount} in supplier claims is overdue.',
  'adv.monitor.detail.costsSupplierDependency': '{name} accounts for {pct}% of this year’s costs.',
  'adv.monitor.detail.costsBudgetOver': 'Costs are {pct}% above budget so far.',
  'adv.monitor.detail.costsIncrease': 'Costs are up {pct}% against the comparable period.',
  'adv.monitor.detail.costsOk': 'No material cost or supplier deviations.',
  'adv.monitor.detail.costsNoData': 'There is not enough cost data to assess deviations.',
  'adv.monitor.detail.taxDeadline': 'Deadlines requiring follow-up: {count}.',
  'adv.monitor.detail.taxVat': 'Calculated VAT to cover is {amount}.',
  'adv.monitor.detail.taxOk': 'No calculated VAT amount or near deadline requires action.',
  'adv.monitor.detail.taxNoData': 'There is not enough accounting data to assess VAT and tax.',
  'adv.monitor.detail.qualityVouchers': '{count} posted purchases are missing vouchers.',
  'adv.monitor.detail.qualityBank': '{count} bank lines have not been fully reconciled.',
  'adv.monitor.detail.qualityStale': 'The latest accounting activity is {days} days old.',
  'adv.monitor.detail.qualityImportedAggregate': 'Imported totals can be analysed, but voucher completeness cannot be checked without transaction details.',
  'adv.monitor.detail.qualityNoData': 'There is not enough activity in the selected year to assess quality.',
  'adv.monitor.detail.qualityOk': 'Vouchers and any bank lines look tidy.',
  'adv.monitor.detail.salesBudgetBelow': 'Revenue is {pct}% below budget so far.',
  'adv.monitor.detail.salesRevenueDrop': 'Revenue is down {pct}% against the comparable period.',
  'adv.monitor.detail.salesNegativeMargin': 'The result margin is {pct}%.',
  'adv.monitor.detail.salesCustomerDependency': '{name} accounts for {pct}% of this year’s revenue.',
  'adv.monitor.detail.salesOk': 'No material deviations in sales or profitability.',
  'adv.monitor.detail.salesNoData': 'There is not enough sales data to assess the trend.',
  'adv.conf.buildsOn': 'Builds on',
  'adv.conf.missing': 'Missing',
  'adv.conf.nothingYet': 'No posted figures yet',
  'adv.conf.nothingMissing': 'Nothing missing',
  'adv.conf.postedIncome': 'Posted income',
  'adv.conf.postedCosts': 'Posted costs',
  'adv.conf.openItems': 'Open items',
  'adv.conf.previousYear': 'Last year’s figures',
  'adv.conf.customerSplit': 'Sales per customer',
  'adv.conf.completeVouchers': 'Complete vouchers',
  'adv.conf.importedVoucherDetails': 'Transaction details for imported vouchers',
  'adv.why.recWhyOverdueCash': 'The money is already earned — it is just unpaid',
  'adv.why.recWhyOverdueBuffer': 'The forecast falls below your buffer without these payments',
  'adv.why.recWhyVatDeadline': 'VAT falls due on a fixed term and cannot be postponed',
  'adv.why.recWhyVatInterest': 'Late payment means late-payment interest and fees',
  'adv.why.recWhyVoucherDeduction': 'Without a voucher the deduction can be struck out on inspection',
  'adv.why.recWhyVoucherAudit': 'The Bookkeeping Act requires documentation for every entry',
  'adv.why.recWhyCostGrowth': 'Costs are growing {pct} % against last year',
  'adv.chat.placeholder': 'Write a message …',
  'adv.chat.send': 'Send',
  'adv.chat.fallbackToast': 'SuperPlumma answered with a local fallback.',
  'adv.chat.limitReached': 'This conversation has reached the limit of {max} questions. Start a new conversation to continue.',
  'adv.chat.limitNear': '{left} questions left in this conversation.',
  'adv.chat.newChat': 'Start new conversation',
  'adv.chat.business.intro': 'Hi! I am SuperPlumma, your financial advisor. I have been through your business accounts and can answer whatever you are wondering about — liquidity, costs, tax or the health score. What would you like to look at?',
  'adv.chat.business.sugg1': 'How can I improve liquidity?',
  'adv.chat.business.sugg2': 'Where can I cut costs?',
  'adv.chat.business.sugg3': 'Explain my health score',
  'adv.chat.business.sugg4': 'When is VAT due?',
  'adv.chat.private.intro': 'Hi! I am SuperPlumma, your personal advisor. I have looked at your finances and can help you with saving, loans, deductions, pension and the tax return. What is on your mind?',
  'adv.chat.private.sugg1': 'Where can I save money?',
  'adv.chat.private.sugg2': 'Should I refinance the mortgage?',
  'adv.chat.private.sugg3': 'Which deductions can I claim?',
  'adv.chat.private.sugg4': 'How am I doing for pension?',
  'adv.reply.private.saving': 'I need connected personal finance data before I can point to concrete savings. Once data is ready, I can show fixed charges, subscriptions and unusual costs.',
  'adv.reply.private.loan': 'I can assess loans and interest once loan data is connected. For now, concrete loan advice should be checked against bank offers and the actual loan agreement.',
  'adv.reply.private.tax': 'I can help with tax once relevant private transactions and deduction basis are connected. Use the answer as a checkpoint, not as binding tax advice.',
  'adv.reply.private.pension': 'Pension advice requires income, pension and savings data. Once that is available, I can show the development and possible adjustments.',
  'adv.reply.private.score': 'The personal health score is calculated once the personal finance model has enough data.',
  'adv.reply.private.default': 'Good question! I can help you with saving, loans, deductions, pension and the tax return. What would you like to start with?',
  'adv.reply.business.liquidity': 'I need access to the backend advisor to give concrete liquidity figures. Once it is available, I use open customer receivables, supplier claims and reported monthly data.',
  'adv.reply.business.costs': 'Cost advice should build on posted cost lines and comparison against earlier years. Try again once the SuperPlumma backend is available.',
  'adv.reply.business.tax': 'Tax and VAT must be calculated from posted figures. I do not give concrete amounts in the local fallback, but the backend advisor can fetch this from the report model.',
  'adv.reply.business.score': 'The health score is calculated from actual liquidity, growth, profitability and stability once the advisor model is available.',
  'adv.reply.business.invoices': 'Invoice follow-up requires open invoices from the backend. Once data is ready, I can show which items should be followed up first.',
  'adv.reply.business.default': 'Good question. I can answer concretely once the SuperPlumma backend is available; the local fallback only shows general advice without accounting figures.',
  // ------------------ Travel, suppliers, guided bank reconciliation
  'trv.sub': 'Travel claims, mileage allowance and expenses submitted from the employee portal. Private expenses go to the next payroll run — company card/operating account is posted directly and kept out of payroll.',
  'trv.allEmployees': 'All employees',
  'trv.searchPh': 'Search by trip, purpose or employee',
  'trv.noTravel': 'No travel here yet',
  'trv.noTravelHelp': 'When employees submit travel or expenses from the employee portal, they appear here.',
  'trv.backToOverview': 'Back to the overview',
  'trv.approveTravel': 'Approve travel',
  'trv.trips': 'Trips',
  'trv.tripsHelp': 'Mileage allowance at the state rate.',
  'trv.noTrips': 'No trips registered.',
  'trv.expenseHelp': 'Private expenses are refunded through payroll. Company card/operating account is posted directly.',
  'trv.noExpenses': 'No expenses registered.',
  'trv.toPayroll': 'To payroll',
  'trv.mileageAllowance': 'Mileage allowance',
  'trv.tollsPrivate': 'Tolls (private)',
  'trv.privateExpenses': 'Private expenses',
  'trv.postingSuggestion': 'Suggested posting',
  'trv.owedToEmployee': 'Salary payable / employee refund',
  'trv.previewComing': 'A preview of the travel claim and attachments will appear here.',
  'trv.privateRefundOf': 'Private refund of',
  'trv.reasonShownToEmployee': 'The reason is shown to the employee in the employee portal.',
  'trv.reason': 'Reason',
  'trv.whatMustBeFixed': 'What must be corrected before the travel or expense can be approved?',
  'trv.subShort': 'Travel claims, mileage allowance and expenses linked to employees. Private expenses go to the next payroll run - company card/operating account is posted directly and kept out of payroll.',
  'trv.newTravel': 'New travel',
  'trv.getStarted': 'Register a trip or an expense to get started.',
  'trv.submitTravel': 'Submit travel',
  'trv.reject': 'Reject',
  'trv.accommodation': 'Accommodation',
  'trv.subsistenceHelp': 'Subsistence allowance for overnight stays is calculated at the state rates and paid tax free to the employee.',
  'trv.noAccommodation': 'No accommodation registered.',
  'trv.subsistenceOvernight': 'Subsistence (overnight)',
  'trv.optionalNotePh': 'Optional note, project or reference',
  'trv.editTravel': 'Edit travel',
  'trv.pickDate': 'Choose date',
  'trv.route': 'Route',
  'trv.kilometreCount': 'Number of kilometres',
  'trv.sameRouteReturn': 'Use the same route for the return trip',
  'trv.pickVehicle': 'Choose vehicle',
  'trv.tollsNok': 'Tolls (NOK)',
  'trv.paymentMethod': 'Payment method',
  'trv.companyCardOperating': 'Company card (operating account)',
  'trv.vatOnReceipt': 'VAT on the receipt',
  'trv.vatNone': 'None / no deduction',
  'trv.enterPassengerName': 'Enter the passenger name',
  'trv.enterKilometres': 'Enter the number of kilometres',
  'trv.kmWithTrailer': 'Kilometres with a trailer',
  'trv.kmForestRoad': 'Kilometres on forest and construction roads',
  'trv.newStay': 'New stay',
  'trv.stayType': 'Type of stay',
  'trv.otherAccommodationCooking': 'Other accommodation with cooking facilities',
  'trv.mealsPaidYourself': 'Meals you paid for yourself',
  'trv.pickForWholeStay': 'Select for the whole stay',
  'trv.breakfast': 'Breakfast',
  'trv.lunch': 'Lunch',
  'trv.dinner': 'Dinner',
  'trv.vehicle': 'Vehicle',
  'trv.paymentMethod2': 'Payment method',
  'trv.requiredBeforeRegister': 'A description, an amount and at least one attachment are required before you can register.',
  'trv.companyCardDirectHelp': 'Company card/operating account is posted directly and kept out of the payroll run.',
  'registry.toggle': 'Search the company registry',
  'registry.toggleHelp': 'Suggests companies as you type. Turn off for private customers.',
  'registry.searching': 'Searching the company registry...',
  'registry.needNineDigits': 'Enter 9 digits to look up a company number.',
  'registry.noHits': 'No hits in the company registry.',
  'registry.failed': 'Company registry lookup failed.',
  'sup.invoices': 'Supplier invoices',
  'sup.invoicesHelp': 'All invoices and credit notes from this supplier. "Unpaid" is open accounts payable, "Paid" is settled, and a credit note is a refund or correction from the supplier.',
  'sup.noInvoicesMatch': 'No supplier invoices matched the filter.',
  'sup.seeVoucher': 'View voucher',
  'sup.goTo': 'Go to',
  'sup.number': 'Supplier no.',
  'sup.numberShort': 'No.',
  'sup.numberPh': 'E.g. 20001',
  'sup.name': 'Supplier name',
  'sup.emailPh': 'invoice@supplier.com',
  'sup.addressPh': 'Street address, postal code and place',
  'sup.searchPh': 'Search suppliers ...',
  'sup.searchListPh': 'Search supplier or amount',
  'sup.searchHelp': 'Search suppliers by number, name, company number, contact details, total purchases or outstanding amount.',
  'sup.totalPurchases': 'Total purchases',
  'sup.mergeTitle': 'Merge suppliers',
  'sup.mergeIntro': 'Have you created the same supplier twice?',
  'sup.mergeSwap': 'Swap which supplier is kept',
  'sup.sameInvoiceNumber': 'The same invoice number is registered on both suppliers.',
  'sup.checkDuplicates': 'Check that the purchases are not duplicates before you merge.',
  'sup.exportCsv': 'Suppliers CSV',
  'sup.exportExcel': 'Suppliers Excel',
  'sup.ledgerCsv': 'Supplier ledger CSV',
  'sup.ledgerExcel': 'Supplier ledger Excel',
  'sup.whoYouBuyFrom': 'Who you buy from',
  'sup.outstandingHelp': 'How much you owe the supplier right now — the total of unpaid supplier invoices (accounts payable). If it says 0, you have no open invoices with this supplier.',
  'sup.totalPurchasesHelp': 'The total amount you have purchased from this supplier — both paid and unpaid invoices.',
  'sup.balance.youOwe': 'You owe the supplier {amount}',
  'sup.balance.supplierOwes': 'The supplier owes you {amount}',
  'sup.ledger.empty': 'No ledger rows yet.',
  'sup.status.posted': 'Posted',
  'sup.status.partial': 'Partially paid',
  'sup.status.unpaid': 'Unpaid',
  'sup.status.credit': 'Credit note',
  'sup.status.invoice': 'Invoice',
  'sup.filter.all': 'All',
  'sup.sheet.suppliers': 'Suppliers',
  'sup.sheet.ledger': 'Supplier ledger',
  'sup.export.internalId': 'Internal ID',
  'sup.ledger.type.supplierInvoice': 'Supplier invoice',
  'sup.ledger.type.payment': 'Supplier payment',
  'sup.ledger.type.importedInvoice': 'Imported supplier invoice',
  'sup.excelUnavailable': 'Excel export is not available yet.',
  'sup.voucherUnderTransactions': 'The voucher is under Transactions.',
  'sup.voucherFallbackName': 'Voucher',
  'sup.voucherViewNotConnected': 'Viewing the voucher is not connected to the backend.',
  'sup.cannotShowVoucher': 'Could not show the voucher.',
  'sup.cannotFetchVoucher': 'Could not fetch the voucher from the backend.',
  'sup.previewVoucher': 'Preview the voucher',
  'sup.noVoucherUploaded': 'No voucher uploaded',
  'sup.nameRequired': 'Supplier name must be filled in.',
  'sup.saveFailed': 'Could not save the supplier.',
  'sup.editTitle': 'Update supplier',
  'sup.updateAction': 'Update',
  'sup.saveAction': 'Save',
  'sup.defaultDueDaysLabel': 'Default payment term (days)',
  'sup.defaultCostAccountLabel': 'Default cost account',
  'sup.defaultSettlementAccountLabel': 'Default payment account',
  'sup.costAccountPh': 'e.g. 6300',
  'sup.settlementAccountPh': 'e.g. 1920',
  'sup.mergePickerPlaceholder': 'Choose supplier ...',
  'sup.mergeKeep': 'Kept',
  'sup.mergeRemove': 'Merged and removed',
  'sup.mergeSuccess': 'The suppliers were merged',
  'sup.mergeBackendNotReady': 'Backend merge is not ready.',
  'sup.mergeFailed': 'Could not merge the suppliers.',
  'sup.merging': 'Merging...',
  'sup.mergeAction': 'Merge suppliers',
  'sup.mergeModalIntro': 'Choose the duplicate. Purchases and invoices move to the supplier that is kept, and the other supplier is removed.',
  'sup.mergeFieldLabel': 'Which supplier is the same as {name}?',
  'sup.mergeMoreInvoiceNumbers': '+ {count} more invoice numbers',
  'sup.noSuppliersToExport': 'No suppliers to export',
  'sup.exportListFailed': 'Could not export the supplier list.',
  'sup.exportListDone': 'Supplier list downloaded',
  'sup.noLedgerRowsToExport': 'No ledger rows to export',
  'sup.exportLedgerFailed': 'Could not export the supplier ledger.',
  'sup.exportLedgerDone': 'Supplier ledger downloaded',
  'sup.updated': 'Supplier updated',
  'sup.saved': 'Supplier saved',
  'sup.archived': 'Supplier moved to archive',
  'sup.archiveFailed': 'Could not archive the supplier.',
  'sup.reopened': 'The supplier was reopened',
  'sup.reopenFailed': 'Could not reopen the supplier.',
  'sup.titleHelp': 'The supplier register collects everyone you buy from — name, company number, contact details and account numbers for payouts. When you register purchases and supplier invoices, they are linked to the right supplier here.',
  'sup.downloadHelp': 'Download the supplier list or supplier ledger as CSV or Excel.',
  'sup.addHelp': 'Create a new supplier manually. Fill in the name and company number, then you can link purchases and invoices to it. New suppliers are often created automatically when you post a purchase.',
  'sup.col.name': 'Supplier',
  'sup.reopenAction': 'Reopen',
  'sup.archiveAction': 'Archive',
  'sup.mergeHelp': 'Merge two suppliers into one. Useful when the same supplier is registered more than once. All history and invoices move to the supplier you keep.',
  'sup.enterName': 'Enter a supplier name.',
  'sup.registryNotConnected': 'The supplier register is not connected to the backend.',
  'sup.saveSuccess': 'The supplier was saved.',
  'sup.saveSupplierAction': 'Save supplier',
  'bg.stepsHelp': 'The steps take you through one task at a time. A tick means the check is done; a number shows what still needs attention.',
  'bg.balanceDiscrepancy': 'Balance discrepancy',
  'bg.notCorrect': 'Not correct',
  'bg.reconciliationDone': 'The bank reconciliation is complete',
  'bg.reconciliationDoneHelp': 'The statement has been reviewed, posted and moved to the archive.',
  'bg.bankLines': 'Bank lines',
  'bg.reconciled': 'Reconciled',
  'bg.backToBank': 'Back to Bank',
  'bg.reopenReconciliation': 'Reopen the reconciliation',
  'bg.bankAccountCaps': 'BANK ACCOUNT',
  'bg.periodCaps': 'PERIOD',
  'bg.balanceAtStart': 'Balance at the start of the period',
  'bg.balanceAtEnd': 'Balance at the end of the period',
  'bg.balancesMatch': 'The balances match.',
  'bg.roundingHelp': 'This can be posted to rounding account 7770 without changing the amount from the bank statement.',
  'bg.balancesMatchContinue': 'The balances match – continue',
  'bg.suggestionsHeading': 'SuperPlumma has matched and suggested postings — you decide',
  'bg.noSuggestions': 'No suggestions are waiting for approval.',
  'bg.continueToRest': 'Continue to the rest',
  'bg.noPostedDiscrepancies': 'No posted entries create a discrepancy.',
  'bg.checkAndFix': 'Check and correct the entries before the period is completed.',
  'bg.allPaymentsHandled': 'All payments have been handled.',
  'bg.continueToVouchers': 'Continue to vouchers',
  'bg.allPurchasesDocumented': 'All purchases have the necessary documentation or are marked as without a voucher.',
  'bg.seePurchase': 'View the purchase',
  'bg.withoutVoucher': 'Without a voucher',
  'bg.linkSuggested': 'Link the suggested one',
  'bg.pickVoucher': 'Choose voucher',
  'bg.continueToFinish': 'Continue to completion',
  'bg.bankLinesTotal': 'Bank lines in total',
  'bg.linkedPosted': 'Linked/posted',
  'bg.privateMovements': 'Private movements',
  'bg.reconcileAndArchive': 'Reconcile and archive',
  'bg.backAndCheck': 'Go back and check',
  'bg.stepModeHelp': 'Step by step takes you through one task at a time. Full overview shows everything together.',

  // ---------------------------- My page, budget, AI Advisor
  'acc.sub': 'Your profile and the businesses you have access to.',
  'acc.signOutHelp': 'Signs you out of Plumme. You must sign in again with your email and password to continue.',
  'acc.yourRole': 'Your role',
  'acc.yourRoleHelp': 'The role decides what you can do: Owner has full access, Administrator manages operations, Accountant keeps the books, and Reader can only view. The role can differ from business to business.',
  'acc.editProfile': 'Edit profile',
  'acc.myBusinesses': 'My businesses',
  'acc.myBusinessesHelp': 'The businesses you have access to in Plumme. The label shows your role in each one. Select a business to open its accounts.',
  'acc.personalFinanceHelp': 'Personal finances is a separate client type for personal and household finances, kept apart from the business accounts.',
  'acc.goToPersonalFinance': 'Go to personal finances',
  'acc.ownPersonalClient': 'Own personal finance client',
  'acc.myEmployers': 'My employers',
  'acc.myEmployersHelp': 'Businesses you are employed by (not necessarily keep accounts for). Here you will find payslips, contracts and your own employee page.',
  'acc.employerPortalAccess': 'Businesses you have employee portal access to.',
  'acc.changePicture': 'Change picture',
  'acc.removePicture': 'Remove picture',
  'acc.photoUploading': 'Uploading …',
  'acc.photoRemoving': 'Removing …',
  'acc.photoSaved': 'Your profile picture has been updated.',
  'acc.photoRemoved': 'Your profile picture has been removed.',
  'acc.photoWrongType': 'Choose a PNG, JPG or WebP image.',
  'acc.photoEmpty': 'The image file is empty.',
  'acc.photoTooLarge': 'The image is too large. Max 2 MB.',
  'acc.photoUploadFailed': 'Could not upload the profile picture.',
  'acc.photoRemoveFailed': 'Could not remove the profile picture.',
  'acc.photoUnavailable': 'Profile pictures are not available right now.',
  'acc.fullName': 'Full name',
  'acc.phoneFromLogin': 'Phone from your login',
  'acc.changePassword': 'Change password',
  'acc.changes': 'Changes',
  'acc.noChangeDetails': 'No extra change details are stored for this event.',
  'acc.logSub': 'What has been done in the accounts - and by whom.',
  'acc.logFilterHelp': 'Filter the log by period, area (for example Invoice, Payroll, VAT) and which user performed the action.',
  'acc.area': 'Area',
  'acc.areaHelp': 'Which part of the accounts the action concerns - for example Invoice, Purchase, Payroll or VAT. One action can touch several areas.',
  'acc.user': 'User',
  'acc.userHelp': 'The person who performed the action, with their role. That way you can see who is behind each change.',
  'acc.sentLinkTo': 'We have sent a link to',
  'bud.annualBudget': 'Annual budget',
  'bud.suggestion': 'Budget suggestion',
  'bud.createSuggestion': 'Create a suggestion',
  'bud.startSimpleQuestions': 'Start with simple questions',
  'bud.fillRelevant': 'Fill in only what is relevant. Monthly amounts are converted to an annual budget.',
  'bud.businessDescription': 'Description of the business',
  'bud.businessDescriptionPh': 'E.g. a transport agency for 2027 with 2 vans, 2 employees, office rent of 8,000/month and more income in the summer.',
  'bud.howToBudget': 'How to build a budget',
  'bud.howToBudgetHelp': 'Choose a method: with "Manual" you enter the accounts yourself, with "Suggestion" you answer a few simple questions and get a draft, and with "AI suggestion" you describe the business in your own words and Plumme creates a draft.',
  'bud.budgetedResult': 'Budgeted result',
  'bud.budgetedResultHelp': 'The result you have budgeted for the whole year — budgeted income minus budgeted costs. This is the target you are steering towards.',
  'bud.actualResult': 'Actual result',
  'bud.actualResultHelp': 'The actual result posted so far this year — real income minus real costs. Compare it with the budget to see whether you are on track.',
  'bud.postedSoFar': 'posted so far',
  'bud.varianceToPeriod': 'Variance against the period',
  'bud.varianceToPeriodHelp': 'The difference between the actual and the budgeted result so far. A negative variance means you are below budget, a positive one that you are above.',
  'bud.incomeTarget': 'Income target',
  'bud.incomeTargetHelp': 'How much of the budgeted income for the year you have reached so far — actual invoiced income divided by budgeted income.',
  'bud.ofTargetReached': 'of the target reached',
  'bud.viewHelp': 'Switch view: "Overview" shows the accumulated result and the largest variance, "Analysis" shows income against costs and the result per month, and "Budget by category" is where you enter and change the amounts.',
  'bud.accumulatedResult': 'Accumulated result',
  'bud.accumulatedResultHelp': 'The chart shows the result building up month by month through the year. The dashed line is the budget, the solid one is what is actually posted — that way you can see whether you are following the plan.',
  'bud.budgetAtYearEnd': 'Budget at year end',
  'bud.accumulated': 'accumulated',
  'bud.actualSoFar': 'Actual so far',
  'bud.posted': 'posted',
  'bud.varianceSoFar': 'Variance so far',
  'bud.largestVariance': 'Largest variance',
  'bud.largestVarianceHelp': 'The account that deviates most from the budget so far this year. Useful for quickly seeing where you are most over or under what you planned.',
  'bud.soFarThisYear': 'so far this year',
  'bud.incomeVsCost': 'Income vs. costs per month',
  'bud.incomeVsCostHelp': 'The bars show income (green) against costs (amber) for each month. Switch between actual figures, budgeted figures, or both. Tap a month to total a selection.',
  'bud.resultPerMonth': 'Result per month',
  'bud.resultPerMonthHelp': 'Shows the result (income minus costs) for each individual month, budget against actual. Bars above the centre line are a profit, below is a loss.',
  'bud.actual': 'Actual',
  'bud.actualByCategory': 'Actual by category',
  'bud.actualByCategoryHelp': 'Posted income and costs per account, split by month. The figures come from your accounts — both entries you registered in Plumme and figures from an import — and update on their own.',
  'bud.noActuals': 'No posted figures for {year} yet.',
  'bud.actualOnlyHint': 'These are actual figures. Add a budget under Budget if you want to measure against a plan.',
  'bud.byCategory': 'Budget by category',
  'bud.addIncome': 'Add income',
  'bud.addIncomeHelp': 'Add an income category with an annual amount — for example expected sales. The amount is spread across the months, which you can adjust.',
  'bud.addCost': 'Add cost',
  'bud.addCostHelp': 'Add a cost category with an annual amount — for example rent, purchases or software. The amount is spread across the months, which you can adjust.',
  'bud.noCategories': 'No budget categories yet. Add income or a cost.',
  'bud.useLastYear': 'Use last year',
  'bud.simpleQuestions': 'Simple questions',
  'bud.byCategoryHelp': 'Each row is a budget category. The amounts for all 12 months are always visible and editable directly in the table, with the annual total on the right.',
  'bud.total': 'Total',
  'bud.annualTotal': 'Annual total',
  'bud.annualTotalHelp': 'Editing this figure directly spreads the new annual amount evenly across all 12 months.',
  'bud.save': 'Save',
  'bud.methodManual': 'Manual',
  'bud.methodSuggestion': 'Suggestion',
  'bud.methodAi': 'AI suggestion',
  'bud.modeBudgeted': 'Budgeted',
  'bud.modeBoth': 'Both',
  'bud.forWholeYear': 'for all of {year}',
  'bud.underBudget': 'under budget',
  'bud.overBudget': 'over budget',
  'bud.legendBudgetDashed': '- - Budget',
  'bud.legendBudgetSolid': '— Budget',
  'bud.legendActual': '— Actual',
  'bud.noVarianceYet': 'No variance yet',
  'bud.savedToast': 'Budget saved',
  'bud.saveFailedToast': 'Could not save budget',
  'bud.aiModalTitle': 'AI budget for {year}',
  'bud.aiDraftBusy': 'Creating draft...',
  'bud.aiDraftCreate': 'Create draft with AI',
  'bud.aiDescription': 'Describe the business in your own words: employees, salaries, assets, fixed costs and seasonal variation. The more detail, the better the draft.',
  'bud.aiDraftFailedGeneric': "I couldn't create a budget draft from the description. Add more detail, or use Suggestion.",
  'bud.aiDraftAppliedToast': 'AI draft added. Press Save when it looks right.',
  'bud.aiDraftFailed': 'AI budget draft failed.',
  'bud.suggestionIntro': "Create a suggestion from last year's actual figures, or answer a few simple questions for a starter budget.",
  'bud.catSales': 'Sale of goods and services',
  'bud.catPurchases': 'Purchases and direct costs',
  'bud.catPremises': 'Premises',
  'bud.catSoftware': 'Software and equipment',
  'bud.catAccounting': 'Accounting and advisory',
  'bud.catTravel': 'Travel',
  'bud.catMarketing': 'Marketing',
  'bud.catCommunication': 'Phone, postage and communication',
  'bud.otherCosts': 'Other costs',
  'bud.customCategory': 'Custom category',
  'bud.q.expectedIncome.label': 'How much do you expect to earn?',
  'bud.q.expectedIncome.hint': 'Expected invoiced income for the whole year.',
  'bud.q.goodsAnnual.label': 'Purchases of goods',
  'bud.q.goodsAnnual.hint': 'Goods or materials you buy in for resale.',
  'bud.q.officeMonthly.label': 'Office/premises per month',
  'bud.q.officeMonthly.hint': 'Rent, office space or premises.',
  'bud.q.softwareMonthly.label': 'Software per month',
  'bud.q.softwareMonthly.hint': 'Subscriptions, tools and apps.',
  'bud.q.accountingMonthly.label': 'Accounting/advisory per month',
  'bud.q.accountingMonthly.hint': 'Accountant, advisor or help.',
  'bud.q.travelAnnual.label': 'Car/travel per year',
  'bud.q.travelAnnual.hint': 'Driving, travel, hotels or transport.',
  'bud.q.marketingAnnual.label': 'Marketing per year',
  'bud.q.marketingAnnual.hint': 'Ads, branding and sales costs.',
  'bud.q.otherAnnual.hint': "Add a buffer for what you don't know yet.",
  // What is left of aii.*: shared SuperPlumma labels used from Home and
  // Personal finance. The AI Advisor page itself lives under adv.*.
  'aii.superPlumma': 'SuperPlumma',
  'aii.askSuperPlumma': 'Ask SuperPlumma',
  'aii.chatWithSuperPlumma': 'Chat with SuperPlumma',
  'aii.chatWithMe': 'Chat with me',
  'aii.healthScore': 'Financial health score',

  // ------------------------------- Personal finances (core)
  'po.title': 'Personal finances',
  'po.backToBusiness': 'Back to the business',
  'po.yourAdvisor': 'Your personal adviser',
  'po.intro': 'Personal finances is your own household economy — entirely separate from the business accounts. SuperPlumma analyses income, spending, savings, loans, pension and tax for the household, and gives advice the way a personal financial adviser would. "Beta" means the feature is still under development.',
  'po.hero.greeting.night': 'Good night.',
  'po.hero.greeting.morning': 'Good morning.',
  'po.hero.greeting.day': 'Hello.',
  'po.hero.greeting.evening': 'Good evening.',
  'po.hero.greetingNamed.night': 'Good night, {name}.',
  'po.hero.greetingNamed.morning': 'Good morning, {name}.',
  'po.hero.greetingNamed.day': 'Hello, {name}.',
  'po.hero.greetingNamed.evening': 'Good evening, {name}.',
  'po.hero.section.idag': 'Today’s advice',
  'po.hero.section.oversikt': 'Financial overview',
  'po.hero.section.forbruk': 'Spending',
  'po.hero.section.familie': 'Family finances',
  'po.hero.section.fremtid': 'Future plan',
  'po.hero.section.reports': 'Reports',
  'po.hero.section.assets': 'Assets',
  'po.hero.section.gjeld': 'Debt',
  'po.hero.section.import': 'Data basis',
  'po.hero.advice.idag': 'I keep an eye on your finances and highlight the most important tasks and opportunities right now.',
  'po.hero.advice.oversikt': 'See what pulls your financial health up and down. Start with the area that needs the most attention.',
  'po.hero.advice.forbruk': 'Look for categories that have increased and choose one realistic step that creates room without making everyday life too tight.',
  'po.hero.advice.familie': 'Clarify what is shared, who pays for what and which goals the household should prioritise together.',
  'po.hero.advice.fremtid': 'Make your goals concrete with an amount and date. This makes it easier to see what you should save each month.',
  'po.hero.advice.reports': 'Use the reports to understand changes over time, rather than focusing on one unusually high or low month.',
  'po.hero.advice.assets': 'Check that values and account balances are current before assessing net worth and long-term choices.',
  'po.hero.advice.gjeld': 'Prioritise a safe buffer first, then consider extra payments on the debt with the highest effective interest rate.',
  'po.hero.advice.import': 'Good advice starts with good data. Link statements to the correct account and fill gaps in the imported periods.',
  'po.pickPerson': 'Choose person',
  'po.sections': 'Sections',
  'po.sectionsHelp': 'Switch between the areas: Today (today\'s insights), Overview (health score and key figures), Spending (where the money goes), Family, Future (forecast and "what if"), Reports, Assets, Debt, Tax and Import.',
  'po.outOf100': 'out of 100',
  'po.todaysFocus': 'Today\'s focus',
  'po.todaysTasks': 'Today\'s tasks',
  'po.mostImportantToday': 'Most important today',
  'po.markDone': 'Mark as done',
  'po.undo': 'Undo',
  'po.healthHeading': 'Your overall financial health — and what moves it',
  'po.healthHelp': 'The number in the ring (0–100) is an overall assessment of your finances — the higher, the healthier. The categories below show what pulls it up and down: green is good, amber means keep an eye on it, and red needs attention.',
  'po.noHistory': 'No history to compare with yet',
  'po.whatAffectsScore': 'What affects the score most',
  'po.noDrivers': 'No drivers calculated yet',
  'po.noDriversHelp': 'Once there are enough imported transactions, I will show what pulls the score up and down.',
  'po.last30Days': 'Latest recorded month',
  'po.last30DaysSub': 'Compared with the preceding calendar month',
  'po.financialOverview': 'Financial overview',
  'po.financialOverviewSub': 'A snapshot of the household finances',
  'po.recommendations': 'SuperPlumma\'s recommendations',
  'po.recommendationsSub': 'The steps that matter most for your finances right now',
  'po.askMe': 'Ask me',
  'po.yourHealthScoreIs': 'Your health score is',
  'po.adjustBudget': 'Adjust budget',
  'po.budgetTotal': 'Budget total:',
  'po.saveBudget': 'Save budget',
  'po.monthlyLimitPerCategory': 'Monthly limit per category',
  'po.noCategoriesImported': 'No spending categories imported yet. Add your own categories below.',
  'po.ownCategories': 'Own categories',
  'po.pickColour': 'Choose colour',
  'po.categoryName': 'Category name',
  'po.removeCategory': 'Remove category',
  'po.addCategory': 'Add category',
  'po.budgetVsSpending': 'Budget vs. spending',
  'po.budgetVsSpendingSub': 'Monthly limit against spending in the selected period',
  'po.budgetVsSpendingHelp': 'Monthly budget against actual spending per category. Press "Adjust budget" to set the limits or create your own categories. The progress bar fills according to how much of the budget you have used — green is within, amber is approaching the limit, and red means the category is exceeded. If you choose the annual overview, the monthly limit is multiplied by the number of months that have imported data. Budgets are saved for the selected year.',
  'po.whereMoneyGoes': 'Where does the money go?',
  'po.whereMoneyGoesSub': 'Tap a category to see the transactions behind it and move them to the right place',
  'po.whereMoneyGoesHelp': 'The pie chart and the list show spending split by category for the selected period. Switch period with the button at the top — months without imported transactions are greyed out. Tap a category to highlight it. The percentage on the right is the change against the previous month — green down means less, red up means more.',
  'po.selectPeriod': 'Select period',
  'po.yearOverview': 'Annual overview',
  'po.yearly': 'Annual',
  'po.month.1': 'January',
  'po.month.2': 'February',
  'po.month.3': 'March',
  'po.month.4': 'April',
  'po.month.5': 'May',
  'po.month.6': 'June',
  'po.month.7': 'July',
  'po.month.8': 'August',
  'po.month.9': 'September',
  'po.month.10': 'October',
  'po.month.11': 'November',
  'po.month.12': 'December',
  'po.largestCategoryIs': 'The largest cost category is',
  'po.recurringCharges': 'Recurring charges to review',
  'po.recurringChargesSub': 'Recurring subscription charges that may be worth checking',
  'po.opportunity': 'Opportunity',
  'po.estimatedAnnualCost': 'Estimated annual cost',
  'po.saveAccount': 'Save account',
  'po.allAccounts': 'All accounts',
  'po.uploadedStatements': 'Uploaded statements',
  'po.yourAccounts': 'Your accounts',
  'po.yourAccountsSub': 'Register and sort your accounts by type — imported statements are linked to the right account',
  'po.totalBalance': 'Total balance',
  'po.creditDebt': 'Credit card debt',
  'po.accounts': 'Accounts',
  'po.analysis': 'SuperPlumma\'s analysis',
  'po.analysisSub': 'How the spending in the category is distributed — and what you can do',
  'po.whoIsBehind': 'Who is behind it',
  'po.noTransactionsToAnalyse': 'No transactions to analyse yet.',
  'po.unusualPurchases': 'Unusual purchases',
  'po.noUnusualPurchases': 'No purchases stand out in this period.',
  'po.searchTransactions': 'Search transactions …',
  'po.clearSearch': 'Clear search',
  'po.sort': 'Sort',
  'po.linkStatementToAccount': 'Link the statement to an account',
  'po.linkToAccount': 'Link to account',
  'po.newAccount': 'New account',
  'po.accountNamePh': 'E.g. DNB current account',
  'po.accountNumberPh': 'E.g. 1234.56.78901',
  'po.currentAccount': 'Current account',
  'po.creditCard': 'Credit card',
  'po.me': 'me',
  'po.importTitle': 'Import financial data',
  'po.importSub': 'Upload bank statements — SuperPlumma reads and categorises them automatically',
  'po.pickStatement': 'Choose a bank statement',
  'po.pickStatementHelp': 'Upload bank statements from your bank. XLSX and CSV are read directly, PDF is read best effort from the text. SuperPlumma categorises the transactions automatically.',
  'po.pdf': 'PDF',
  'po.noStatementsUploaded': 'No bank statements have been uploaded yet.',
  'po.deleteStatement': 'Delete statement',
  'po.sharedCosts': 'Contribution to shared costs',
  'po.sharedCostsSub': 'Who pays what of the shared expenses — and how that compares with the income share',
  'po.sharedCostsHelp': 'The bar shows how large a share of the household\'s shared costs each of you covers. On the right is the share of total income. If the two are equal, the split is proportional to income. The figures come from what each of you has entered on your own profile.',
  'po.splitIsEven': 'The split is even. You share',
  'po.togetherYouCan': 'Together you can',
  'po.togetherYouCanSub': 'Small steps you can take as a team — calculated from the household\'s own figures',
  'po.togetherHelp': 'The suggestions are calculated from the total income and shared costs you have entered. They are meant as shared goals, not demands on individuals.',
  'po.sharedSteps': 'Shared steps',
  'po.magnitude': 'Order of magnitude',
  'po.youPartnerPh': 'You, partner …',
  'po.monthlyNetIncome': 'Monthly net income',
  'po.sharedCostShare': 'Share of shared costs per month',
  'po.familyFinances': 'Family finances',
  'po.addPerson': 'Add person',
  'po.noHouseholdMembers': 'No household members are registered yet.',
  'po.householdHasRegistered': 'The household has registered',

  // ------------------ Personal finances (future, debt, assets, tax)
  'po.todaysPlan': 'Today\'s plan',
  'po.savePlan': 'Save plan',
  'po.monthlySaving': 'Monthly saving (NOK)',
  'po.monthlyExtraDebt': 'Monthly extra debt repayment (NOK)',
  'po.targetNetWealth': 'Desired net wealth (NOK)',
  'po.expectedReturn': 'Expected annual return (%)',
  'po.yourAgeToday': 'Your age today (years)',
  'po.desiredRetirementAge': 'Desired retirement age (years)',
  'po.pickEvent': 'Choose an event',
  'po.eventNamePh': 'E.g. second child',
  'po.starts': 'Starts',
  'po.oneOffCost': 'One-off cost (NOK)',
  'po.monthlyEffect': 'Monthly effect (NOK)',
  'po.durationMonths': 'Duration (months)',
  'po.goalName': 'Name of the goal',
  'po.goalNamePh': 'E.g. Buffer',
  'po.shortDescription': 'Short description',
  'po.whatSavingFor': 'What are you saving for?',
  'po.targetAmount': 'Target amount (NOK)',
  'po.savedSoFar': 'Saved so far (NOK)',
  'po.icon': 'Icon',
  'po.colour': 'Colour',
  'po.debtFree': 'Debt free',
  'po.saveLoan': 'Save loan',
  'po.loanType': 'Loan type',
  'po.spendingCategory': 'Category in Spending',
  'po.categoryPh': 'E.g. Housing',
  'po.debtOverview': 'Debt overview',
  'po.debtOverviewSub': 'All your loans together — remaining debt, interest and repayment pace',
  'po.debtOverviewHelp': 'The key figures for all your debt: total remaining debt, what you repay per month, interest cost per year, average interest rate and how long until you are debt free.',
  'po.totalDebt': 'Total debt',
  'po.repaymentPerMonth': 'Repayment per month',
  'po.interestPerYear': 'Interest per year',
  'po.averageRate': 'Average rate',
  'po.debtFreeIn': 'Debt free in',
  'po.loanCount': 'Number of loans',
  'po.yourLoans': 'Your loans',
  'po.yourLoansSub': 'Tap a loan to see the repayment plan and simulate changes',
  'po.addLoan': 'Add loan',
  'po.noLoans': 'No loans entered yet. Press "Add loan" to get started.',
  'po.whichLoanFirst': 'Which loan should you repay first?',
  'po.whichLoanFirstSub': 'Ranked by interest rate — the most expensive loan first gives the most back for every extra krone',
  'po.iRecommend': 'I recommend',
  'po.snowballWithRate': 'the interest-rate method (debt avalanche)',
  'po.repaymentSimSub': 'See how the remaining debt falls, and simulate what happens if you pay more or less per month',
  'po.myRecommendation': 'My recommendation',
  'po.withChange': 'With the change',
  'po.extraRepaymentPerMonth': 'Extra repayment per month',
  'po.dragToPayMore': 'Drag to pay more (debt free sooner) or less (longer term)',
  'po.standard': 'Standard',
  'po.savedInInterest': 'Saved in interest',
  'po.overWholeTerm': 'over the whole term',
  'po.netWealthEffect': 'Net wealth effect',
  'po.becomesYours': 'becomes yours, not the bank\'s',
  'po.interestPostedAs': 'Interest and instalments on this loan are posted as',
  'po.debtJourney': 'Your debt journey',
  'po.debtJourneySub': 'The key milestones on the way to being completely debt free',
  'po.yourFinancialFuture': 'Your financial future',
  'po.yourFinancialFutureSub': 'Where the money takes you — and how your choices shape the road there',
  'po.showingScenario': 'Showing scenario:',
  'po.reset': 'Reset',
  'po.desiredNetWealth': 'Desired net wealth',
  'po.lastsUntilYouAre': 'lasts until you are',
  'po.lasts': 'lasts',
  'po.forLife': 'for life',
  'po.plummaReadsChart': 'SuperPlumma reads the chart',
  'po.whatIf': 'What if?',
  'po.whatIfSub': 'Set the starting point in Today\'s plan, choose a decision and adjust the assumptions — the chart, goals, dates and pension all update together',
  'po.todaysPlanBase': 'Today\'s plan — the starting point',
  'po.editTodaysPlan': 'Edit today\'s plan',
  'po.netWealthToday': 'Net wealth today',
  'po.monthlySavingShort': 'Monthly saving',
  'po.extraDebtRepayment': 'Extra debt repayment',
  'po.return': 'Return',
  'po.retirementAge': 'Retirement age',
  'po.adjustAssumptions': 'Adjust assumptions',
  'po.lifeEvents': 'Life events',
  'po.lifeEventsSub': 'Plan major events ahead — children, housing, leave, a sabbatical — and see how they shape the whole picture',
  'po.addEvent': 'Add event',
  'po.lifeEventsHelp': 'Enter future events with a start date, one-off cost, monthly effect and duration. Each active event is placed at the right point in the forecast. Turn an event off to see the plan without it. Events are saved for the selected year.',
  'po.effectOver5Years': 'Effect over 5 years',
  'po.goalScore': 'Goal score',
  'po.goalScoreSub': 'How well you are placed to reach your goals — and what lifts the score',
  'po.whatAffectsGoalScore': 'What affects the goal score',
  'po.myRecommendationNow': 'My recommendation right now',
  'po.prioritise': 'Prioritise',
  'po.talkAboutPlan': 'Talk to me about the plan',
  'po.yourGoals': 'Your goals',
  'po.yourGoalsSub': 'Each goal with the amount left, expected date and probability',
  'po.newGoal': 'New goal',
  'po.addGoal': 'Add goal',
  'po.editGoal': 'Edit goal',
  'po.deleteGoal': 'Delete goal',
  'po.remaining': 'Left',
  'po.expectedDone': 'Expected completion',
  'po.probability': 'Probability',
  'po.largestEffect': 'Largest effect',
  'po.howReachFaster': 'What can I do to reach this faster?',
  'po.nextMilestone': 'Next milestone',
  'po.nextMilestoneSub': 'What you are most likely to achieve first — in chronological order',
  'po.yourLifePlan': 'Your life plan',
  'po.yourLifePlanSub': 'The most important financial milestones ahead, built from your goals and your plan',
  'po.adjustLive': 'Adjust the assumptions — the forecast, goals and dates update live as you drag.',
  'po.deleteGoalTitle': 'Delete the goal?',
  'po.deleteGoalConfirm': 'Delete the goal',
  'po.doYouWantToDelete': 'Do you want to delete',
  'po.ownPartnerSharedSub': 'An overview of your own, your partner\'s and shared costs',
  'po.you': 'You',
  'po.partner': 'Partner',
  'po.householdSpends': 'The household spends',
  'po.reportSub': 'View, compare, print and download monthly and annual reports',
  'po.print': 'Print',
  'po.downloadPdf': 'Download PDF',
  'po.pdfBusy': 'Creating PDF …',
  'po.pdfFailed': 'Could not create a PDF of the report. Try again, or use Print.',
  'po.pdfFileName': 'personal-finance-report',
  'po.compareWith': 'Compare with',
  'po.compareHelp': 'Put an earlier period alongside to see the change. "Off" shows only the selected period.',
  'po.ongoingPeriod': 'Ongoing period — the figures are provisional',
  'po.plummaSummary': 'SuperPlumma\'s summary',
  'po.wentWell': 'This went well',
  'po.canImprove': 'This could be improved',
  'po.focusNextMonth': 'Focus next month:',
  'po.goDeeper': 'Want to go deeper? Ask me about the report.',
  'po.plummaNoticed': 'SuperPlumma noticed',
  'po.savingsRate': 'Savings rate',
  'po.noImportedCosts': 'No imported costs',
  'po.totalCosts': 'Total costs',
  'po.whatHappensNext': 'What happens next?',
  'po.setAsideOver12': 'Set aside over 12 months',
  'po.averagePerMonth': 'Average per month',
  'po.askWhatHappensNext': 'Ask me what happens next',
  'po.whatFiguresMean': 'What the figures mean',
  'po.youHaveStated': 'You have stated that',
  'po.howItLooksAhead': 'How it looks going forward',
  'po.inSixMonths': 'In 6 months',
  'po.inTwelveMonths': 'In 12 months',
  'po.assetCategoryPh': 'E.g. Property',
  'po.assetsAndWealth': 'Assets and wealth',
  'po.assetsAndWealthSub': 'Everything you own together — home, vehicles, savings and investments',
  'po.assetsHelp': 'The total value of what you own, your debt, and the net wealth (assets minus debt). "Expected change in value" sums up how the assets are expected to rise or fall in value during the year.',
  'po.totalAssets': 'Total assets',
  'po.netWealth': 'Net wealth',
  'po.expectedChangePerYear': 'Expected change in value per year',
  'po.liquid': 'Liquid (savings and funds)',
  'po.assetCount': 'Number of assets',
  'po.wealthHealth': 'Wealth health',
  'po.wealthHealthSub': 'An overall assessment of how robust your wealth is — diversification, liquidity, risk and debt ratio',
  'po.wealthStrongestOn': 'Your wealth scores strongest on',
  'po.wealthDistribution': 'How your wealth is distributed across categories',
  'po.expectedDevelopment': 'Expected development',
  'po.expectedDevelopmentSub': 'Based on the change in value you have entered per asset',
  'po.projectionHelp': 'The projection uses the expected annual change in value you have entered for each asset. Plumme does not yet pull in external market data for property, used cars or funds.',
  'po.withYourAssumptions': 'With the assumptions you have entered, your wealth changes by roughly',
  'po.explainSimply': 'Explain the development simply',
  'po.watchingClosely': 'Watching especially closely',
  'po.watchingCloselySub': 'The assets expected to lose value or grow more slowly than inflation',
  'po.explain': 'Explain',
  'po.yourAssets': 'Your assets',
  'po.yourAssetsSub': 'Tap an asset to edit its value and details',
  'po.addAsset': 'Add asset',
  'po.askAboutTax': 'Ask me about the tax',
  'po.taxAssistant': 'Tax return assistant',
  'po.taxAssistantSub': 'SuperPlumma guides you step by step and adapts the questions as you go',
  'po.deductionHunter': 'Deduction hunter',
  'po.deductionHunterSub': 'The deductions are sorted by expected value — start at the top where the gain is largest',
  'po.whyIThinkThis': 'Why do I think this?',
  'po.dataIUsed': 'Data I have used',
  'po.whyYouQualify': 'Why you qualify for the deduction',
  'po.estimatedTaxBenefit': 'Estimated tax benefit',
  'po.taxOptimisation': 'Tax optimisation',
  'po.taxOptimisationSub': 'Concrete steps sorted by deadline — and what they mean for this year and the next',
  'po.nextYearOnwards': 'Next year and beyond',
  'po.aiTaxCheck': 'AI tax check',
  'po.aiTaxCheckSub': 'SuperPlumma reviews your imported tax details',
  'po.readyToFile': 'Ready for external review',
  'po.readyToFileSub': 'Compare the basis with the tax return and annual statements',
  'po.checkBasis': 'Basis for the check',
  'po.requiresIntegration': 'Requires an official integration, strong authentication and explicit approval',
  'po.filingUnavailable': 'Filing is not available',
  'po.whatIsMissing': 'What is missing before an external check?',
  'po.whatRemains': 'What remains',
  'po.taxBasisNotFetched': 'The tax basis has not been fetched',
  'po.alreadyVerified': 'Already quality checked',
  'po.nothingVerified': 'Nothing has been quality checked yet.',

  // ------------------ Products, subscriptions, reports, specifications
  'spx.taxScheme': 'Tax and duty scheme',
  'spx.noItems': 'No items registered yet.',
  'spx.removeSpec': 'Remove specification',
  'prd.import': 'Import products',
  'prd.excel': 'Excel (.xlsx)',
  'prd.export': 'Export products',
  'prd.csvName': 'Products CSV',
  'prd.excelName': 'Products Excel',
  'prd.countTemplateName': 'Inventory count template',
  'prd.countTemplateEmpty': 'No goods to count. The count template covers products of type Vare.',
  'prd.countTemplateDone': 'Count template downloaded. Fill in quantities as of 31 December; inventory is valued at acquisition cost.',
  'prd.countTemplateError': 'Could not build the count template.',
  'prd.colProductId': 'Product ID',
  'prd.colInventoryAccount': 'Inventory account',
  'prd.colStockToday': 'Stock today',
  'prd.colCountedQuantity': 'Counted quantity',
  'prd.colTotalCostValue': 'Total cost value',
  'prd.colNote': 'Note',
  'prd.countSheetTitle': 'Inventory count',
  'prd.countSheetIntro': 'Quantity and unit cost are pre-filled from today\'s product register. Check and correct them against the actual count on the count date.',
  'prd.countSheetDate': 'Count date',
  'prd.countSheetCountedBy': 'Counted by',
  'prd.countSheetReference': 'Reference',
  'prd.countSheetSignature': 'Signature',
  'prd.countSheetNoteLabel': 'Note',
  'prd.countSheetNote': 'This list documents the count. Accounting value and tax value are assessed in the year-end close.',
  'prd.countSheetInfoTab': 'Information',
  'prd.countSheetWrongTemplate': 'Use the Plumme count template. The columns do not match.',
  'prd.countSheetOnlyXlsx': 'Automatic import supports the Excel template (.xlsx). Other files are stored as documentation.',
  'prd.countSheetTabNotFound': 'Could not find the {name} sheet.',
  'prd.countSheetRowError': 'Row {row}: check the item, inventory account, counted quantity and cost.',
  'prd.countSheetNoneCounted': 'No filled-in quantities were found in the count list.',
  'prd.countSheetUnmappedAccount': 'Inventory account {account} cannot be allocated automatically. Check the accounts in the review.',
  'prd.filterHelp': 'Filter the products by type (goods, service, rental), whether they are in stock, and whether deleted ones are shown.',
  'prd.listTitle': 'Product list',
  'prd.listSub': 'The goods and services you sell',
  'prd.new': 'New product',
  'prd.searchPh': 'Search by product name, description, item number or price',
  'prd.searchHelp': 'Search by product name, description, item number or price.',
  'prd.none': 'No products here yet',
  'prd.listHelpTitle': 'The product list',
  'prd.listHelp': 'Each row is one product with its item number, price, VAT rate, type and stock. Tap a row to see details and edit.',
  'prd.detailsTitle': 'Product details',
  'prd.detailsHelp': 'Description, item number, price excl. VAT, VAT rate, type and stock for the product.',
  'prd.editHelp': 'Change the name, price, VAT, type and stock for the product.',
  'prd.delete': 'Delete product',
  'prd.deleteHelp': 'Move the product to deleted. You can restore it later.',
  'prd.itemNo': 'Item no.',
  'prd.colStockItem': 'Item',
  'prd.stockReasonDefault': 'Physical count',
  'prd.stock': 'Stock',
  'prd.deleted': 'Deleted',
  'prd.pickOwnColour': 'Choose your own colour',
  'prd.namePh': 'E.g. Consulting hour',
  'prd.priceExVat': 'Price excl. VAT', 'prd.price': 'Price',
  'prd.priceIncVat': 'Price incl. VAT',
  'prd.subscriptionPeriod': 'Subscription period',
  'prd.multiDayDiscount': 'Multi-day discount',
  'prd.multiDayHelp': 'Applies only to this rental product.',
  'prd.day2ChargedAt': 'Day 2 is charged at',
  'prd.day3Onwards': 'Day 3 onwards',
  'prd.itemNumber': 'Item number',
  'prd.accountFallbackName': 'Account',
  'prd.acct3000': 'Sales and withdrawals subject to VAT',
  'prd.acct3020': 'Sales revenue services, high VAT rate',
  'prd.acct3030': 'Sales revenue goods, medium VAT rate',
  'prd.acct3050': 'Sales revenue goods, low VAT rate',
  'prd.acct3100': 'Sales and withdrawals at 0 percent VAT',
  'prd.acct3200': 'Sales and withdrawals outside the VAT act',
  'prd.acct3900': 'Other operating income',
  'prd.colProductName': 'Product name',
  'prd.colDescription': 'Description',
  'prd.colVat': 'VAT',
  'prd.colType': 'Type',
  'prd.colRentalDiscount': 'Rental discount',
  'prd.colSalesAccount': 'Sales account',
  'prd.colEquivalentAccount': 'Equivalent to standard account',
  'prd.excelImportUnavailable': 'Excel import is not available yet.',
  'prd.excelExportUnavailable': 'Excel export is not available yet.',
  'prd.colStatus': 'Status',
  'prd.exportSheetName': 'Products',
  'prd.typeHeading': 'Heading',
  'prd.typeTextLine': 'Text line',
  'prd.textLinesTitle': 'Text lines',
  'prd.newTextLine': 'New text line',
  'prd.updateTextLine': 'Update text line',
  'prd.saveTextLine': 'Save text line',
  'prd.textLineNamePh': 'E.g. Standard installation text',
  'prd.textLineTextPh': 'Write the text that can be used on document lines',
  'prd.styleFor': 'Style for {target}',
  'prd.styleTargetText': 'Text',
  'prd.styleTargetName': 'Name',
  'prd.styleBold': 'Bold',
  'prd.styleItalic': 'Italic',
  'prd.styleDivider': 'Divider',
  'prd.styleNoDivider': 'No divider',
  'prd.styleSummary': 'Name: {name} · Text: {text} · {divider}',
  'prd.toastProductUpdated': 'Product updated',
  'prd.toastProductSaved': 'Product saved',
  'prd.toastProductSaveError': 'Could not save the product.',
  'prd.toastProductDeleted': 'Product deleted',
  'prd.toastProductDeleteError': 'Could not delete the product.',
  'prd.toastTextLineUpdated': 'Text line updated',
  'prd.toastTextLineSaved': 'Text line saved',
  'prd.toastTextLineSaveError': 'Could not save the text line.',
  'prd.toastTextLineDeleted': 'Text line deleted',
  'prd.toastTextLineDeleteError': 'Could not delete the text line.',
  'prd.toastImportNoneFound': 'No products found in the file.',
  'prd.toastImportSuccess': '{count} products imported',
  'prd.toastImportError': 'Could not import products.',
  'prd.toastExportNone': 'No products to export',
  'prd.toastExportDone': 'Product list downloaded',
  'prd.toastExportError': 'Could not export the product list.',
  'prd.textLineFilterHelp': 'Filter saved text lines and headings.',
  'prd.filterOther': 'Other',
  'prd.showDeleted': 'Show deleted',
  'prd.typeGoods': 'Goods',
  'prd.typeService': 'Service',
  'prd.typeRental': 'Rental',
  'prd.typeSubscription': 'Subscription',
  'prd.stockOnly': 'In stock only',
  'prd.textLineSubtitle': 'Saved texts and headings for sales documents',
  'prd.titleHelp': 'Your products — the goods and services you sell, with price, VAT and stock. Tap a product for details.',
  'prd.uploadHelp': 'Import products from a file.',
  'prd.downloadHelp': 'Download the product list as CSV or Excel.',
  'prd.addHelp': 'Add a new good, service, subscription or rental product.',
  'prd.textLineSearchPh': 'Search by name, text or type',
  'prd.textLineSearchHelp': 'Search saved text lines and headings.',
  'prd.emptyText': 'Add the goods and services you sell, and invoicing will go lightning fast.',
  'prd.textLineEmptyTitle': 'No text lines yet',
  'prd.textLineEmptyText': 'Save recurring texts, headings and product texts without a price.',
  'prd.colBalance': 'Balance',
  'prd.colCostPerUnit': 'Cost per unit',
  'prd.colTotalValue': 'Total value',
  'prd.colStockAvailable': 'Stock/available',
  'prd.noneShort': 'None',
  'prd.subscriptionLabel': 'Subscription · {period}',
  'prd.month1Short': '1 mo',
  'prd.months12Short': '12 mo',
  'prd.copyToTextLine': 'Copy to text line',
  'prd.colProduct': 'Product',
  'prd.colPrice': 'Price',
  'prd.colName': 'Name',
  'prd.colStyle': 'Style',
  'prd.errNrTaken': 'Item number «{nr}» is already in use.',
  'prd.errAccountCodeFormat': 'Use an income account that starts with 3 and has 4 or 5 digits.',
  'prd.errAccountNameRequired': 'Give the account a name.',
  'prd.errAccountEquivalentRequired': 'Choose the standard account this one should correspond to.',
  'prd.errAccountExists': 'Account {code} already exists.',
  'prd.errCostPriceInvalid': 'Cost price must be a valid amount of at least 0.',
  'prd.errTrackingDateRequired': 'Choose the date automatic inventory tracking should start.',
  'prd.errStockNegative': 'The opening stock cannot be negative.',
  'prd.errCostPriceRequired': 'Enter a cost price for the opening stock.',
  'prd.errCostPriceNegative': 'Cost price cannot be negative.',
  'prd.noName': 'Unnamed',
  'prd.updateProduct': 'Update product',
  'prd.saveProduct': 'Save product',
  'prd.rentalQtyLabel': 'Quantity available for rental',
  'prd.autoInventoryTitle': 'Automatic inventory and cost price',
  'prd.autoInventoryHelp': 'Purchases increase stock. Posted sales reduce stock and record the calculated cost price using weighted average.',
  'prd.calculatedStock': 'Calculated stock balance',
  'prd.openingStock': 'Opening stock',
  'prd.avgCostPrice': 'Average cost price',
  'prd.costPerUnit': 'Cost price per unit',
  'prd.inventoryValueLine': 'Inventory value: {value}',
  'prd.month1': '1 month',
  'prd.months12': '12 months',
  'prd.advancedTitle': 'Advanced product data',
  'prd.advancedHelp': 'SKU, EAN/GTIN, product group and import data.',
  'prd.noGroup': 'No group',
  'prd.removeGroup': 'Remove product group',
  'prd.newGroupPh': 'New product group',
  'prd.brand': 'Brand',
  'prd.variantName': 'Variant name',
  'prd.supplierItemNumber': 'Supplier item number',
  'prd.internalReference': 'Internal reference',
  'prd.tags': 'Tags',
  'prd.tagsPh': 'E.g. webshop, spare part, winter',
  'prd.saveAsTextLineTitle': 'Also save as a text line',
  'prd.saveAsTextLineHelp': 'Creates a copy without a price for document lines.',
  'prd.autoAccountLine': 'Automatic: {account}',
  'prd.accountTypeLabel': 'Account type',
  'prd.selectAccount': 'Choose account',
  'prd.customAccountOption': 'Custom',
  'prd.accountInLedger': 'Account in the ledger',
  'prd.accountNamePh': 'Pass-through invoicing',
  'prd.equivalentForYearEnd': 'Equivalent for annual accounts/tax',
  'prd.selectStandardAccount': 'Choose standard account',
  'sub.tabsHelp': 'Switch between subscriptions with recurring invoicing and customer lists for combined invoicing or email.',
  'sub.start': 'Start',
  'sub.end': 'End',
  'sub.endHelp': 'Leave empty to continue until the subscription is paused or deleted.',
  'sub.internalComment': 'Internal comment',
  'sub.saveCustomers': 'Save customers',
  'sub.searchCustomers': 'Search customers',
  'sub.searchCustomersPh': 'Search by name, email or company number...',
  'sub.selectVisible': 'Select visible',
  'sub.deselectVisible': 'Deselect visible',
  'sub.noCustomers': 'No customers yet',
  'sub.howToInvoice': 'How do you want to invoice?',
  'sub.manualFlowNote': 'The choice below starts a manual invoice flow for the subscription.',
  'sub.sendInvoice': 'Send invoice',
  'sub.openDraftFilled': 'Open an invoice draft with the subscription already filled in.',
  'sub.openBlankDraft': 'Open a blank invoice draft with the customer group selected.',
  'sub.subject': 'Subject',
  'sub.message': 'Message',
  'sub.removeAllAttachments': 'Remove all attachments',
  'sub.addCustomers': 'Add customers',
  'sub.noInvoiceSent': 'No invoice sent',
  'sub.noEmailSent': 'No email sent',
  'sub.unknownCustomer': 'Unknown customer',
  'sub.customersCount': '{count} customers',
  'sub.cpiAnnualSuffix': ' · CPI {rate}% annually',
  'sub.actionMenuLabel': 'Action',
  'sub.nameRequiredSubscription': 'Please give the subscription a name',
  'sub.nameRequiredList': 'Please give the list a name',
  'sub.nameRequiredListError': 'Please give the list a name.',
  'sub.nameRequiredAgreementError': 'Please give the agreement a name.',
  'sub.editSubTitle': 'Edit subscription',
  'sub.editListTitle': 'Edit list',
  'sub.newSubTitle': 'New subscription',
  'sub.newListTitle': 'New list',
  'sub.saveChanges': 'Save changes',
  'sub.saveSubscription': 'Save subscription',
  'sub.saveList': 'Save list',
  'sub.namePlaceholderSub': 'E.g. Gold membership',
  'sub.namePlaceholderList': 'E.g. Newsletter',
  'sub.nextInvoiceDateLabel': 'Next invoice date',
  'sub.cpiAdjustmentLabel': 'CPI adjustment',
  'sub.cpiAdjustmentHelp': 'Annual consumer price adjustment of the subscription price.',
  'sub.customerSavedToast': 'Customer "{name}" saved',
  'sub.saveCustomerError': 'Could not save the customer.',
  'sub.addCustomersTitle': 'Add customers · {name}',
  'sub.selectedCount': '{count} selected',
  'sub.addAsNewCustomer': 'Add "{name}" as a new customer',
  'sub.noContactInfo': 'No contact info',
  'sub.addCustomersEmptyText': 'Add customers to the customer register first, or type a name to create a new one.',
  'sub.sendInvoiceTitle': 'Send invoice · {name}',
  'sub.attachmentTooLarge': 'Attachments can be max {max}.',
  'sub.fillSubject': 'Fill in the subject.',
  'sub.writeMessage': 'Write a message.',
  'sub.sendEmailTitle': 'Send email · {name}',
  'sub.sending': 'Sending...',
  'sub.sendEmailButton': 'Send email',
  'sub.readyCount': '{count} ready',
  'sub.attachmentsAddedCount': '{count} attachments added',
  'sub.addAttachment': 'Add attachment',
  'sub.emailSendNote': 'Emails are sent via the backend. You can drop files anywhere in the dialog or paste with Ctrl+V. Recipients without an email address are logged as not sent.',
  'sub.typeSubscription': 'Subscription',
  'sub.typeList': 'List',
  'sub.actionClose': 'Close',
  'sub.actionOpen': 'Open',
  'sub.edit': 'Edit',
  'sub.emailLabel': 'Email',
  'sub.resume': 'Resume',
  'sub.pause': 'Pause',
  'sub.delete': 'Delete',
  'sub.tabCustomers': 'Customers ({count})',
  'sub.tabInvoices': 'Invoices ({count})',
  'sub.tabEmails': 'Emails ({count})',
  'sub.addCustomersToInvoiceText': 'Add customers to invoice them.',
  'sub.removeMember': 'Remove',
  'sub.noInvoiceSentText': 'Invoices you send from this subscription appear here.',
  'sub.invoiceRunFallback': 'Invoice run',
  'sub.statusSaved': 'saved',
  'sub.noEmailSentText': 'Emails you send to customers appear here.',
  'sub.emailLogFallback': 'Email log',
  'sub.recipientsCount': '{count} recipients',
  'sub.changesSaved': 'Changes saved',
  'sub.listCreated': 'List created',
  'sub.subscriptionCreated': 'Subscription created',
  'sub.saveError': 'Could not save.',
  'sub.customersSaved': 'Customers saved',
  'sub.saveCustomersError': 'Could not save customers.',
  'sub.agreementResumed': 'The agreement is active again',
  'sub.agreementPaused': 'The agreement is paused',
  'sub.updateAgreementError': 'Could not update the agreement.',
  'sub.listDeleted': 'The list was deleted',
  'sub.subscriptionDeleted': 'The subscription was deleted',
  'sub.deleteError': 'Could not delete.',
  'sub.emailsSentToast': '{count} emails sent',
  'sub.emailsSentFailedSuffix': ', {count} not sent',
  'sub.sendEmailError': 'Could not send the email.',
  'sub.searchSubPlaceholder': 'Search by subscription, customer or amount...',
  'sub.searchListPlaceholder': 'Search by list or customer...',
  'sub.emptySubTitle': 'No subscriptions yet',
  'sub.emptyListTitle': 'No lists yet',
  'sub.emptySubText': 'Create your first subscription to invoice customers regularly.',
  'sub.emptyListText': 'Create your first customer list.',
  'sub.preservedSubscriptionsNotice': '{count} older customer subscriptions are preserved in app state and can be migrated later.',
  'agreements.customer': 'Customer',
  'agreements.tab.subscriptions': 'Subscriptions',
  'agreements.tab.recurring': 'Recurring',
  'agreements.tab.lists': 'Lists',
  'agreements.unknownCustomer': 'Unknown customer',
  'agreements.recurringInvoice': 'Recurring invoice',
  'agreements.lastSent': 'Last sent',
  'agreements.nextDelivery': 'Next delivery',
  'agreements.net': 'Net',
  'agreements.amount': 'Amount',
  'agreements.total': 'Total',
  'agreements.status': 'Status',
  'agreements.status.active': 'Active',
  'agreements.status.paused': 'Paused',
  'agreements.status.ended': 'Ended',
  'agreements.status.failed': 'Failed',
  'agreements.pause': 'Pause',
  'agreements.resume': 'Resume',
  'agreements.interval': 'Interval',
  'agreements.interval.weekly': 'Weekly',
  'agreements.interval.fourteen_days': 'Every 14 days',
  'agreements.interval.monthly': 'Monthly',
  'agreements.interval.quarterly': 'Quarterly',
  'agreements.interval.semiannual': 'Semi-annually',
  'agreements.interval.annual': 'Annually',
  'agreements.paymentTerms': 'Payment terms',
  'agreements.days': '{count} days',
  'agreements.units': 'pcs.',
  'agreements.invoiceLine': 'Invoice line',
  'agreements.deliveries': 'Deliveries',
  'agreements.noDeliveries': 'No automatic deliveries yet.',
  'agreements.invoice': 'Invoice',
  'agreements.sent': 'Sent',
  'agreements.processing': 'Processing',
  'agreements.emptyTitle': 'No recurring invoices',
  'agreements.emptyText': 'Enable Recurring when creating an invoice. The series will appear here and can be paused at any time.',
  'agreements.autoSend': 'Automatic delivery',
  'agreements.autoSendHelp': 'Plumme creates and sends the invoice on the next invoice date. It can be paused under Agreements.',
  'agreements.newRecurring': 'New recurring',
  'agreements.newRecurringTitle': 'New recurring invoice',
  'agreements.searchRecurring': 'Search by customer, agreement or amount...',
  'agreements.sortBy': 'Sort by {column}',
  'rep.help': 'Help',
  'rep.excel': 'Excel',
  'rep.allAccountsSub': 'All accounts in the chart of accounts for the selected period.',
  'rep.openingChangeClosing': 'Opening / Change / Closing',
  'rep.balanceModeHelp': 'Choose which balance is shown. Opening is the balance at the start of the period, Change is the movement during the period, and Closing is the balance at the end. Closing = opening + change.',
  'rep.groupsHelp': 'The accounts are split into groups by their first digit: assets (1xxx), equity and liabilities (2xxx), income (3xxx) and costs (4xxx-7xxx). Tap to hide or show a group.',
  'rep.displayHelp': 'Show account toggles the account number in front of each line on or off. Show as chooses whether amounts appear in kroner and øre, whole kroner or whole thousands.',
  'rep.showAccount': 'Show account',
  'rep.showAs': 'Show as',
  'rep.operatingIncomeHelp': 'The total the business has earned from ordinary operations in the selected period.',
  'rep.operatingCostHelp': 'The total cost of running the business in the selected period.',
  'rep.resultHelp': 'Operating income minus operating costs and financial items. A positive figure is a profit, a negative one is a loss.',
  'rep.groupHelp': 'A main group in the income statement. Tap to open or close the group and see the accounts behind the total.',
  'rep.noLedgerLines': 'No ledger lines available from the backend.',

  // ------------------ Onboarding, bank modals, search, help mode
  'bwf.fixPostedEntry': 'Correct posting',
  'bwf.createsDiscrepancy': 'Creates a discrepancy',
  'bwf.entry': 'Entry',
  'bwf.whatToDo': 'What do you want to do?',
  'bwf.correctPostedAmount': 'Correct posted amount',
  'bwf.correctDate': 'Correct date',
  'bwf.postedEntry': 'Posted entry',
  'bwf.matched': 'Matched',
  'bwf.plummaLinks': 'SuperPlumma is linking',
  'bwf.searchInbox': 'Search receipt or amount…',
  'bwf.clickForPreview': 'Click for a preview, or drag the voucher onto a bank line',
  'bwf.tapToPick': 'Tap to select the voucher, then tap the bank line',
  'bwf.tapHint': 'Tap a voucher · then pick the bank line it belongs to',
  'bwf.pickedVoucher': 'Selected voucher',
  'bwf.pickTapLine': 'Tap the bank line this voucher belongs to.',
  'bwf.cancelPick': 'Cancel',
  'bwf.pickChooseLine': 'Choose the bank line this voucher belongs to',
  'bwf.possibleMatch': 'Possible match',
  'bwf.previewVoucher': 'Preview voucher',
  'bwf.annulEntry': 'Annul the entry',
  'bwf.correctEntry': 'Correct posting',
  'bwf.account': 'Account',
  'bwf.missing': 'missing',
  'bwf.searchAccount': 'Search accounts …',
  'bwf.noAccountHits': 'No matches',
  'bwf.selectedLines': 'lines selected',
  'bwf.selectedLinesHelp': 'Choose what to do with the selected lines.',
  'bwf.clearSelection': 'Clear selection',
  'bwf.bulkProcessing': 'Processing line {{index}} of {{total}}',
  'bwf.andNext': 'and next',
  'bwf.andLast': 'last',
  'bwf.openInbox': 'Open the inbox',
  'bwf.drawerHint': 'Tap a voucher and then the bank line — or drag it out onto the line.',
  'bwf.selectLine': 'Select bank line',
  'bwf.selectLineHelp': 'Select bank lines to handle several at once. Shift-click selects a range. The colour still shows the line status.',
  'onb.getStartedTitle': 'Get started with Plumme',
  'onb.getStarted': 'Get started',
  'onb.whatCreate': 'What would you like to create?',
  'onb.whatCreateHelp': 'Choose what to set up now. You can always add more later.',
  'onb.registerCompany': 'Register a company for invoicing, bookkeeping and VAT.',
  'onb.backendComing': 'A dedicated backend model is needed before this can be enabled.',
  'onb.createPersonal': 'Create your personal finances',
  'onb.createPersonalHelp': 'This creates a separate personal finance user, which you find from My page and the user switcher.',
  'onb.welcome': 'Welcome',
  'onb.letsSetUp': 'Let us set up your business',
  'onb.tellUsAbout': 'Tell us about the business',
  'onb.signedIn': 'Signed in',
  'onb.sweden': 'Sweden',
  'onb.denmark': 'Denmark',
  'onb.companyNamePh': 'E.g. Joda Consulting Ltd',
  'onb.nineDigits': '9 digits',
  'onb.resetAndSearch': 'Clear and search again',
  'onb.checkingExisting': 'Checking whether the business already exists in Plumme...',
  'onb.searchingRegistry': 'Searching the Brønnøysund register...',
  'onb.companyForm': 'Company form',
  'onb.searchingAddress': 'Searching for an address...',
  'onb.oslo': 'Oslo',
  'onb.whichPages': 'Which pages do you want to use?',
  'onb.menuNotLoaded': 'The side menu has not loaded yet. All standard pages will be visible.',
  'onb.bankLater': 'Bank connection comes later',
  'onb.connectWith': 'Connect with',
  'onb.noBankData': 'Bank connection is not active yet. You can upload bank statements manually whenever you like.',
  'onb.allSet': 'All set',
  'onb.allSetHelp': 'The business has been created in the backend, added to your businesses and selected as the active one.',
  'onb.goToPlumme': 'Go to Plumme',
  'air.sub': 'View, compare, print and download monthly and annual reports for the business',
  'air.help': 'Here you create monthly and annual reports for the business. Choose a period and optionally a year to compare with, and the key figures, the chart and the cost table update automatically. You can print the report or download it as a PDF.',
  'air.downloadPdf': 'Download PDF',
  'air.chooseWhatToShow': 'Choose what the report shows',
  'air.chooseHelp': '"View" switches between one month and the whole year. "Year" chooses which year you are looking at. "Compare with" places an earlier year alongside, so all figures also show the change against the same period that year.',
  'air.keyFigures': 'Key figures for the period',
  'air.keyFiguresHelp': 'The four most important figures for the selected period: income, costs, result (income minus costs) and profit margin (result as a percentage of income). If comparison is on, the arrow and the text under each figure show the change against the previous year.',
  'air.profitMargin': 'Profit margin',
  'air.chartHelp': 'The bar chart shows income (green) and costs (purple) for each month of the year, so you can quickly see seasonal swings and months where costs approach income. In monthly view the selected month is highlighted.',
  'air.costsByCategory': 'Costs by category',
  'air.costsByCategoryHelp': 'The table breaks the total costs down by category — payroll, rent, marketing and so on. If comparison is on, you see last year\'s figures and the change in percent, where red means higher costs and green means lower.',
  'air.costCategory': 'Cost category',
  'pdf.cannotShow': 'Cannot display the PDF here',
  'pdf.browserBlocked': 'The browser blocked the display.',
  'pdf.rotate': 'Rotate',
  'tf.subsistenceQuestion': 'Should a subsistence allowance be calculated for this trip?',
  'tf.accommodationQuestion': 'Did you stay overnight on this trip?',
  'tf.pickEmployee': 'Choose employee',
  'tf.timeFrom': 'Time from',
  'tf.timeTo': 'Time to',
  'tf.mealsCovered': 'Which meals were covered by others?',
  'hh.household': 'Household',
  'hh.help': 'Link two separate Personal finance accounts. Your own accounts and transactions stay private; only the details stored under Family are shared.',
  'hh.privacyNote': 'Private accounts, transactions, tax and personal plans are not shared automatically.',
  'hh.partnerEmail': 'Partner\'s email',
  'hh.partnerEmailPh': 'partner@example.com',
  'hh.invitesForYou': 'Invitations for you',
  'hh.wantsToLink': 'wants to link the Personal finance accounts as a household',
  'hh.decline': 'Decline',
  'hh.accept': 'Accept',
  'hh.pendingInvites': 'Pending invitations',
  'hh.awaitingReply': 'Awaiting a reply',
  'srch.placeholder': 'Search customers, invoices, products, vouchers, projects …',
  'srch.esc': 'esc',
  'srch.recent': 'Recent searches',
  'srch.noMatches': 'No matches for “{query}”.',
  'srch.tryPageName': 'Try a name, number, amount, page name or help topic.',
  'srch.group.customers': 'Customers', 'srch.group.suppliers': 'Suppliers', 'srch.group.products': 'Products',
  'srch.group.sales': 'Sales and invoices', 'srch.group.vouchers': 'Purchases and vouchers', 'srch.group.documents': 'Documents and inbox',
  'srch.group.projects': 'Projects and time', 'srch.group.other': 'Other accounting records',
  'srch.tag.customer': 'Customer', 'srch.tag.supplier': 'Supplier', 'srch.tag.product': 'Product', 'srch.tag.invoice': 'Sales document',
  'srch.tag.expense': 'Purchase', 'srch.tag.other-sale': 'Other sale', 'srch.tag.receipt': 'Inbox', 'srch.tag.project': 'Project',
  'srch.tag.activity': 'Activity', 'srch.tag.mileage': 'Mileage', 'srch.tag.agreement': 'Agreement', 'srch.tag.company-document': 'Document',
  'srch.tag.bank-statement': 'Bank statement',
  'srch.recentDefaults': 'invoice|payroll|VAT',
  'srch.group.shortcuts': 'Shortcuts',
  'srch.nav.sub': 'Page in Plumme',
  'srch.help.sub': 'Help article',
  'srch.hint.browse': 'browse', 'srch.hint.open': 'open', 'srch.hint.close': 'close',
  'srch.countShown': '{count} results shown',
  'srch.fallback.trip': 'Trip',
  'srch.kind.offer': 'Offer', 'srch.kind.invoice': 'Invoice', 'srch.kind.invoiceDraft': 'Invoice draft',
  'srch.kind.orderConfirmation': 'Order confirmation', 'srch.kind.sale': 'Sale', 'srch.kind.customerList': 'Customer list',
  'hlp.explainMode': 'Explain this to me – tap, then tap whatever you are wondering about (shortcut: ? or Ctrl+I)',
  'hlp.helpModeOn': 'Help mode is on.',
  'hlp.tapWhatever': 'Tap whatever you are wondering about, and we will explain it.',
  'hlp.shortcutHint': 'Press ? or Ctrl+I to toggle.',
  'hlp.exit': 'Exit',

  // ------------------------------------------ Data tab in settings
  'sd.deleteAllCustomers': 'Delete all customers',
  'sd.deleteAllSuppliers': 'Delete all suppliers',
  'sd.deleteAllProducts': 'Delete all products',
  'sd.exportLedger': 'Export ledger',
  'sd.importLedger': 'Import ledger',
  'sd.exportDetails': 'Export details',
  'sd.importDetails': 'Import details',
  'sd.exportVouchers': 'Export vouchers',
  'sd.importVouchers': 'Import vouchers',
  'sd.deleteBusinessHelp': 'Delete business removes the selected business after 30 days via the backend. This is a serious action.',
  'sd.permissionsHelp': 'Only the owner or an admin can reset data and clear registers. Only the owner can delete the business.',

  // -------------------------------------------- Help articles (h6, h12, h13)
  'ha.h6.title': 'How to file the VAT return',
  'ha.cat.vat': 'VAT and duties',
  'ha.read3': '3 min read',
  'ha.h6.lead': 'The VAT return shows how much VAT the business has collected on sales and paid on purchases in a period. Plumme calculates the figures automatically from posted vouchers — you check them and file the return with Skatteetaten. Here is how.',
  'ha.h6.before': 'Before you start',
  'ha.h6.beforeText': 'Make sure every purchase and sale in the period is posted, and that the Inbox is empty. The figures in the return come straight from the accounts, so anything not posted will not appear on the return either.',
  'ha.h6.reminded': 'You are reminded in good time',
  'ha.h6.remindedText': 'Plumme reminds you of the deadline automatically. You always find the next deadline on the home page and under Filings.',
  'ha.h6.openPeriod': 'Open the right period',
  'ha.h6.openPeriodText': 'Go to Filings → VAT return. The periods that need action are at the top. Press "Open return" on the period you are filing.',
  'ha.h6.fig1': 'The period overview. "Period 3 2026" needs action and is due 31 August.',
  'ha.h6.check': 'Check the calculation',
  'ha.h6.checkText': 'At the top you see output VAT (what you have collected on sales) minus input VAT (what you have paid on purchases). The difference is either payable or refundable. In this example NOK 49,834 is refundable.',
  'ha.h6.fig2': 'Output minus input VAT gives the amount you pay or get back.',
  'ha.h6.codes': 'Go through the code overview',
  'ha.h6.codesText': 'The code overview shows how the basis is distributed across the different VAT codes — sales, purchases and imports. Tap a code to see which vouchers lie behind the figure. If everything is right, press "Check the figures".',
  'ha.h6.fig3': 'Each line shows the basis, rate and VAT per code. Tap a code to see the vouchers behind it.',
  'ha.h6.deviation': 'Check discrepancies before you file',
  'ha.h6.deviationText': 'If you get an amount you do not recognise, go through the bookkeeping before filing. It is easier to correct before the return is sent than afterwards.',
  'ha.h6.send': 'File the return with Skatteetaten',
  'ha.h6.sendText': 'Plumme cannot send the VAT return to Skatteetaten. Enter the figures from Plumme and file the return in the Skatteetaten service, and keep the receipt. Then go back to the period in Plumme and press "Mark as filed outside Plumme". Enter the date you filed and preferably the reference from the receipt. The vouchers in the period are then locked, and the period counts as filed in the year-end closing.',
  'ha.h6.after': 'After filing',
  'ha.h6.afterText': 'If you owe money, the KID and account number are on the receipt from Skatteetaten. Once the period is marked as filed outside Plumme and the amount is paid or refunded, record the settlement on the period with "Register payment" or "Register refund", so the accounts match the tax account.',
  'ha.h12.title': 'How to create an invoice',
  'ha.cat.sales': 'Sales and invoicing',
  'ha.h12.lead': 'With New sale you create an invoice for a customer in a few steps. You choose the customer, fill in the lines, and see a live preview before you create and send it. The sale is posted automatically.',
  'ha.h12.beforeText': 'It helps to have the customer and products saved beforehand, but you can also enter both the recipient and the lines as free text as you go. Everything can be changed before you create the invoice.',
  'ha.h12.open': 'Open New sale and choose invoice',
  'ha.h12.openText': 'Go to New sale in the menu. At the top you choose the document type — choose "Invoice". You can also create a quote or an order confirmation from here.',
  'ha.h12.quoteOrder': 'Quotes and order confirmations',
  'ha.h12.quoteOrderText': 'The same approach applies to quotes and order confirmations — just choose the right type in the "New invoice" menu at the top, and the steps and fields are the same. "Other sale" is slightly different: there you upload a receipt as documentation instead of choosing a customer.',
  'ha.h12.customerText': 'In the "Customer" step you search for a saved customer, list or subscription — or press "New customer" to enter a recipient that is not saved. The name and address are pulled onto the document automatically.',
  'ha.h12.fig1': 'Step 1 "Customer": search for a saved customer, list or subscription — or create a new recipient.',
  'ha.h12.details': 'Fill in the details',
  'ha.h12.detailsText': 'Under "Details" you set the invoice date and due date, and any references. If you want the invoice sent automatically each period, turn on "Recurring".',
  'ha.h12.fig2': 'Step 2 "Details": invoice date, due date and references. Turn on "Recurring" for automatic sending.',
  'ha.h12.lines': 'Add lines',
  'ha.h12.linesText': 'In the "Lines" step you add what you are selling. Choose a saved product or write free text, and enter the quantity, price and VAT rate. The line total is calculated automatically.',
  'ha.h12.fig3': 'Step 3 "Lines": each line has a quantity, price and VAT rate. The line and grand totals are calculated for you.',
  'ha.h12.livePreview': 'Live preview',
  'ha.h12.livePreviewText': 'Next to the form you see at all times how the finished document will look to the customer. Use "Switch to all on one page" if you would rather see all the fields at once.',
  'ha.h12.preview': 'Preview and create',
  'ha.h12.previewText': 'In "Preview" you check the sender, customer details, lines and total. If everything is right, you create the invoice — and can email it to the customer or download it as a PDF.',
  'ha.h12.fig4': 'Step 4 "Preview": check the document and the total before you create the invoice.',
  'ha.h12.afterText': 'Once the invoice is created, the sale is posted to the right account automatically, and you find it again in the invoice list with its status and due date.',
  'ha.h13.title': 'Registering an other sale',
  'ha.read2': '2 min read',
  'ha.h13.lead': 'Other sale is for sales that do not need an ordinary invoice — such as cash sales, withdrawals, or sales made outside Plumme. You choose "Other sale" in New sale, upload a receipt as documentation, fill in the amount and VAT, and choose where the money came in. The sale is posted automatically.',
  'ha.h13.when': 'When do you use other sale?',
  'ha.h13.whenText': 'Use other sale when you are not sending an invoice to a customer — for example a cash sale, a private withdrawal of goods, or a sale already made outside the system that just needs posting. If the customer is to be invoiced, create an invoice instead.',
  'ha.h13.choose': 'Choose Other sale',
  'ha.h13.chooseText': 'Go to New sale and choose "Other sale" in the document type menu at the top. The flow then gets its own "Receipt" step first.',
  'ha.h13.receiptText': 'In the "Receipt" step you upload an image or a PDF as documentation of the sale — for example a till slip or a sales note.',
  'ha.h13.details': 'Fill in the details and "Paid to"',
  'ha.h13.detailsText': 'Under "Details" you set the date and choose "Paid to" — where the money came in: Operating account, Cash or Private. The choice controls which account the sale is posted against (bank, cash or private withdrawal).',
  'ha.h13.fig1': 'In "Details" you choose "Paid to" — Operating account, Cash or Private. That decides which account the sale is posted against.',
  'ha.h13.linesText': 'In "Lines" you add what you sold, with quantity, price and VAT rate. The total and VAT are calculated automatically.',
  'ha.h13.fig2': 'Add sales lines with the amount and VAT rate. The total is calculated for you.',
  'ha.h13.register': 'Register the sale',
  'ha.h13.registerText': 'Check the summary and press "Register sale". The sale is posted, and the receipt is archived under Transactions.',
  'ha.h13.invoiceOrOther': 'Invoice or other sale?',
  'ha.h13.invoiceOrOtherText': 'If you need to claim payment from a customer, create an invoice (New sale → Invoice). Other sale is for sales that are already settled or do not need a payment demand.',

  // -------------------------------------------- Help articles (h1, h2, h4)
  'ha.h1.title': 'Creating a recurring invoice',
  'ha.h1.lead': 'A recurring invoice is sent automatically at regular intervals — perfect for subscriptions and fixed services. You set it up once, and Plumme does the rest.',
  'ha.h1.start': 'Start a new invoice',
  'ha.h1.startText': 'Go to New sale and fill in the customer and invoice lines as usual.',
  'ha.h1.turnOn': 'Turn on "Recurring"',
  'ha.h1.turnOnText': 'Under Details you switch on "Recurring". Choose how often the invoice should be sent (weekly, every 14 days, monthly, quarterly or yearly) and when it falls due.',
  'ha.h1.fig1': 'Turn on "Recurring" in the Details step. Then you choose "Sent every" (the interval) and "Due".',
  'ha.h1.autoText': 'Plumme creates a new invoice and emails it automatically each period. Under Agreements → Recurring you see when the next invoice is sent, and can pause and resume it.',
  'ha.h1.control': 'Pause in time',
  'ha.h1.controlText': 'The invoice is sent without notice in advance. If something has changed, pause it under Agreements → Recurring before the invoice date. The customer must have an email address, otherwise no invoice is sent.',
  'ha.h2.title': 'The payment does not match the invoice',
  'ha.h2.lead': 'When an amount received differs from the invoice amount, you register the amount that actually came in — and Plumme keeps track of what remains.',
  'ha.h2.open': 'Open the invoice',
  'ha.h2.openText': 'Find the invoice in the invoice list and open it. Under "Payment status" you see whether it is paid, partly paid or unpaid.',
  'ha.h2.fig1': '"Payment status" on the invoice: what has been paid, what remains, and the "Register payment" button.',
  'ha.h2.registerText': 'Press "Register payment" and enter the amount that has come in. If the amount is less than the invoice, it stays as "Partly paid", and the remaining amount is shown.',
  'ha.h2.fig2': 'In "Register payment" you enter the amount received. The remainder is shown, and "Settled without payment" closes the rest without a payment.',
  'ha.h2.handle': 'Handling what remains',
  'ha.h2.handleText': 'If the rest arrives later, you register another payment then. To close the invoice without the rest being paid, choose "Settled without payment". A registered payment can be reversed, and the whole payment can be cleared if you posted it wrongly.',
  'ha.h2.autoStatus': 'The status is calculated automatically',
  'ha.h2.autoStatusText': 'Paid / partly paid / unpaid is calculated from the registered payments against the invoice amount — you do not need to set the status yourself.',
  'ha.cat.payroll': 'Payroll and employees',

  // -------------------------------------------- Help articles (h5, h7, h8)
  'ha.cat.purchase': 'Purchases and vouchers',
  'ha.cat.bank': 'Bank and payments',

  // -------------------------------------------- Help articles (h9, h10, h11)
  'ha.cat.assets': 'Fixed assets',
  'ha.cat.budget': 'Budget',
  'ha.cat.closing': 'Year-end closing',
  'ha.h9.title': 'Registering an asset and its depreciation',
  'ha.h9.lead': 'Larger things the business buys and uses over several years — a computer, a vehicle or machinery — are recorded as fixed assets. Instead of being expensed at once, they are depreciated a little each year. Plumme keeps track of the depreciation for you.',
  'ha.h9.whenAsset': 'When is something a fixed asset?',
  'ha.h9.whenAssetText': 'A purchase normally requires depreciation when one fixed asset costs at least NOK 30,000 and has an expected useful life of at least three years. The threshold is assessed per asset, not from the invoice total alone.',
  'ha.h9.limit': 'The NOK 30,000 threshold',
  'ha.h9.limitText': 'If an individual fixed asset costs less than NOK 30,000, its cost can normally be expensed in the acquisition year. Physically or functionally integrated components may need to be assessed together.',
  'ha.h9.register': 'Register the asset',
  'ha.h9.registerText': 'Go to Purchases → Fixed assets and press "New asset" — or register it straight from the purchase. Give it a name and enter the cost price and acquisition date.',
  'ha.h9.group': 'Choose a balance group',
  'ha.h9.groupText': 'Choose which group the asset belongs to (for example group a for computer equipment, c for vans, d for machinery and fixtures). The group determines the depreciation rate.',
  'ha.h9.depreciate': 'Let Plumme depreciate',
  'ha.h9.depreciateText': 'Each year the depreciation is calculated automatically as a fixed percentage of the remaining value (the declining balance method). You see the book value and the accumulated depreciation in the asset register.',
  'ha.h9.sell': 'When you sell or dispose of the asset',
  'ha.h9.sellText': 'If you sell the asset, you register the sales amount on it. A gain or loss against the book value is handled automatically — where relevant via a gain and loss account that spreads the amount over several years.',
  'ha.h10.title': 'Making a budget for the year',
  'ha.h10.lead': 'A budget is a plan for your income and costs through the year. Once you have entered it, Plumme compares the budget against the actual figures continuously, so you can see whether you are on track.',
  'ha.h10.method': 'Choose a method',
  'ha.h10.methodText': 'Go to Budget and choose how you want to start: with "Manual" you enter everything yourself, with "Suggestion" you answer a few simple questions, and with "AI suggestion" you describe the business in your own words and Plumme creates a draft.',
  'ha.h10.amounts': 'Enter income and costs',
  'ha.h10.amountsText': 'Under "Budget by category" you add an income or cost category with an annual amount. The amount is spread across the months, which you can adjust if activity varies through the year.',
  'ha.h10.variance': 'Follow up variances',
  'ha.h10.varianceText': 'In "Analysis" and "Overview" you see the budget against the actual result, month by month. The variance shows whether you are above or below plan, and which account deviates the most.',
  'ha.h10.startSimple': 'Start simple',
  'ha.h10.startSimpleText': 'You do not have to budget everything. Begin with the largest income and costs — you can always add more categories later.',
  'ha.h11.title': 'Closing the financial year',
  'ha.h11.lead': 'The year-end closing closes the financial year. You check that everything is posted correctly, lock the year, and then prepare the tax return and the annual accounts. Plumme guides you through each step.',
  'ha.h11.before': 'Before you close',
  'ha.h11.beforeText': 'Make sure every voucher is posted, the Inbox is empty, and the VAT periods have been filed. The more that is in place, the smoother the closing goes.',
  'ha.h11.checklist': 'Go through the checklist',
  'ha.h11.checklistText': 'Choose "Go through the checklist". Plumme checks items such as bank reconciliation, VAT, payroll and fixed assets. Items that need action must be resolved before the year can be closed.',
  'ha.h11.closeYear': 'Close the year',
  'ha.h11.closeYearText': 'When everything is checked, you close the financial year. The year is locked for changes — but you can always reopen it if something needs correcting.',
  'ha.h11.taxReturn': 'Prepare the tax return',
  'ha.h11.taxReturnText': 'Plumme creates a draft tax return from the accounts. Go through the draft and check the figures. You file the tax return itself with Skatteetaten, outside Plumme, and mark it as filed here.',
  'ha.h11.annualAccounts': 'Prepare the annual accounts',
  'ha.h11.annualAccountsText': 'Finally the annual accounts are drawn up from the figures, and the documents are signed. You file the annual accounts with the Register of Company Accounts in Altinn, outside Plumme (applies to businesses with a filing obligation).',
  'ha.h11.reconciled': 'Bank-reconciled periods',
  'ha.h11.reconciledText': 'Vouchers in a bank-reconciled period cannot be changed without reopening the period. That keeps the reconciliation correct.',

  // -------------------------------------------- Help articles: frame and rest
  'ha.h1.save': 'Save',
  'ha.h2.register': 'Register the payment',
  'ha.h12.customer': 'Choose the customer',
  'ha.h13.receipt': 'Upload a receipt',
  'ha.eyebrow': 'Help · {category}',
  'ha.readOn': 'Help · read on',
  'ha.backToSearch': 'Back to search',
  'ha.goTo': 'Go to {page}',
  'ha.openedInBackground': 'Opened {page} in the background',
  'ha.reopen': 'Open the help article again',
  'ha.closeArticle': 'Close help article',
  'ha.expandImage': 'Open image full size',
  'ha.collapseImage': 'Close full-size image',
  'ha.minimize': 'Put away',
  'ha.minimizeHelp': 'Put away — pick it up again later',
  'ha.dragWidth': 'Drag to change the width',
  'ha.changeWidth': 'Change width',

  // ------------------------------------------------------------ preferences
  // --------------------------------------------------- errors from the server
  // The key is the domain code functions/ sends in the HttpsError details,
  // looked up as t('err.' + domainCode, serverMessage).
  'err.auth.required': 'You must sign in first.',
  'err.auth.emailNotVerified': 'Confirm your email address first. We have sent you a link — open it, then try again.',
  'err.auth.sessionRevoked': 'Your session has ended. Sign in again.',
  'err.invoice.publicLinkExpired': 'This link has expired. Ask the sender to send the document again.',
  'err.business.alreadyVerified': 'This business is already registered in Plumme. Ask the owner to invite you.',
  'err.business.idPortenRequired': 'Sign in with ID-porten to verify this business.',
  'err.business.notAnAltinnActor': 'You are not registered as an actor for this business in Altinn.',
  'err.business.altinnUnavailable': 'Could not look up your Altinn roles right now. Try again later.',
  'err.email.invalid': 'Enter a valid email address.',
  'err.pf.notCreated': 'Create Personal finance before you link a household.',
  'err.pf.noAccess': 'You do not have access to this Personal finance client.',
  'err.household.alreadyLinked': 'You are already linked to a household.',
  'err.household.notLinked': 'You are not linked to a household.',
  'err.household.selfInvite': 'You cannot invite yourself.',
  'err.household.selfLink': 'You cannot link to yourself.',
  'err.household.invitePending': 'There is already a pending invitation to this email address.',
  'err.household.invalidResponse': 'Invalid response to the invitation.',
  'err.household.inviteNotFound': 'The invitation does not exist.',
  'err.household.inviteOtherEmail': 'The invitation belongs to a different email address.',
  'err.household.inviteInactive': 'The invitation is no longer active.',
  'err.household.someoneLinked': 'One of the users is already linked to a household.',
  'err.household.cannotWithdraw': 'You cannot withdraw this invitation.',
  'err.business.missing': 'No active business selected.',
  'err.business.notFound': 'The business does not exist.',
  'err.business.dataNotFound': 'The business data does not exist.',
  'err.import.noAccess': 'You do not have access to import accounts for this business.',
  'err.import.jobMissing': 'The import job is missing.',
  'err.import.jobNotFound': 'The import job does not exist.',
  'err.import.packageMissingFile': 'The stored import has no file reference. Upload the files again.',
  'err.import.packageAlreadyCommitted': 'The same import file set has already been imported. Delete the duplicate from the stored import packages list.',
  'err.import.packageActive': 'This is the active import package and cannot be deleted. Delete an older package instead.',
  'err.advisor.insightIncomplete': 'The AI advice was truncated before it finished. Please try again shortly.',
  'err.advisor.insightUnavailable': 'SuperPlumma could not produce safe advice from this evidence right now.',
  'err.advisor.insightEmpty': 'SuperPlumma did not produce completed advice. Please try again shortly.',
  'err.import.notAnalyzed': 'The import job must be analysed before it can be approved.',
  'err.import.noProposal': 'The import job has no opening balance proposal.',
  'err.pf.clientMissing': 'No Personal finance client selected.',
  'err.pf.clientNotFound': 'The Personal finance client does not exist.',
  'err.pf.notPersonalClient': 'This client is not a Personal finance client.',
  'err.pf.noValidFields': 'No valid Personal finance fields to save.',
  'err.tx.pickAtLeastOne': 'Select at least one transaction.',
  'err.tx.maxBatch': 'You can move at most 200 transactions at a time.',
  'err.tx.pickCategory': 'Select a category.',
  'err.tx.notFound': 'One or more transactions do not exist.',
  'err.tx.otherClient': 'The transaction does not belong to this client.',
  'err.statement.missing': 'The bank statement is missing.',
  'err.statement.notFound': 'The bank statement does not exist.',
  'err.account.pickOrCreate': 'Select or create an account.',
  'err.account.missing': 'The account is missing.',
  'err.account.notFound': 'The account does not exist.',
  'err.account.hasTransactions': 'The account has imported transactions. Delete the bank statement first.',
  'err.asset.missing': 'The asset is missing.',
  'err.asset.notFound': 'The asset does not exist.',
  'err.loan.missing': 'The loan is missing.',
  'err.loan.notFound': 'The loan does not exist.',
  'err.assistant.emptyQuestion': 'Write a question first.',
  'err.assistant.tooLong': 'The message is too long.',
  'err.assistant.conversationLimit': 'The conversation has reached its limit. Start a new conversation to continue.',
  'err.idporten.expired': 'The ID-porten token is missing or has expired. Sign in with ID-porten again.',

  'pref.title': 'Preferences',
  'pref.sub': 'Adjust notifications, language, theme and default workflow.',
  'pref.deadlineMail': 'Email reminders for deadlines',
  'pref.deadlineMailSub': 'Get an email 7 days before VAT deadlines and 30 days before the tax return, annual accounts and shareholder register return. Applies to Norwegian businesses where you are owner or admin.',
  'pref.deadlineMailNotManager': 'You are not an owner or admin of this business, so you will not get deadline reminders for it.',
  'pref.language': 'Language',
  'pref.languageSub': 'Your language across businesses. Other users keep their language. Accounting rules and currency follow the business country.',
  'pref.mascots': 'Mascot images',
  'pref.mascotsSub': 'Show SuperPlumma and the other mascots in the app.',
  'pref.theme': 'Theme',
  'pref.theme.light': 'Light',
  'pref.theme.dark': 'Dark',
  'pref.saved': 'Preferences saved',
  'set.transitionImport.title': 'Import transition file',
  'set.transitionImport.help': 'Use SAF-T XML, Excel or CSV with an account and either debit/credit or a signed balance. The file is treated as start-up figures or an opening balance, not as complete history.',
  'set.transitionImport.choose': 'Choose file',
  'set.transitionImport.readError': 'Could not read the transition file.',
  'set.transitionImport.summaryBalance': 'Read {accounts} accounts and {balanceLines} balance lines. Check the figures before saving.',
  'set.transitionImport.summaryStartup': 'Read {accounts} accounts: {salesLines} income lines, {costLines} expense lines, output VAT {outgoingVat} and input VAT {incomingVat}. Check the figures before saving.',
  'set.transitionImport.includeVat': 'Include the VAT amounts in a VAT return in Plumme',
  'set.transitionImport.includeVatHelp': 'Enable this only if the amounts were not already reported from the previous system. Otherwise VAT will be counted twice.',
  'set.transitionImport.vatPeriod': 'VAT period that should receive the start-up figures',
  'set.transitionImport.chooseVatPeriod': 'Choose period',
  'set.transitionImport.chooseVatPeriodError': 'Choose which VAT period should include the start-up figures.',
  'set.transitionImport.vatFootnote': 'Start-up VAT is stored as transition data. It is only included in a VAT return when you actively choose the period above.',
  'set.transitionImport.useSimple': 'Use simple transition',
  'set.transitionImport.simpleTitle': 'Most businesses should use a simple transition',
  'set.transitionImport.simpleHelp': 'At the start of a financial year, an opening balance is usually enough. When switching mid-year, use start-up figures. Both can be entered manually or imported from SAF-T or a trial balance under Accounting.',
  'set.transitionImport.completeTitle': 'Complete history import is advanced',
  'set.transitionImport.completeRisk': 'Exports from other accounting systems may contain differences, omissions or corrections that cannot be interpreted safely.',
  'set.transitionImport.completeCheck': 'Check opening balances, VAT amounts and filing statuses against the previous system and the authorities’ records.',
  'set.transitionImport.completeKeep': 'Keep the original export and accounting records for the entire statutory retention period.',
  'set.transitionImport.completeAccept': 'I understand that imported information must be checked before I file or correct anything.',
  'set.transitionImport.error.noRows': 'The file does not contain any balance rows.',
  'set.transitionImport.error.noAccount': 'The file must have an account or account number column.',
  'set.transitionImport.error.ambiguousAmount': 'The file must have separate debit and credit columns, or an amount together with a side column.',
  'set.transitionImport.error.notBalanced': 'The opening balance is not balanced. Debit {debit} and credit {credit} must be equal.',
  'set.transitionImport.error.fileType': 'Choose SAF-T XML or a CSV or text trial balance file.',
  'set.transitionImport.warning.noSaftBalances': 'No account balances were found in the SAF-T file.',
  'set.transitionImport.warning.noBalances': 'No balances with amounts were found in the file.',
  'set.transitionImport.lineNote': 'Imported from {source}',
  'set.transitionImport.note': 'Imported from {source}. Check the balances against the previous accounting system.',
  'set.transitionImport.accountName': 'Account {account}',
  'set.transitionImport.sourceTrialBalance': 'trial balance',
  'set.transitionImport.yearMismatch': 'The file is for a transition to {detectedYear}, but the start year is set to {selectedYear}. Change the start year or choose the correct file.',
  'importCompliance.warningTitle': 'Check imported information',
  'importCompliance.warningBody': 'The information was imported from another accounting system. Plumme checks that the data can be read and processed, but cannot confirm that the export is complete, that the figures are correct, or that the filings were received by the authorities. Check the previous accounting system and the authorities’ records if you are unsure.',
  'importCompliance.historicalTitle': 'Historical years will be marked complete',
  'importCompliance.historicalBody': 'For complete years older than last year ({years}), the year-end closing and relevant filings are marked as filed. Imported VAT periods are marked as filed, but not as paid.',
  'importCompliance.previousTitle': 'Confirm the status for {year}',
  'importCompliance.previousHelp': 'We do not assume that last year is complete. Choose “Unsure” if this must be checked; the filing will remain open.',
  'importCompliance.question.yearClosing': 'Is the year-end closing complete?',
  'importCompliance.question.taxReturn': 'Has the tax return been filed?',
  'importCompliance.question.annualAccounts': 'Have the annual accounts been filed?',
  'importCompliance.question.vatReturns': 'Have the VAT returns for the imported periods been filed?',
  'importCompliance.selectStatus': 'Choose status',
  'importCompliance.yes': 'Yes',
  'importCompliance.no': 'No',
  'importCompliance.unknown': 'Unsure – keep open',
  'importCompliance.accept': 'I understand that imported figures and historical filing statuses must be checked against the previous accounting system and the authorities’ records.',
  'importCompliance.noPaymentAssumption': 'VAT payment status is not assumed merely because a period is old.',
  'importCompliance.noticeTitle': 'Imported information for {year}',
  'importCompliance.area.vat': 'The VAT returns',
  'importCompliance.area.tax': 'The tax return',
  'importCompliance.area.annualAccounts': 'The annual accounts',
  'importCompliance.area.yearClosing': 'The year-end closing',
  'importCompliance.statusDelivered': '{area} is marked as {status} based on the import decision.',
  'importCompliance.statusOpen': '{area} remains open.',
  'importCompliance.statusNotApplicable': '{area} is not marked as required for this business type.',
  'importCompliance.statusFiled': 'filed',
  'importCompliance.statusClosed': 'complete',
  'importCompliance.noticeBody': 'Figures and historical statuses were imported from another accounting system. Plumme cannot confirm that the export is complete, that the figures are correct, or that the filing was received by the authorities. Check the previous accounting system and the authorities’ records before making changes or filing again.',
  'importCompliance.understood': 'I understand',
  'importOpen.title': 'Imported subledger',
  'importOpen.items': 'items',
  'importOpen.customerInvoice': 'Invoice',
  'importOpen.supplierInvoice': 'Supplier invoice',
  'importOpen.noDate': 'no date',
  'importOpen.due': 'Due {date}',
  'importOpen.controlBasis': 'imported control basis',
  'importOpen.open': 'Imported open item',
  'importOpen.partial': 'Partly settled',
  'importOpen.settled': 'Settled',
  'importOpen.credit': 'Credit / overpayment',
  'importOpen.registerSettlement': 'Register settlement',
  'importOpen.dialogTitle': 'Settle imported open item',
  'importOpen.amount': 'Settled amount',
  'importOpen.date': 'Settlement date',
  'importOpen.note': 'Note (optional)',
  'importOpen.noPostingNotice': 'The settlement is posted against the selected bank account and imported customer or supplier subledger. It creates no new income, expense, or VAT.',
  'importOpen.settledToast': 'The settlement was registered',
  'importOpen.reopenedToast': 'The imported item was reopened',
  'importOpen.error': 'Could not update the imported item',
  'importOpen.reopen': 'Reopen',
  'importOpen.reopenTitle': 'Reopen imported item',
  'importOpen.reopenWarning': 'The item becomes outstanding again, and the posted settlement is reversed on the selected date.',
  // --------------------------------------------------- projects and timesheet
  'inv.detail.overpaid': 'Overpaid',
  'inv.detail.customerOverpayment': 'Unresolved customer credit',
  'inv.detail.registerExtraPayment': 'Register extra payment',
  'inv.pay.overpaymentNote': 'The payment is {amount} higher than the invoice balance. The full amount will be registered and the excess will remain as unresolved customer credit.',
  'inv.overpayment.refund': 'Refund overpayment',
  'inv.overpayment.allocate': 'Allocate overpayment',
  'inv.overpayment.available': 'Available unallocated overpayment: {amount}.',
  'inv.overpayment.source': 'Overpayment from invoice',
  'inv.overpayment.allocations': 'Overpayment allocations',
  'inv.overpayment.receivedFrom': 'Received from {document}',
  'inv.overpayment.allocatedTo': 'Allocated to {document}',
  'inv.overpayment.refundNote': 'Customer overpayment refund',
  'inv.overpayment.allocationNote': 'Customer overpayment allocated from {source}',
  'inv.overpayment.refunded': 'The overpayment was refunded',
  'inv.overpayment.allocated': 'The overpayment was allocated',
  'inv.overpayment.reverseRefund': 'Reverse refund',
  'inv.overpayment.reverseAllocation': 'Reverse allocation',
  'inv.overpayment.notConnected': 'Overpayment refunds are not connected to the backend.',
  'inv.overpayment.noSource': 'Select an invoice with an available overpayment.',
  'inv.overpayment.refundFailed': 'Could not refund the overpayment.',
  'inv.overpayment.allocationFailed': 'Could not allocate the overpayment.',
  'inv.overpayment.reverseRefundFailed': 'Could not reverse the refund.',
  'inv.overpayment.reverseAllocationFailed': 'Could not reverse the allocation.',
  'sup.overpayment.invalidAmount': 'Enter a valid amount.',
  'sup.overpayment.refunded': 'The refund was registered.',
  'sup.overpayment.allocated': 'The overpayment was allocated.',
  'sup.overpayment.failed': 'Could not process the overpayment.',
  'sup.overpayment.refundTitle': 'Refund supplier overpayment',
  'sup.overpayment.allocateTitle': 'Allocate supplier overpayment',
  'sup.overpayment.refundAction': 'Register refund',
  'sup.overpayment.allocateAction': 'Allocate overpayment',
  'sup.overpayment.source': 'Overpayment from invoice',
  'sup.overpayment.amount': 'Amount',
  'sup.overpayment.date': 'Date',
  'sup.overpayment.bankAccount': 'Bank account',
  'sup.overpayment.reverseRefund': 'Reverse refund',
  'sup.overpayment.refundReversed': 'The refund was reversed.',
  'sup.overpayment.reverseRefundFailed': 'Could not reverse the refund.',
  'sup.overpayment.reverseAllocation': 'Reverse allocation',
  'sup.overpayment.allocationReversed': 'The allocation was reversed.',
  'sup.overpayment.reverseAllocationFailed': 'Could not reverse the allocation.',
  'settlement.linkExisting': 'Link existing posting',
  'settlement.title': 'Link existing posting',
  'settlement.noNewPosting': 'The link updates the subledger. It does not create another general-ledger posting.',
  'settlement.noMatchesTitle': 'No possible matches',
  'settlement.noMatchesText': 'Check that the manual posting credits account 1500 for the selected customer or debits account 2400 for the selected supplier, and that the amount has not already been linked.',
  'settlement.exactMatch': 'Exact amount match',
  'settlement.manualPosting': 'Manual posting',
  'settlement.customerInvoice': 'Customer invoice',
  'settlement.supplierInvoice': 'Supplier invoice',
  'settlement.noDate': 'No date',
  'settlement.canLink': 'Can link: {amount} · Available in posting: {available}',
  'settlement.amount': 'Amount to link',
  'settlement.amountTooHigh': 'The amount exceeds the available amount.',
  'settlement.linkSelected': 'Link selected',
  'settlement.linking': 'Linking…',
  'settlement.linkedOne': 'The posting was linked to the open item.',
  'settlement.linkedMany': '{count} open items were linked.',
  'settlement.cardTitle': 'Open items can be linked',
  'settlement.cardText': 'Choose the invoice and amount yourself. Nothing is settled automatically.',
  'settlement.linkPosting': 'Link {voucher}',
  'settlement.linkFailed': 'Could not link the posting.',
  'settlement.voucherNotFound': 'The posting to link could not be found.',
  'settlement.actionHelp': 'Links an unused amount from a manual posting to an open customer or supplier item without creating another general-ledger posting.',
  'accounting.importedStatisticsTitle': 'Imported accounting statistics',
  'accounting.importedStatisticsReconciliation': 'The balances come from validated imported account statistics, not journal entries in Plumme. Reconciliation may be reviewed, but certification and closing remain blocked.',
});

window.PlummeI18n.register("en", {"nav.kjopsoversikt": "Purchase list", "route.kjopsoversikt": "Purchase list"});
